const Cookies = {
	setCookie: function(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	},

	getCookie: function(cname) {
	  let name = cname + "=";
	  let ca = document.cookie.split(';');
	  for(let i = 0; i < ca.length; i++) {
	    let c = ca[i];
	    while (c.charAt(0) == ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) == 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return "";
	}
};
const Money = {
	getVat: function() {
		let vatStatus = Cookies.getCookie('vat');
		if(!vatStatus) {
			Cookies.setCookie('vat', 'exc', 300);
			vatStatus = 'exc'
		}

		return vatStatus;
	},

	getCurrency: function() {
		let currency = Cookies.getCookie('curr');
		if(!currency) {
			Cookies.setCookie('curr', 'GBP', 300);
			currency = 'GBP'
		}

		return currency;
	}

	// updateMoney: function() {
	// 	let currency = Cookies.getCookie('curr');
	// 	if(!currency) {
	// 		Cookies.setCookie('curr', 'GBP', 300);
	// 		currency = 'GBP'
	// 	}

	// 	return currency;
	// }
};
function fadeOut(el) {
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= .1) < 0) {
            el.style.display = "none";
        } else {
            requestAnimationFrame(fade);
        }
    })();
};

function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += .2) > 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
};

function makeRequest(method, url) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                resolve(null);
            }
        };
        xhr.onerror = function () {
            resolve(null);
        };
        xhr.send();
    });
}

function makePostRequest(url, data) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                console.log({
                    status: this.status,
                    statusText: xhr.statusText
                })
                resolve(null);
            }
        };
        xhr.onerror = function () {
            console.log({
                status: this.status,
                statusText: xhr.statusText
            })
            resolve(null);
        };
        xhr.send(JSON.stringify(data));
    });
}

function getClosest(elem, selector) {

    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    for ( ; elem && elem !== document; elem = elem.parentNode ) {
        if ( elem.matches( selector ) ) return elem;
    }
    return null;
};

function capitalizeWords(sentence) {
    const words = sentence.split(" ");

    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(" ");
}

function showModal(error, text) {
    const toast = document.querySelector('#toast');
    toast.innerHTML = text;
    error ? toast.setAttribute('data-error', 'true') : toast.setAttribute('data-error', 'false');
    toast.classList.add('toast--show');
    setTimeout(function() { toast.classList.remove('toast--show') }, 3000);
}

function htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

;
var FinanceUtils = {
  updateForm: function(yrs) {
    if(document.querySelector('#product-finance')) {
      document.querySelector('#product-finance').querySelector('#years').value = yrs;
    }
  },

  getPriceBreakdown: function(amount, yearChoice=5) {
    var financeAmount = amount;
    var year = [1, 1, 0.0522, 0.0355, 0.0289, 0.0235];
    var mtotal = [1, 1, 24, 36, 48, 60];
    return financeAmount * year[yearChoice];
  },

  workoutFinance: function(first=false, amount=false) {
    var updateForm = this.updateForm;
    var financeBlock = document.querySelector('.finance-block');
    if(financeBlock) {
        var num = amount ? amount : financeBlock.getAttribute('data-finance-price') / 100;
        var financeAmount = 0;
        var year = [1, 1, 0.0522, 0.0355, 0.0289, 0.0235];
        var mtotal = [1, 1, 24, 36, 48, 60];
        var totalCost = 0;
        var taxRelief = 0;
        var firstpay = 0;
        var weekPayment = 0;
        var multiProductSelected = '';

        function calTaxRelief(totalCost) {
          var taxRelief = (totalCost / 100) * 20;
          taxRelief = taxRelief.toFixed(2);
          var totalTaxparent = document.querySelector(multiProductSelected + " #taxRelief");
          var totalTaxparent_input = document.querySelector(multiProductSelected + " #taxRelief-input");
          totalTaxparent_input.value = taxRelief;
          totalTaxparent.innerHTML = "Tax Relief @ 20% <span>£" + taxRelief + '</span>';
        }

        function checkNumber(num) {
          var money = parseInt(num);
          if (isNaN(money)) {
            alert("Please enter a number");
            window.location.reload();
          } else {
            workOutfinance(num);
          }
        }

        function calTaxReliefmath(totalCost) {
          taxRelief = (totalCost / 100) * 20;
          taxRelief = taxRelief.toFixed(2);
          return;
        }

        function underFive() {
          if (financeAmount < 1) {
            alert("Unfortunately we can only offer finance over £1");
            document.getElementById("results-price").focus();
            return financeAmount = 0;
          } else {}
        }

        function calNetCost(totalCost) {
          calTaxReliefmath(totalCost);
          var netCost = totalCost - taxRelief;
          netCost = netCost.toFixed(2);
          var totalnetCostparent = document.querySelector(multiProductSelected + " #netCost");
          totalnetCostparent.innerHTML = "Net cost of Finance <span>£" + netCost + '</span>';
          var totalnetCostparent_input = document.querySelector(multiProductSelected + " #netCost-input");
          totalnetCostparent_input.value = netCost;
        }

        function workOutfinance() {
          var yearChoice = document.querySelector(multiProductSelected + ' select.finance-slider').value;
          if(!isNaN(yearChoice)) {  
            updateForm(yearChoice)
            financeAmount = num;
            underFive();
            var firstpay = financeAmount * year[yearChoice];
            var weekPayment = (firstpay * 12) / 52;
            weekPayment = weekPayment.toFixed(2);
            firstpay = firstpay.toFixed(2);
            result = document.querySelector(multiProductSelected + " #weekpaytext");
            result_input = document.querySelector(multiProductSelected + " #weekpaytext-input");
            var elementFpayText = document.querySelector(multiProductSelected + " #fpaytext");
            var elementFpayText_input = document.querySelector(multiProductSelected + " #fpaytext-input");
            elementFpayText.innerHTML = "First Payment <span>£" + firstpay + '</span>';;
            elementFpayText_input.value = firstpay;
            var totalPriceText = document.querySelector(multiProductSelected + " #totalpricetext");
            if(totalPriceText) { totalPriceText.innerHTML = "<span>£" + firstpay; totalPriceText.setAttribute('data-total-finance', num) + '</span>'; };
            var elementmpayText = document.querySelector(multiProductSelected + " #mpaytext");
            var elementmpayText_input = document.querySelector(multiProductSelected + " #mpaytext-input");
            result.innerHTML = "Weekly Payment <span>£" + weekPayment + '</span>';
            result_input.value = weekPayment;
            elementFpayText.innerHTML = "Monthly Payment <span>£" + (firstpay) + '</span>';
            elementmpayText.innerHTML = "First Payment <span>£" + (firstpay) + '</span>';
            elementmpayText_input.value = firstpay;

            // Update form
            var contactFormProduct = document.querySelectorAll(multiProductSelected + " .contactFormProduct");
            var contactFormPrice = document.querySelectorAll(multiProductSelected + " .contactFormPrice");
            var contactFormYears = document.querySelectorAll(multiProductSelected + " .contactFormYears");
            if(contactFormProduct) {
              var i;
              for(i = 0; i < contactFormProduct.length; i++) {
                contactFormProduct[i].value = window['foundVariant'] ? window['foundVariant'].name : '';
                contactFormPrice[i].value = '£' + num;
                contactFormYears[i].value = document.querySelector('select.finance-slider').value;
              };
            }

            var totalCost = firstpay * mtotal[yearChoice];
            totalCost = totalCost.toFixed(2);
            var totalCostparent = document.querySelector(multiProductSelected + " #totalcostID");
            var totalCostparent_input = document.querySelector(multiProductSelected + " #totalcostID-input");
            totalCostparent.innerHTML = "Total Amount <span>£" + totalCost + '</span>';;
            totalCostparent_input.value = totalCost;
            calTaxRelief(totalCost, multiProductSelected);
            calNetCost(totalCost, multiProductSelected);
          }
        }

        // var iframe = document.createElement("iframe");
        // iframe.name = "myTarget";
        // window.addEventListener("load", function() {
        //   iframe.style.display = "none";
        //   document.body.appendChild(iframe);
        // });

        function addMoneyAmountToQuote (enterMoneyAmount){
          var resultText = document.querySelector(multiProductSelected + " #result");
          if(resultText) {
            var resultText_input = document.querySelector(multiProductSelected + " #result-input");
            resultText.innerHTML = "Quote based on <span>£" + enterMoneyAmount + '</span>';
            resultText_input.value = enterMoneyAmount;
          }
        }

        if(first) {
          window.financeCheck = true;
          document.querySelector(multiProductSelected + ' select.finance-slider').addEventListener('change', function() {
            this.workoutFinance();
          }.bind(this));
        }

        checkNumber(num);
        addMoneyAmountToQuote(num);
    }
  }
};
const Header = {
	init: function(section) {
		this.announcement(section)
		this.nav(section)
		this.mmenu()
		this.stickyMenu();
	},

	announcement: function(section) {
		const announcementBar = section.querySelector('.announce');
		const announceStatus = Cookies.getCookie('announce-status-3');
		const announceClose = section.querySelector('.announce svg');
		const reinitMenuPlacement = this.reinitMenuPlacement

		if(announceStatus !== 'closed') {
			if(announcementBar) {
				announcementBar.style.display = 'block';
				announceClose.addEventListener('click', function() {
					Cookies.setCookie('announce-status-3', 'closed', 90);
					announcementBar.style.display = 'none';
					window['drawer'].close();
					window.location.reload();
				}.bind(this))
			}
		} else {
			if(announcementBar) {
				announcementBar.style.display = 'none';
			}
		}
	},

	nav: function(section) {
		const menuSelectors = document.querySelectorAll('.menu-selector')

		document.querySelector('.nav').addEventListener('mouseleave', function() {
			   for(j=0;j<menuSelectors.length;j++) {
					menuSelectors[j].classList.remove('nav__option--show')
			   }
		})

		for(i=0;i<menuSelectors.length;i++) {
		    menuSelectors[i].addEventListener('mouseover', function() {
		    const selectedSelector = this;

		    for(j=0;j<menuSelectors.length;j++) {
		        if(menuSelectors[j] == selectedSelector) {
		            selectedSelector.classList.add('nav__option--show')
		        } else {
		            menuSelectors[j].classList.remove('nav__option--show')
		        }
		    }    
		    })
		}
	},

	stickyMenu: function() {
		const mobileSpacer = document.querySelector('#mobile-menu-inner');
		const limit = document.querySelector('.mob-limit');
		const body = document.querySelector('body');
		const menuMain = document.querySelector('#menu-main');


		document.addEventListener('scroll', function() {
			const yPos = limit.getBoundingClientRect().y + limit.getBoundingClientRect().height;
			this.stickyMenuWork(yPos, mobileSpacer, limit, menuMain);
		}.bind(this));

		const yPos = limit.getBoundingClientRect().y + limit.getBoundingClientRect().height;
		this.stickyMenuWork(yPos, mobileSpacer, limit, menuMain);
	},

	stickyMenuWork: function(yPos, mobileSpacer, menu, body) {
		if(yPos < 0) {
			if(!mobileSpacer.classList.contains('mob-nav--fixed')) {
				mobileSpacer.classList.add('mob-nav--fixed');
				body.style.paddingTop = '64px';
			}
		} else {
			if(mobileSpacer.classList.contains('mob-nav--fixed')) {
				mobileSpacer.classList.remove('mob-nav--fixed');
				body.style.paddingTop = '0';
			}
		}
	},

	mmenu: function() {
		const mobileMenu = document.querySelector('#mobile-menu');
		const mobileSpacer = document.querySelector('#mobile-spacer');
		const mobileMenuPos = mobileSpacer.offsetTop + mobileSpacer.offsetHeight;
		const menuMain = document.querySelector('#menu-main');

		const menu = new MmenuLight(
            mobileMenu,
            '(max-width: 798px)'
        );

        const navigator = menu.navigation();
        const drawer = menu.offcanvas();
        window['drawer'] = drawer; 

        document.querySelector('a[href="#mobile-menu"]')
            .addEventListener('click', ( evnt ) => {
            	Global.hideCart();
				document.body.classList.remove('body-locked')
            	drawer.wrapper.style.top = 0 + 'px'
                evnt.preventDefault();
                drawer.wrapper.classList.contains('mm-ocd--open') ? drawer.close() : drawer.open();
            });

        drawer.wrapper.style.top = 0 + 'px'
	}
} ;
const Article = {
	init: function(section) {
		const budgetInfoObj = {
			'budgetSelector': section.querySelector('#budget-slider'),
			'budgetInfo': section.querySelector('#budget-info'),
			'budgetLoading': section.querySelector('#budget-loading'),
			'budgetProduct': section.querySelector('#budget-product'),
			'budgetAmount': section.querySelector('#budget-amount'),
			'budgetVideo': section.querySelectorAll('.budget-details')
		}

		budgetInfoObj['budgetSelector'].addEventListener('input', function() {
			this.updateBudget(budgetInfoObj)
		}.bind(this));
		this.updateBudget(budgetInfoObj);
	},

	updateBudget: async function(budgetInfoObj) {
		const { budgetSelector, budgetInfo, budgetLoading, budgetProduct, budgetAmount, budgetVideo } = budgetInfoObj;

		budgetLoading.style.display = 'block';
		budgetProduct.style.opacity = '0';
		let amount = budgetSelector.value;
		let productHandle = budgetInfo.getAttribute('data-product-' + amount);
		let productAmount = budgetInfo.getAttribute('data-amount-' + amount);

		for (var i = 0; i < budgetVideo.length; i++) {
			if(budgetVideo[i].getAttribute('data-budget-id') == productHandle) {
				budgetVideo[i].classList.remove('d-none');
			} else {
				budgetVideo[i].classList.add('d-none');
			}
		}

		let currency = Money.getCurrency();
		let vatStatus = Money.getVat();
		let priceGbp = Currency.formatMoney(parseInt(productAmount), Currency.money_format[currency]);
		let priceGbpVat = Currency.formatMoney(parseInt(productAmount) * 1.2, Currency.money_format[currency]);
		let priceFormatted = Currency.formatMoney(parseInt(productAmount), Currency.money_format[currency]);

		Product.updatePriceEl(budgetAmount, priceGbp, parseInt(productAmount), priceGbpVat, priceFormatted)

		let product = await makeRequest('GET', '/products/' + productHandle);

		if(product) {
			let template = document.createElement('html');
			template.innerHTML = product;
			let productTemplate = template.querySelector('[data-section="product"]');
			let productDeatails = template.querySelector('#product-details-section');

			if(productTemplate) {
				budgetProduct.innerHTML = productTemplate.innerHTML + productDeatails.innerHTML;
				Global.glider();
				Product.init(budgetProduct, window['product-' + productHandle]);
				Global.tabs();
				Global.accordion();
				Global.initAddToCart();
				budgetLoading.style.display = 'none';
				budgetProduct.style.opacity = '1';
			}
		}
	}	
}
;
const Collection = {
	init: function(section) {
		this.pagination(section);
	},

	getHtml: function(url, callback) {
		if (!window.XMLHttpRequest) return;
		var xhr = new XMLHttpRequest();
		xhr.onload = function() {
			if (callback && typeof(callback) === 'function')  {
				callback( this.responseXML );
			}
		}
		xhr.open( 'GET', url );
		xhr.responseType = 'document';
		xhr.send();
	},

	pagination: function(section) {
		const pagBtn = section.querySelector('#pagination-button');
		const pagBtnPrev = section.querySelector('#pagination-button-prev');

		if(pagBtn) {
			pagBtn.addEventListener('click', function() {
				const nextPage = pagBtn.getAttribute('data-page-next');
				if(nextPage) {
					pagBtn.removeAttribute('data-page-next');
					const collection = pagBtn.getAttribute('data-collection');
					const currentProducts = section.querySelector('#collection-products');

					this.getHtml('/collections/' + collection + '?page=' + nextPage, function(res) {
						const newProducts = res.querySelector('#collection-products');
						currentProducts.innerHTML = currentProducts.innerHTML + newProducts.innerHTML

						const newPagBtn = res.querySelector('#pagination-button');
						if(newPagBtn) {
							pagBtn.setAttribute('data-page-next', parseInt(nextPage) + 1);
						} else {
							pagBtn.classList.add('d-none');
						}

						Global.updateCurrency(false);
						window.history.replaceState('', '', '/collections/' + collection + '?page=' + nextPage);
					});
				}
			}.bind(this));
		}

		if(pagBtnPrev) {
			pagBtnPrev.addEventListener('click', function() {
				const prevPage = pagBtnPrev.getAttribute('data-page-next');
				if(prevPage) {
					pagBtnPrev.removeAttribute('data-page-next');
					const collection = pagBtnPrev.getAttribute('data-collection');
					const currentProducts = section.querySelector('#collection-products');

					this.getHtml('/collections/' + collection + '?page=' + prevPage, function(res) {
						const newProducts = res.querySelector('#collection-products');
						currentProducts.innerHTML = newProducts.innerHTML + currentProducts.innerHTML

						const newPagBtn = res.querySelector('#pagination-button-prev');
						if(newPagBtn) {
							pagBtnPrev.setAttribute('data-page-next', parseInt(prevPage) - 1);
						} else {
							pagBtnPrev.classList.add('d-none');
						}
						
						Global.updateCurrency(false);
						window.history.replaceState('', '', '/collections/' + collection + '?page=' + prevPage);
					});
				}
			}.bind(this));
		}
	}
}
;
const Global = {
	elements: {
		main: document.querySelector('main'),
		vatSwitcher: document.querySelector('#vat-switcher'),
		vatSwitcherParent: document.querySelector('#vat-switcher-parent'),
		currencies: document.querySelectorAll('.currencies'),
		financeForm: document.querySelector('#product-finance'),
		vanForm: document.querySelector('#product-van'),
	},

	init: function() {
		this.updateVat(true);
		const vatStatus = Money.getVat();
		document.body.classList.add(vatStatus === 'inc' ? 'vat-inc' : 'vat-exc');
		this.clickToShow();
		this.hoverToShow();
		this.lazyloadVideo();
		this.glider();
		this.accordion();
		this.modal();
		this.quantitySelector();
		this.quantitySelectorInput(this);
		this.tabs();
		this.recommendations();
		this.recentlyViewed();
		this.removeFromCart();
		this.initCart();
		this.initAddToCart();
		this.search();
		this.initSlider();
		this.orders();
		this.financeForm();
		this.showShippingBar();
		this.vanForm();

		this.elements.vatSwitcher.addEventListener('change', function() {
			this.updateVat(false, true);
		}.bind(this))

		this.updateCurrency(true);
		for (var i = 0; i < this.elements.currencies.length; i++) {
			let currencyConverter = this.elements.currencies[i];
			currencyConverter.addEventListener('change', function() {
				this.updateCurrency(false, currencyConverter.value)
			}.bind(this))
		}
	},

	showShippingBar: function() {
		let currency = Money.getCurrency();
		const bar = document.querySelector('#shipping-bar')
		const shippingPromoContainer = document.querySelector('.product-discount-container')

		if(currency == 'GBP') {
			if(bar) {
				bar.classList.remove('d-none')
			}

			if(shippingPromoContainer) {
				shippingPromoContainer.classList.remove('d-none')
			}
		}
	},

	enableShippingBar: function() {
		const percent = document.querySelector('.discount-bar-percent');

		if(!window['shippingBar']) {
			window['shippingBar'] = true;

			const bar = document.querySelector('.discount-bar-inner');
			if(!bar) { return }
			const limit = bar.getAttribute('data-width');
			const thresholds = document.querySelectorAll('.discount-threshold');
			const completedThresholds = []

			var width = parseFloat(bar.style.width.replace('%', ''));
			var speed = 1;

			this.checkThresholds(thresholds, width, completedThresholds)
			
			const widthUpdate = (limit, el, thresholds) => {
				if (width < limit || width > limit) {
					speed = speed + 1.5;
					width = width < limit ? parseFloat((width + speed < limit) ? width + speed : limit) : parseFloat((width - speed > limit) ? width - speed : limit);
					el.style.width = Math.floor(width) + '%';
					percent.innerHTML = Math.floor(width) + '%';
					this.checkThresholds(thresholds, width, completedThresholds, true)
				} else {
					this.checkThresholds(thresholds, width, completedThresholds, true)
					clearInterval(interval);
				}
			}

			var interval = setInterval(() => widthUpdate(limit, bar, thresholds), 100);
			const productPrices = document.querySelector('#product-template .price:not(.price-compare)');
			if(productPrices) {
				const priceText = productPrices.getAttribute('data-amount');
				const price = parseFloat(priceText);
				Product.updateProductPromos(document, price);
			}
		}
		return
	},

	checkThresholds: function(thresholds, width, completedThresholds, confetti=false) {
		const completedConfetti = Cookies.getCookie('completed-confetti-1') ? Cookies.getCookie('completed-confetti-1').split(',') : [];
		for (var i = 0; i < thresholds.length; i++) {

			if((!(parseFloat(thresholds[i].getAttribute('data-threshold')) >= parseFloat(width)) || parseFloat(thresholds[i].getAttribute('data-threshold')) == parseFloat(width)) && !completedThresholds.includes(thresholds[i])) {
				completedThresholds.push(thresholds[i])
				if(confetti) {
					if(completedConfetti.includes(thresholds[i].getAttribute('data-threshold'))) {
						return 
					}
					this.enableConfetti(thresholds[i])
				}
			}
		}
	},

	enableConfetti: function(el) {
        const x = (window.innerWidth - 250) / window.innerWidth;
    	const y = 0.5;
        
        confetti({
          shapes: ['star'],
		  particleCount: 50,
		  gravity: 2,
		  spread: 60,
		  flat: false,
		  ticks: 90,
		  drift: 1,
		  disableForReducedMotion: false,
		  origin: { x: x, y: y }
        });

		// Update cookie
		let completedConfetti = Cookies.getCookie('completed-confetti') ? Cookies.getCookie('completed-confetti').split(',') : [];
		completedConfetti.push(el.getAttribute('data-threshold'));
		Cookies.setCookie('completed-confetti-1', completedConfetti.join(','), 5);
	},

	financeForm: function() {
		document.addEventListener('click', function(e) {
			if(e.target.classList.contains('finance-form-selector') || e.target.classList.contains('finance-form-selector-parent') || e.target.closest('.finance-form-selector-parent')) {
				this.elements.financeForm.classList.contains('product-finance--show') ? this.elements.financeForm.classList.remove('product-finance--show') : this.elements.financeForm.classList.add('product-finance--show')
			}
		}.bind(this))
		this.financeFormCustomise();
	},

	vanForm: function() {
		document.addEventListener('click', function(e) {
			if(e.target.classList.contains('van-form-selector') || e.target.classList.contains('van-form-selector-parent') || e.target.closest('.van-form-selector-parent')) {
				this.elements.vanForm.classList.contains('product-finance--show') ? this.elements.vanForm.classList.remove('product-finance--show') : this.elements.vanForm.classList.add('product-finance--show')
			}
		}.bind(this))
	},

	financeFormCustomise: function() {
		document.addEventListener('click', function(e) {
			if(e.target.classList.contains('finance-form-customise') || e.target.classList.contains('finance-form-selector-customise')) {
				sessionStorage.setItem('finance-products-3', JSON.stringify([{
					name: fullProduct.title,
					id: fullProduct.id,
					img: fullProduct.images.length ? fullProduct.images[0] : '',
					vendor: fullProduct.vendor,
					handle: fullProduct.handle,
					variants: fullProduct.variants.map(function(variant) {
						return {
							title: variant.public_title,
							price: variant.price,
							id: variant.id,
							available: variant.available
						}
					}),
					selectedVariant: fullProduct.variants.find(function(variant) { return variant.available }).id || fullProduct.variants[0].id
				}]));
				window.location.href = Shopify.routes.root + 'pages/finance-dev';
			}
		}.bind(this))
	},

	glider: function() {
		const glides = document.querySelectorAll('.glider:not(.glider-std)');

		for(var i=0;i<glides.length;i++) {
			if(!glides[i].classList.contains('glider-disable')) {
				const optionsJson = glides[i].getAttribute('data-glider-options');
				const options = optionsJson ? JSON.parse(glides[i].getAttribute('data-glider-options')) : {}
				const windowId = glides[i].getAttribute('data-window-id');
				const glider = new Glider(glides[i], options);
				Global.updateCurrency(false);
				if(windowId) {
					window[windowId] = glider;
				}
			}
		}

		const stdGGlider = document.querySelectorAll('.glider-std');
		for(var i=0;i<stdGGlider.length;i++) {
			console.log(stdGGlider[i])

			const optionsJson = stdGGlider[i].getAttribute('data-glider-options');
			const options = optionsJson ? JSON.parse(stdGGlider[i].getAttribute('data-glider-options')) : {}
			const glider = new Glider(stdGGlider[i], options)
		}
	},



	initSlider: function() {
		const sliders = document.querySelectorAll('.slider-std');
		for (var i = 0; i < sliders.length; i++) {
			this.updateSlider(sliders[i]);
			sliders[i].addEventListener('input', function(e) {
				this.updateSlider(e.target);
			}.bind(this));
		}
	},

	updateSlider: function(slider) {
		let value = slider.value;
		let max = slider.getAttribute('max');
		slider.style.background = `linear-gradient(to right, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 5%, #2a2a2a 5%, #2a2a2a ${value == max ? 95 : value / max * 100}%, #b8b8b8 ${value == max ? 95 : value / max * 100}%, #b8b8b8 95%, #2a2a2a 95%, rgb(255, 255, 255) 95%, rgb(255, 255, 255) 100%)`
	},

	specificGlider: function(glider) {
		const optionsJson = glider.getAttribute('data-glider-options');
		const options = optionsJson ? JSON.parse(glider.getAttribute('data-glider-options')) : {}
		const windowId = glider.getAttribute('data-window-id');
		const gliderRow = new Glider(glider, options);
		Global.updateCurrency(false);
		if(windowId) {
			window[windowId] = gliderRow;
		}
	},

	lockScreen: function(remove) {
		let body = document.querySelector('body');
		remove == true ? body.classList.remove('body-locked') : body.classList.add('body-locked')
	},

	hoverToShow: function() {
		const hoverToShow = document.querySelectorAll('.hover-show');
		for (let i = 0; i < hoverToShow.length; i++) {
			const hoverType = hoverToShow[i].getAttribute('data-hover-type');
			const hoverId = hoverToShow[i].getAttribute('data-hover-id');

 			hoverToShow[i].addEventListener('mouseover', function() {
				const hoverTargets = document.querySelectorAll(`[data-hover-target="${hoverType}"]`);
				for (let j = 0; j < hoverTargets.length; j++) {
					if(hoverTargets[j].getAttribute('data-hover-id') == hoverId) {
						hoverTargets[j].classList.add('hover-show--show');
					} else {
						hoverTargets[j].classList.remove('hover-show--show');
					}
				}
			})
		}
	},

	clickToShow: function() {
		const clickToShow = document.querySelectorAll('.click-show-select');
		const cartOverlay = document.querySelector('#cart-overlay')

		document.addEventListener('click', function(event) {
			if(event.target.closest('.click-show-select')) {
				let clickedToShow = event.target.closest('.click-show-select');
				let clickTarget = clickedToShow.getAttribute('data-click-target');
				this.hideCart();
				window['drawer'].close();

				if(clickTarget) {
					let slickTarget = document.querySelector(clickTarget);
					if(clickTarget == '#search-show' && !slickTarget.classList.contains('click-show--show')) {
						// Focus input
						let input = slickTarget.querySelector('input');
						console.log(input)
						input.focus();
						// input.select();
					}
					this.lockScreen(slickTarget.classList.contains('click-show--show'));
					slickTarget.classList.toggle('click-show--show');
					fadeOut(cartOverlay);
				}
			} else {
				const shownTargets = document.querySelectorAll('.click-show--show');
				for (var i = 0; i < shownTargets.length; i++) {
					shownTargets[i].classList.remove('click-show--show');
					document.body.classList.remove('body-locked')
				}
			}
		}.bind(this));
	},

	lazyloadVideo: function() {
		var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

		if ("IntersectionObserver" in window) {
		  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		    entries.forEach(function(video) {
		      if (video.isIntersecting) {
		        for (var source in video.target.children) {
		          var videoSource = video.target.children[source];
		          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
		            videoSource.src = videoSource.dataset.src;
		            videoSource.classList.add('video-enabled')
		          }
		        }

		        video.target.load();
		        video.target.classList.remove("lazy");
		        lazyVideoObserver.unobserve(video.target);
		      }
		    });
		  });

		  lazyVideos.forEach(function(lazyVideo) {
		    lazyVideoObserver.observe(lazyVideo);
		  });
		}
	},

	updateAccordion(selector, target, type) {
		if(type == 'remove') {
			target.style.height = 0;
			selector.classList.remove('accordion-selector-open');
			target.classList.remove('accordion-target-open');
		} else {
			target.style.height = target.scrollHeight + 'px'
			selector.classList.add('accordion-selector-open');
			target.classList.add('accordion-target-open');
		}
	},

	accordion: function() {
		const accordionSelectors = document.querySelectorAll('.accordion-selector');
		const updateAccordion = this.updateAccordion;

		for(var i=0;i<accordionSelectors.length;i++) {
			accordionSelectors[i].addEventListener('click', function() {
				const accordionSelector = this;
				const accordionGroup = accordionSelector.getAttribute('data-accordion-group');
				const accordionTarget = accordionSelector.getAttribute('data-accordion-target');
				const accordionGroupTargets = document.querySelectorAll(`[data-accordion-targets="${accordionGroup}"]`);

				for(var j=0;j<accordionGroupTargets.length;j++) {
					const selectorTarget = accordionGroupTargets[j].id;
					const relevantSelector = document.querySelector(`[data-accordion-target="${selectorTarget}"]`)

					if(accordionGroupTargets[j].id == accordionTarget && !accordionGroupTargets[j].classList.contains('accordion-target-open')) {
						updateAccordion(relevantSelector, accordionGroupTargets[j], 'add')
					} else if(accordionGroupTargets[j].id == accordionTarget && accordionGroupTargets[j].classList.contains('accordion-target-open')) {
						updateAccordion(relevantSelector, accordionGroupTargets[j], 'remove')
					} else {
						updateAccordion(relevantSelector, accordionGroupTargets[j], 'remove')
					}
				}

			})
		}
	},

	updatePrice: function(el, vatStatus) { 
		// let newPrice = el.getAttribute('data-alt-price');
		// let oldPrice = el.textContent;

		// el.textContent = newPrice;
		// el.setAttribute('data-alt-price', oldPrice);
	},

	updateVat: function(first, change=false) {
		let vatStatus = Money.getVat();
		let currency = Money.getCurrency();

		if(first) {
			this.elements.vatSwitcher.checked = vatStatus == 'exc' ? false : true;
			this.elements.vatSwitcher.disabled = false;
		}

		if(!this.elements.vatSwitcher.disabled) {
			vatStatus = change ? vatStatus == 'inc' ? 'exc' : 'inc' : vatStatus;

			const prices = document.querySelectorAll('.price'); 
			const dicountPrices = document.querySelectorAll('.discount-price'); 
			for (var i = 0; i < prices.length; i++) {
				let price = prices[i];
				let discountSave = dicountPrices[i];
				let amount = price.getAttribute('data-amount');
				if (price.classList.contains('price-compare') && (!(Number(amount) > 0) || price.closest('.sale-price')?.classList.contains('d-none'))) {
					price.textContent = '';
					continue;
				}
				let discount = price.getAttribute('data-discount');
				let vat = currency != 'GBP' ? 1 : vatStatus == 'exc' ? 1 : 1.2;

				if(price.getAttribute('data-vat-default') == 'second') {
					vat = currency != 'GBP' ? 1 : vatStatus == 'exc' ? 1.2 : 1;
				}

				let discountAmount = (amount - (amount * (discount/100))).toFixed(0);
				let newPriceAmount =  Currency.convert(discountAmount * vat, 'GBP', currency);
				let formattedCurrency = Currency.formatMoney(newPriceAmount, Currency.money_format[currency]);
				price.innerHTML = formattedCurrency.replace('&pound;', '£');
				if(price.getAttribute('data-vat-status')){
				price.setAttribute('data-vat-status', vat == 1 ? 'exc' : 'inc');}
				currency == 'GBP' ? price.classList.add('price-gbp') : price.classList.remove('price-gbp');
				
			}
			for (var i = 0; i < dicountPrices.length; i++) {
				let price = dicountPrices[i];
				let discountSave = dicountPrices[i];
				let amount = discountSave.getAttribute('data-amount');
				if (!(Number(amount) > 0)) {
					price.textContent = '';
					continue;
				}
				let discount = discountSave.getAttribute('data-discount');
				let vat = currency != 'GBP' ? 1 : vatStatus == 'exc' ? 1 : 1.2;

				if(price.getAttribute('data-vat-default') == 'second') {
					vat = currency != 'GBP' ? 1 : vatStatus == 'exc' ? 1.2 : 1;
				}

				let discountAmount = (amount - (amount * (discount/100))).toFixed(0);
				let newPriceAmount =  Currency.convert(discountAmount * vat, 'GBP', currency);
				let formattedCurrency = Currency.formatMoney(newPriceAmount, Currency.money_format[currency]);
				// price.innerHTML = formattedCurrency.replace('&pound;', '£');
				// price.setAttribute('data-vat-status', vat == 1 ? 'exc' : 'inc');
				currency == 'GBP' ? price.classList.add('price-gbp') : price.classList.remove('price-gbp');
				
				if (discountSave) {
					discountSave.innerHTML = formattedCurrency.replace('&pound;', '£'); 
				if(discountSave.getAttribute('data-vat-status')){
					discountSave.setAttribute('data-vat-status', vat == 1 ? 'exc' : 'inc');}
				}
				
			}
			setTimeout(function () {
				const buttonPrice = document.querySelector('.buton_price #product-template .price')?.textContent?.trim();
				const addToCart = document.querySelector('.newpdp_bt');
				if(addToCart && !addToCart.disabled && buttonPrice){
					const addToCartText = addToCart.getAttribute('data-add-to-cart');
					addToCart.innerHTML = `${addToCartText} | ${buttonPrice}`;
					// console.log('buttonPrice test:', buttonPrice);
				}
				
			}, 500);
			document.body.classList.remove('vat-inc', 'vat-exc');
			document.body.classList.add(vatStatus === 'inc' ? 'vat-inc' : 'vat-exc');
			Cookies.setCookie('vat', vatStatus, 300);
			this.elements.vatSwitcher.checked = vatStatus == 'exc' ? false : true;

		}
	},

	updateCurrency: function(init=false, currency=null) {
		if(!currency) {
			currency = Cookies.getCookie('curr');
			if(!currency) {
				Cookies.setCookie('curr', 'GBP', 300);
				currency = 'GBP'
			}
		}

		currency != 'GBP' ? this.elements.main.classList.add('non-gbp') : this.elements.main.classList.remove('non-gbp')
		Cookies.setCookie('curr', currency, 300);	
		for (var i = 0; i < this.elements.currencies.length; i++) {
			this.elements.currencies[i].value = currency;
		}
		this.elements.vatSwitcherParent.classList.remove('switch-hide');
		this.updateVat(false);
	},

	modal: function() {
		const modals = document.querySelectorAll('.modal');
		for (var i = 0; i < modals.length; i++) {
			let modal = modals[i];
			let modalSelectorId =  modal.id
			let modalSelectors = document.querySelectorAll(`[data-modal-selector="${modalSelectorId}"]`);
			
			for (var i = 0; i < modalSelectors.length; i++) {
				var close = modal.querySelector('.modal-close');
				modalSelectors[i].onclick = function() {
				  modal.style.display = "block";
				}
				close.onclick = function() {
				  modal.style.display = "none";
				}
				window.onclick = function(event) {
				  if (event.target == modal) {
				    modal.style.display = "none";
				  }
				}
			}
		}
	},

	quantitySelector: function() {
		const quantitySelectorAll = document.querySelectorAll('.quantity-selector');
		const _this = this;
		const updateLineItem = this.updateLineItem;
		const event = new Event('quantity');

		document.addEventListener('click' , function(e) {
			if(e.target.classList.contains('plus')) {
				let quantitySelect = e.target.parentNode.querySelector('.quantity-selector');

				quantitySelect.value = parseInt(quantitySelect.value) + 1;
				if(quantitySelect.getAttribute('data-line-id')) {
					_this.updateLineItem(quantitySelect.getAttribute('data-line-id'), quantitySelect.value, _this);
				}
				e.target.dispatchEvent(event);
			} else if (e.target.classList.contains('minus')) {
				let quantitySelect = e.target.parentNode.querySelector('.quantity-selector');

				let currentValue = parseInt(quantitySelect.value, 10);

					if (currentValue > 1) {
						quantitySelect.value = currentValue - 1;
						
						if (quantitySelect.getAttribute('data-line-id')) {
							_this.updateLineItem(quantitySelect.getAttribute('data-line-id'), quantitySelect.value, _this);
						}
					} else {
						// Trigger alert when user hits minimum limit
						showTooltip(e.target, 'Minimum quantity is 1');
					}
			}
		})
	},

	quantitySelectorInput: function(_this) {
		const updateCartHtml = _this.updateCartHtml;

		const quantitySelector = document.querySelectorAll('.quantity-selector');
		for (var i = 0; i < quantitySelector.length; i++) {
			quantitySelector[i].addEventListener('change', function() {
				if(this.getAttribute('data-line-id')) {
					_this.updateLineItem(this.getAttribute('data-line-id'), this.value, _this);
				}
			})
		}

	},

	updateLineItem: function(lineId, quantity, _this) {
		const cartPopout = document.querySelector('#cart-popout-inner');
		const cartTemplate = document.querySelector('#cart-template-inner');
 
		if(cartPopout) {
			cartPopout.classList.add('cart-popout--loading');
			if(cartTemplate) { cartTemplate.classList.add('cart-template--loading') };
			makePostRequest('/cart/change.js', {
			  'line': parseInt(lineId),
			  'quantity': parseInt(quantity)
			}).then(function() {
				window['shippingBar'] = false;
				_this.updateCartHtml(cartPopout, cartTemplate, _this);
			}).catch(function(err) {
				console.log(err)
				alert('There has been an error removing this product from cart');
				if(cartTemplate) { cartTemplate.classList.remove('cart-template--loading') };
				cartPopout.classList.remove('cart-popout--loading');
			}.bind(this))
		}
	},

	cleansAllTabs: function(tabSection, tabs) {
		let tabContentSelected = tabSection.querySelectorAll('.tab-content-show');
		for (var i = 0; i < tabs.length; i++) {
			tabs[i].classList.remove('tab-selected');
		}
		for (var i = 0; i < tabContentSelected.length; i++) {
			tabContentSelected[i].classList.remove('tab-content-show')
		}
	},

	cleansAllTabsWithVideos: function(tabSection) {
		let allTabVideos = tabSection.querySelectorAll('iframe');
		for (var i = allTabVideos.length - 1; i >= 0; i--) {
			if(allTabVideos[i].closest('.tab-content-show')) {
				let videoUrl = allTabVideos[i].getAttribute('data-embed-url');
				allTabVideos[i].src = videoUrl;
			} else {
				allTabVideos[i].src = '';
			}
		}
	},

	tabs: function() {
		const tabsSections = document.querySelectorAll('.tab-system');

		for (var i = 0; i < tabsSections.length; i++) {
			let tabSection = tabsSections[i];
			let tabs = tabSection.querySelectorAll('.tab-system-tab');

			for (var j = 0; j < tabs.length; j++) {
				let tab = tabs[j];
				tab.addEventListener('click', function() {
					if(!tab.classList.contains('tab-selected')) {
						let selectedTabIndex = tab.getAttribute('data-tab-selector');
						let selectedTab = tabSection.querySelectorAll(`[data-tab-content="${selectedTabIndex}"]`);
						this.cleansAllTabs(tabSection, tabs);
						tab.classList.add('tab-selected');
						selectedTab.forEach(function(tabContent) {
							tabContent.classList.add('tab-content-show');
						});
						window['tab-system'] = selectedTabIndex
					}

					if(tabSection.classList.contains('tab-with-videos')) {
						this.cleansAllTabsWithVideos(tabSection);
					}
				}.bind(this))
			}
		}
	},

	recommendations: function() {
	  // Look for an element with class 'product-recommendations'
	  var productRecommendationsSection = document.querySelector(".product-recommendations");
	  if (productRecommendationsSection === null) { return; }
	  // Read product id from data attribute
	  var productId = productRecommendationsSection.dataset.productId;
	  // Read limit from data attribute
	  var limit = productRecommendationsSection.dataset.limit;
	  // Build request URL
	  var requestUrl = "/recommendations/products?section_id=ymal&limit="+limit+"&product_id="+productId;
	  // Create request and submit it using Ajax
	  var request = new XMLHttpRequest();

	  request.open("GET", requestUrl);
	  request.onload = function() {
		if (request.status >= 200 && request.status < 300) {
		  let container = document.createElement('div');
		  container.innerHTML = request.response;
		  productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
		  let glider = container.querySelector('.glider');
		  
		  Global.glider()
		}
	  };
	  request.send();
	},

	recentlyViewed: async function() {
		const recentlyViewedSections = document.querySelectorAll('.recently-viewed-js');
		const recentlyViewedHandles = Cookies.getCookie('recently-viewed');
		let recentlyFound = false;

		if(recentlyViewedHandles) {
			let recentlyViewedArr = recentlyViewedHandles.split(',');
			for (var i = 0; i < recentlyViewedSections.length; i++) {
				let recentlyViewedSection = recentlyViewedSections[i];
				let recentlyViewedRow = recentlyViewedSection.querySelector('.glider');
				let handle = typeof fullProduct !== 'undefined' ? fullProduct['handle'] : null;

				for (var j = 0; j < recentlyViewedArr.length; j++) {
					if(recentlyViewedArr[j] != handle) {
						let result = await makeRequest("GET", /products/ + recentlyViewedArr[j]);
						if(result) {
							let container = document.createElement('div');
							container.innerHTML = result;
							let productBlock = container.querySelector('#product-block');
							if(productBlock) {
								let productBlockChild = productBlock.querySelector('.product-block');
								let listItem = document.createElement('li');
								listItem.classList.add('glide__slide');
								listItem.appendChild(productBlockChild)

								recentlyFound = true
								recentlyViewedRow.appendChild(listItem)
							}
						}
					}

					if(j == recentlyViewedArr.length - 1 && recentlyFound) {
						recentlyViewedSection.classList.remove('d-none');
						Global.specificGlider(recentlyViewedRow);
					}
				}
			}
		}
	},

	initCart: function() {
		const mobileBtn = document.querySelector('.mobile-cart-button');
		const cartPopout = document.querySelector('#cart-popout');
		const body = document.querySelector('body');
		const cartOverlay = document.querySelector('#cart-overlay');
		const updateMiniCart = this.updateMiniCart;

		function openCart(_this) {
			// Hide all non-clicked shown targets
			window['drawer'].close();

			const shownTargets = document.querySelectorAll('.click-show--show');
			for (var i = 0; i < shownTargets.length; i++) {
				shownTargets[i].classList.remove('click-show--show');
			}

			if(mobileBtn.classList.contains('mobile-cart-button-open')) {
				mobileBtn.classList.remove('mobile-cart-button-open');
				cartPopout.style.right = '-100%';
				fadeOut(cartOverlay);
				cartOverlay.style.display = 'none';
				body.classList.remove('mm-ocd-opened')
				body.classList.remove('body-locked')
			} else {
				mobileBtn.classList.add('mobile-cart-button-open');
				cartPopout.style.right = '0%';
				fadeIn(cartOverlay, 'block');
				body.classList.add('mm-ocd-opened')
				body.classList.remove('body-locked')
				Global.enableShippingBar()
			}
		}

		mobileBtn.addEventListener('click', function() {
			openCart(this)
		}.bind(this));

		cartOverlay.addEventListener('click', function() {
			openCart(this)
		}.bind(this));	

		document.addEventListener('click', function(e) {
			if(e.target.id == 'cart-popout-close') {
				mobileBtn.classList.remove('mobile-cart-button-open');
				cartPopout.style.right = '-100%';
				fadeOut(cartOverlay);
				cartOverlay.style.display = 'none';
				body.classList.remove('mm-ocd-opened')
				body.classList.remove('body-locked')
			}
		}.bind(this))

		const cartSelector = document.querySelector('.menu__cart-inner');
		// cartSelector.addEventListener('mouseleave', function(e) {
		// 	updateMiniCart(true, cartPopout, cartSelector);
		// })

		// cartSelector.addEventListener('mouseover', function() {
		// 	updateMiniCart(false, cartPopout, cartSelector);
		// })

		cartSelector.addEventListener('click', function() {
			openCart(this)		
			Global.enableShippingBar()	
		}.bind(this));
	},

	hideCart: function() {
		const mobileBtn = document.querySelector('.mobile-cart-button');
		const cartPopout = document.querySelector('#cart-popout');
		mobileBtn.classList.remove('mobile-cart-button-open');
		cartPopout.style.right = '-100%';
	},

	updateMiniCart: function(show, cartPopout, cartSelector) {
		if(show) {
			if(cartPopout.style.display !== 'none') {
				cartSelector.classList.remove('cart-button-open');
				cartPopout.style.right = '-100%';
			}
		} else {
			if(cartPopout.style.display !== 'block') {
				cartSelector.classList.add('cart-button-open');
				cartPopout.style.right = '0%';		
				Global.enableShippingBar()	
			}
		}
	},

	removeFromCart: async function() {
		const cartPopout = document.querySelector('#cart-popout-inner');
		const cartTemplate = document.querySelector('#cart-template-inner');
		const updateCartHtml = this.updateCartHtml;
		const _this = this;

		document.addEventListener('click', async function(e) {
			if(e.target.classList.contains('remove-line-item')) {
				cartPopout.classList.add('cart-popout--loading');
				if(cartTemplate) { cartTemplate.classList.add('cart-template--loading') };

				if(e.target.getAttribute('data-bundle')) {
					let cartBundle = getClosest(e.target, '.cart-bundle');
					let lineItem = e.target.getAttribute('data-line-id');
					let allBundleLineItems = cartBundle.querySelectorAll('.remove-line-item');
					let removeChanges = {'updates': {}};
					let toAddVariants = {'items': [] };
					let updateQuantity = null

					for (var i = 0; i < allBundleLineItems.length; i++) {
						if(allBundleLineItems[i].getAttribute('data-line-id') == lineItem) {
							removeChanges['updates'][allBundleLineItems[i].getAttribute('data-line-key').toString()] = 0;
						} else {
							removeChanges['updates'][allBundleLineItems[i].getAttribute('data-line-key').toString()] = 0;
							toAddVariants['items'].push({
								'quantity': 1,
								'id': allBundleLineItems[i].getAttribute('data-variant-id')
							});
						}
					}

					// Update properties
					let removeChangesRes = await makePostRequest('/cart/update.js', removeChanges);
					let toAddVariantsRes = await makePostRequest('/cart/add.js', toAddVariants);

					window['shippingBar'] = false;
					updateCartHtml(cartPopout, cartTemplate, _this)
				} else {
					let lineItem = e.target.getAttribute('data-line-id');
					makePostRequest('/cart/change.js', {
					  'line': parseInt(lineItem),
					  'quantity': 0
					}).then(function() {
						updateCartHtml(cartPopout, cartTemplate, _this)
					}).catch(function(err) {
						console.log(err)
						alert('There has been an error removing this product from cart');
						cartPopout.classList.remove('cart-popout--loading');
						if(cartTemplate) { cartTemplate.classList.remove('cart-template--loading') };
					})
				}
			}
		});
	},

	updateCartHtmlGlobal: function() {
		const cartPopout = document.querySelector('#cart-popout-inner');
		const cartTemplate = document.querySelector('#cart-template-inner');
		this.updateCartHtml(cartPopout, cartTemplate, this);
		this.updateVat();
	},

	updateCartHtml: async function(currentCartPopout, currentCartTemplate, _this) {
		const cart = await makeRequest('GET', '/cart');

		if(cart) {
			// Readd cart pop-up
			let container = document.createElement('div');
			container.innerHTML = cart;
			let cartPopout = container.querySelector('#cart-popout-inner');

			currentCartPopout.querySelector('#cart-popout-inner-top').innerHTML = cartPopout.querySelector('#cart-popout-inner-top').innerHTML;
			if(currentCartPopout.querySelector('#cart-popout-inner-bottom') && cartPopout.querySelector('#cart-popout-inner-bottom')) {
				currentCartPopout.querySelector('#cart-popout-inner-bottom').innerHTML = cartPopout.querySelector('#cart-popout-inner-bottom').innerHTML;
			}
			// currentCartPopout.innerHTML = cartPopout.innerHTML;
			currentCartPopout.classList.remove('cart-popout--loading');

			const cartItems = currentCartPopout.querySelectorAll('.line-item');
			if (cartItems.length === 0) {
				currentCartPopout.classList.add('empty_cart_drawer');
			} else {
				currentCartPopout.classList.remove('empty_cart_drawer');
			}

			// Readd cart shipping bar thresholds
			setTimeout(function() {
				const currentShippingBarTitles = document.querySelectorAll('.discount-bar-title');
				const shippingBarTitles = container.querySelectorAll('.discount-bar-title');
				for (var i = 0; i < currentShippingBarTitles.length; i++) {
					currentShippingBarTitles[i].style.display = shippingBarTitles[i].style.display;
				}
			}, 500)

			// Readd cart shipping bar message
			// let cartShippingBarTextContainer = document.querySelector('.discount-bar-text-container');
			let cartShippingBarText = container.querySelectorAll('.discount-bar-text');
			let currentCartShippingBarText = document.querySelectorAll('.discount-bar-text');

			if(cartShippingBarText && currentCartShippingBarText) {
				// const cartShippingBarLetters = cartShippingBarText.querySelectorAll('.in');
				// for (let i = 0; i < cartShippingBarLetters.length; i++) {
				// 	cartShippingBarLetters[i].classList.remove('in');
				// 	cartShippingBarLetters[i].classList.add('behind');
				// }

				// cartShippingBarTextContainer.appendChild(cartShippingBarText);
				for (let i = 0; i < cartShippingBarText.length; i++) {
					_this.updateShippingBarText(currentCartShippingBarText[i], cartShippingBarText[i]);
					
				}
			}

			// Readd cart page
			if(currentCartTemplate) { 
				let cartContainer = document.createElement('div');
				cartContainer.innerHTML = cart;
				let newCartTemplate = container.querySelector('#cart-template-inner');
				currentCartTemplate.innerHTML = newCartTemplate.innerHTML;
				currentCartTemplate.classList.remove('cart-template--loading')
			};

			// Update shipping bar
			_this.updateShippingBar(document, container);

			// Update cart counter
			let cartCounts = container.querySelector('.cart-count');
			let currentCartCounts = document.querySelectorAll('.cart-count');
			for (var i = 0; i < currentCartCounts.length; i++) {
				currentCartCounts[i].innerHTML = cartCounts.innerHTML;
			}

		}
		_this.quantitySelectorInput(_this);
		_this.updateVat();

		// Update promos
		const productPrices = document.querySelector('#product-template .price:not(.price-compare)');
		if(productPrices) {
			const priceText = productPrices.getAttribute('data-amount');
			const price = parseFloat(priceText);
			Product.updateProductPromos(document, price);
		}

		// setTimeout(_this.updateCurrency(true), 1000);
		Cart.init();
	},

	updateShippingBar: function(currentCartTemplate, newCartTemplate) {
		const shippingBar = newCartTemplate.querySelector('[data-width]');
		const currentShippingBar = currentCartTemplate.querySelector('[data-width]');

		if(shippingBar) {
			currentShippingBar.setAttribute('data-width', shippingBar.getAttribute('data-width'));

			// If cart open
			window['shippingBar'] = false;
			if(document.querySelector('.cart-button-open') || document.querySelector('.mobile-cart-button-open')) {
				this.enableShippingBar();
			}
		}
	},

	updateShippingBarText: function(cw, nw) {
		// nw[0].style.opacity = 1;
		// nw[0].classList.remove('behind');
		cw.innerHTML = nw.innerHTML;
		return
		
		const parentElement = cw[0].parentElement;
		for (var i = 0; i < cw.length; i++) {
			animateLetterOut(cw, i, i == cw.length - 1);
			setTimeout(function() {
				parentElement.remove();
			}, 1000);
		}
		
		for (var i = 0; i < nw.length; i++) {
			nw[i].className = 'letter behind';
			nw[0].parentElement.style.opacity = 1;
			animateLetterIn(nw, i);
		}

		function animateLetterOut(cw, i, last) {
			setTimeout(function() {
					cw[i].className = 'letter out';
			}, i*0);
		}

		function animateLetterIn(nw, i) {
			setTimeout(function() {
					nw[i].className = 'letter in';
			}, 300+(i*0));
		}

		
	},

	initAddToCart: function() {
		const addToCartForms = document.querySelectorAll('[action="/cart/add"]');
		if (!addToCartForms.length) return;

		const cartPopout = document.querySelector('#cart-popout-inner');
		const cartSelector = document.querySelector('.menu-cart');
		const cartTemplate = document.querySelector('#cart-template-inner');
		const updateMiniCart = this.updateMiniCart;
		const updateCartHtml = this.updateCartHtml;
		const _this = this;

		const mobileBtn = document.querySelector('.mobile-cart-button');
		const cartContainer = document.querySelector('#cart-popout');
		const body = document.querySelector('body');
		const cartOverlay = document.querySelector('#cart-overlay');

		addToCartForms.forEach((addToCart) => {
			const addToCartBtn = addToCart.querySelector('[type="submit"]');
			const addToCartTextnormal = addToCartBtn.getAttribute('data-add-to-cart');
			const newaddToCart = addToCart.querySelector('.newpdp_bt'); // changed: search inside the same form

			let addToCartText = '';
			let price = '';
			let addToCartBtnText = '';

			if (newaddToCart) {
				addToCartText = newaddToCart.getAttribute('data-add-to-cart');
				price = newaddToCart.getAttribute('data-price');
				addToCartBtnText = newaddToCart.querySelector('.buton-text');
			}

			addToCart.addEventListener('submit', function(e) {
				e.preventDefault();

				addToCartBtn.setAttribute('disabled', 'true');
				addToCartBtn.innerHTML = 'Adding...';

				const url = '/cart/add';
				const request = new XMLHttpRequest();
				request.open('POST', url, true);

				request.onload = function() {
					if (request.status === 200) {
						showModal(false, 'Added to cart successfully');

						updateCartHtml(cartPopout, cartTemplate, _this);

						mobileBtn.classList.add('mobile-cart-button-open');
						cartContainer.style.right = '0%';
						fadeIn(cartOverlay, 'block');
						body.classList.add('mm-ocd-opened');
						body.classList.remove('body-locked');

						Global.enableShippingBar();
					} else {
						showModal(true, 'An Error Occurred');
					}

					updateCartHtml(cartPopout, cartTemplate, _this);
					addToCartBtn.removeAttribute('disabled');

					if (newaddToCart) {
						newaddToCart.innerHTML = `${addToCartText} | ${price}`;
					} else {
						addToCartBtn.innerHTML = `${addToCartTextnormal}`;
					}
				};

				request.onerror = function() {
					updateCartHtml(cartPopout, cartTemplate, _this);
					addToCartBtn.removeAttribute('disabled');

					if (newaddToCart) {
						newaddToCart.innerHTML = `${addToCartText} | ${price}`;
					} else {
						addToCartBtn.innerHTML = `${addToCartTextnormal}`;
					}

					showModal(true, 'An Error Occurred');
				};

				request.send(new FormData(e.target));
			});
		});
	},

	search: async function() {
		// let request = `https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=window-cleaning-warehouse-ltd.myshopify.com&q=${'pole'}&product_limit=5&page_limit=2&collection_limit=2&suggestion_limit=3`;
		// let result = await makeRequest('GET', request);
		let tradeStatus = document.querySelector('#custom-boost-trade') ? document.querySelector('#custom-boost-trade').getAttribute('data-custom-boost-trade') : null;
		let resElsParent = document.querySelectorAll('.boost-custom');
		let searchForms = document.querySelectorAll('.search');
		let searchBtn = document.querySelector('.mobile-search-btn');
		const cartOverlay = document.querySelector('#cart-overlay')
		let _this = this;

		const searchInputs = document.querySelectorAll('.custom-boost-search');
		for(var i=0; i < searchInputs.length; i++) {
		  ['input','focus','click'].forEach(function(evt) {
		      searchInputs[i].addEventListener(evt, function(e) {
				// Show search on mobile
				let clickTarget = document.querySelector('#search-show');

				if(!clickTarget.classList.contains('click-show--show') && this.value) {
					_this.hideCart();
					window['drawer'].close();
					_this.lockScreen(clickTarget.classList.contains('click-show--show'));
					clickTarget.classList.toggle('click-show--show');
					fadeOut(cartOverlay);
				} else if(!this.value) { 
					clickTarget.classList.remove('click-show--show');
					document.body.classList.remove('body-locked')
				}

		      	let resultsId = e.target.getAttribute('data-results-id');
		      	let resultsEl = document.querySelector(resultsId);

		      	if(this.value) {
		      		let request = `/search/suggest.json?&q=${this.value}&resources[options][fields]=title,product_type,variants.title,variants.barcode,variants.sku,variants.title,vendor&resources[limit_scope]=each`;
					_this.initSearchResults(request, resultsEl, this.value, tradeStatus);

		      		for (var i = 0; i < resElsParent.length; i++) {
		      			if(resElsParent[i].id != resultsId) {
		      				resElsParent[i].classList.remove('row')
		      			}
		      		}
		      	} else {
		      		_this.initSearchResults(null, resultsEl, null, tradeStatus);
		      	}
		      })
		  });
		}

		searchBtn.addEventListener('click', function() {
			const searchMobile = document.querySelector('.custom-boost-search-mobile');
			if(searchMobile) {
				const term = searchMobile.value;
				if(term) {
					window.location.href = Shopify.routes.root + `search?q=${term}`;
				}
			}
		});

		document.addEventListener('click', function(e) {
			if(!e.target.closest('.boost-custom') && !e.target.closest('.custom-boost-search')) {
				for (var i = 0; i < resElsParent.length; i++) {
					resElsParent[i].classList.contains('row') ? resElsParent[i].classList.remove('row') : null;
				}
			}
		})

		for (var i = 0; i < searchForms.length; i++) {
			let searchForm = searchForms[i];
			let searchIcon = searchForms[i].querySelector('svg');

			searchForms[i].addEventListener('submit', function(e) {
				e.preventDefault()
				_this.submitSearchForm(e.target);
			});

			if(searchIcon) {
				searchIcon.addEventListener('click', function() {
					_this.submitSearchForm(searchForm);
				});
			}
		}
		// let resEls = document.querySelector(target);
		// let resElsParent = resEls.closest('.boost-custom');
	},

	submitSearchForm: function(e) {
		const searchInput = e.querySelector('input');
		const term = searchInput.value;

		if(term) {
			window.location.href = `/search?q=${term}`;
		}
	},

	initSearchResults: async function(request, resEls, term, tradeStatus) {
		if(term) {
			let result = await makeRequest('GET', request);
			if(result) {
			  result = JSON.parse(result)['resources']['results'];
			  resEls.innerHTML = '';
			  try {
				if(result.products.length < 1 && result.pages.length < 1 && result.collections.length < 1 && result.suggestions.length < 1) {
					resEls.innerHTML = '<li class="boost-pfs-search-suggestion-group boost-custom__title text-extra-bold" aria-label="No Results">No results found</li>';
				  } else {
					let productRes = this.initProducts(result, term, tradeStatus);
					let pagesRes = this.initLinks(result['pages'], 'Information');
					let colRes = this.initLinks(result['collections'], 'Categories');
					// let colSuggestions = this.initSuggestions(result['queries'], false);
					// let colSuggestionsMobile = this.initSuggestions(result['queries'], true);
	
					// resEls.insertAdjacentHTML('beforeend', colSuggestionsMobile);
					resEls.insertAdjacentHTML('beforeend', productRes);
					// resEls.insertAdjacentHTML('beforeend', colSuggestions);
					resEls.insertAdjacentHTML('beforeend', colRes);
					resEls.insertAdjacentHTML('beforeend', pagesRes);
				  }
			  } catch(e) {
				resEls.innerHTML = '<li class="boost-pfs-search-suggestion-group boost-custom__title text-extra-bold" aria-label="No Results">No results found</li>';
			  }
			  resEls.classList.add('row');
			  Global.updateVat();
			}
		} else {
			resEls.classList.remove('row');
			Global.updateVat();
		}
	},

	initProducts: function(result, term, tradeStatus) {
	  let products = `<li class="boost-custom__title col-one-whole col-md-five-eigth" data-group="products-custom" aria-label="Products">
	        <ul aria-hidden="true" aria-expanded="false" class="p-0 m-0 flex flex-wrap__wrap row">
	          <li class="boost-custom__title text-extra-bold width-whole mb-10" aria-label="Products">Products</li>`;
	  if(result.products.length > 0) {
	    for(const [i, product] of result.products.entries()) {
	    //   let tradeDiscount = tradeStatus ? product.tags.filter(function(i) { if(i.includes(`Wholesale-Pricing-${tradeStatus}`)) { return i } }) : null
	      let tradeDiscountAmount = 0

	      let currency = Money.getCurrency();
	      let vatStatus = Money.getVat();

	      let discountAmount = 0;
	      let price =  Currency.convert(discountAmount, 'GBP', currency);
	      let vatPrice =  Currency.convert(discountAmount * 1.2, 'GBP', currency);

	      // let price = Currency.formatMoney((product.price_min  tradeDiscountAmount * 100), Currency.money_format[currency]);
	      // let vatPrice = currency != 'GBP' ? (product.price_min * tradeDiscountAmount * 100) : Currency.formatMoney((product.price_min * tradeDiscountAmount * 100) * 1.2, Currency.money_format[currency]);
	      let bundleTag = product.tags.filter(function(i) { if(i.includes('infinite-adv')) { return i } });

	      let bundle = product.tags.filter(function(i) { if(i.includes('infinite-adv-')) { return i } })
	      let bundleAmount = bundle.length > 0 ? parseInt(bundle[0].replace('infinite-adv-', '')) : null
		  
	      products = products + `
	          <li class="boost-custom__product col-md-one-fourth col-one-half pl-10-medium pl-0 ${i > 3 ? 'd-md-none' : ''}" aria-label="products: ${product.title}" data-id="${product.id}">
	            <div class="width-whole">
	              <a class="font-text-decoration__none" href="/products/${product.handle}${product.variants.length > 0 ? `?variant=${product.variants[0].id}` : ''}">
	              	<div class="relative">
	              		<div class="width-whole">
	              			<div class="image-wrapper-100">
	              				${product.featured_image ? `<img src="${product.featured_image.url}" alt="${product.title}">` : ``}
	              			</div>
	              		</div>
	                </div>
	                <p class="text-standard font-semibold mb-5 font-small font-small-plus-large line-height">${product.title}</p>
	                ${tradeStatus && !(bundle.length > 0) ? '<p class="font-small font-green discount-text">Trade Price</p>' : ''}

	                <p 
	                	data-amount="${product.price_min * 100}"
	                	data-discount="${tradeDiscountAmount}"
	                	data-vat-default="main"
	                	class="line-height font-small-plus font-small-plus-large font-green price">${vatStatus == 'inc' ? vatPrice : price}</p> 

	                ${bundle.length > 0 && !tradeStatus ? `<p class="font-small font-green discount-text">+${bundleAmount}% Bundle Discount at Checkout </p>` : ''}
	                	
	                	<p 
	                		data-amount="${product.price_min * 100}"
	                		data-discount="${tradeDiscountAmount}"
	                		data-vat-default="second"
	                		class="font-small line-height font-light-grey money price">${vatStatus == 'inc' ? price : vatPrice}</p> 
	              </a>
	            </div>
	          </li>`
	    }
	    // let total = result.total_product
	    products = products + `
	      <li class="pb-20 boost-pfs-search-suggestion-item boost-pfs-ui-item ui-menu-item width-whole ">
	      	<div class="boost-custom__btn width-whole std-btn std-btn--black">
	        	<a class="boost-custom__view-all font-text-decoration__none width-whole text-center" href="/search?q=${term}">View All</a>
	      	</div>
	      </li>`
	  }
	  products = products + '</ul></li>';
	  return products
	},

	initSuggestions: function(suggestions, mobile) {
	  let link = `<li data-group="suggestions-custom" class="col-one-whole col-md-one-eigth ${mobile ? 'd-md-none d-block' : 'd-md-block d-none'}" aria-label="Suggestions">
	        <ul class="pl-10-medium pl-0" aria-hidden="true" aria-expanded="false">
	        <li class="boost-custom__title text-extra-bold mb-20" aria-label="Suggestions">Suggestions</li>`;
	  if(suggestions.length > 0) {
	    for(let suggestion of suggestions) {
	      link = link + `
	        <li class="mb-10 font-text-decoration__none" aria-label="${suggestion}: ${suggestion}" data-id="${suggestion}">
	          <a class="font-text-decoration__none font-light" href="/search?q=${encodeURI(suggestion)}" tabindex="-1" class="ui-menu-item-wrapper">
	            ${suggestion}
	          </a>
	        </li>`
	    }
	  }
	  link = link + '</ul></li>'
	  return link
	},

	initLinks: function(arr, name) {
	  let link = `<li data-group="links-custom" class="col-one-whole col-md-one-eigth" aria-label="${name}">
	        <ul class="pl-10-medium pl-0"  aria-hidden="true" aria-expanded="false">
	        <li class="boost-custom__title text-extra-bold mb-20" aria-label="${name}">${name}</li>`;
	  if(arr.length > 0) {
	    for(let item of arr) {
	      link = link + `
	        <li class="mb-10 font-text-decoration__none" aria-label="${name}: ${item.title}" data-id="${item.id}">
	          <a class="font-text-decoration__none font-light" href="${name == 'Information' ? item.url : `/collections/${item.handle}`}" tabindex="-1" >
	            ${item.title}
	          </a>
	        </li>`
	    }
	  }
	  link = link + '</ul></li>'

	  return link
	},

	updateOrdersCard: function(card, trackingData, orderLink, enable=true, multiple=false) {
		const trackingStatus = {
		  'NOT_TRACKED': {
		    'title': 'Sent - Not Tracked',
		    'color': 'Orange',
		    'description': 'The package has been sent however tracking is not available'
		  },
		  'TRACKING NOT AVAILABLE': {
		    'title': 'Sent - Tracking Currently Unavailable',
		    'color': 'Orange',
		    'description': 'The package has been sent however tracking is not available'
		  },
		  'UNFULFILLLED': {
		    'title': 'Order Received',
		    'color': 'Yellow',
		    'description': 'The order has been received and will be shipped shortly'
		  },
		  'DELIVERED': {
		    'title': 'Delivered',
		    'color': 'Green',
		    'description': 'The package has been delivered'
		  },
		  'OUT FOR DELIVERY': {
		    'title': 'Out for Delivery',
		    'color': 'Green Orange',
		    'description': 'The package is with the courier being delivered today'
		  },
		  'CONFIRMED AT DEPOT': {
		    'title': 'At the DPD Depot',
		    'color': 'Orange',
		    'description': 'The package is at the courier depot'
		  },
		  'HUB SCAN': {
		    'title': 'At the Sorting Hub',
		    'color': 'Orange',
		    'description': 'The package is at the sorting hub'
		  },
		  'DEPOT OUTBOUND': {
		    'title': 'Left the DPD Depot',
		    'color': 'Orange',
		    'description': 'The package has left the DPD depot and is on route'
		  },
		  'COLLECTED SELF LABELLER': {
		    'title': 'Shipped',
		    'color': 'Orange',
		    'description':
		        'The package has left Window Cleaning Warehouse and is on the way to the DPD depot'
		  },
		  'LABEL APPLIED': {
		    'title': 'New Label Applied',
		    'color': 'Orange',
		    'description': 'New parcel label applied to package'
		  },
		  'TRAILER SCANNED': {
		    'title': 'Trailer Scanned',
		    'color': 'Orange',
		    'description': 'New package is on route'
		  },
		  'FAILED PREMISES CLOSED': {
		    'title': 'Delivery Failed',
		    'color': 'Red Orange',
		    'description':
		        'The package could not be delivered as the premises was closed'
		  },
		  'FAILED NOTIFICATION RECEIVED': {
		    'title': 'Delivery Failed',
		    'color': 'Red Orange',
		    'description': 'The package could not be delivered'
		  },
		  'PARCEL RECONSIGNED RTC': {
		    'title': 'Parcel Reconsigned',
		    'color': 'Red Orange',
		    'description':
		        'There has been a delivery problem and the package is being returned to Window Cleaning Warehouse'
		  },
		  'HELD DAMAGED PARCEL': {
		    'title': 'Parcel Damaged',
		    'color': 'Red Orange',
		    'description':
		        'The package has been damaged during delivery and is being held'
		  },
		  'HELD IN DEPOT': {
		    'title': 'Parcel Delayed',
		    'color': 'Red Orange',
		    'description': 'The package has been delayed by the courier'
		  },
		  'PARCEL DATA': {
		    'title': 'Ready to be Shipped/Shipped',
		    'color': 'Orange',
		    'description':
		        'The order has been packed and ready to hand/has just been given to the courier'
		  },
		  'CANCELLED': {
		  	'title': 'Cancelled',
		  	'color': 'Red',
		  	'description': 'The order has been cancelled'
		  }
		}

		const defaultTracking = {
	    	'title': 'Sent - Not Tracked',
	    	'color': 'linear-gradient(58deg, rgba(0,0,0,1) 0%, rgba(41,41,41,1) 35%, rgba(0,0,0,1) 100%)',
	    	'description': 'The package has been sent. Tracking is not available'
	  	}

		const cardItem = card.querySelector('.order-card-item');
		const refData = trackingData['type'] in trackingStatus ? trackingStatus[trackingData['type']] : defaultTracking
		const trackingDate = 'date' in trackingData ? new Date(trackingData['date']) : null
		const trackingDateFormatted = trackingDate ? trackingDate.toLocaleString() : null

		let orderCard = `
			<a class="height-whole font-text-decoration__none" href="${orderLink}">
			<div class="pl-30 pr-30 pt-20 pb-20 height-whole ${!multiple ? 'd-none order-card-link' : 'd-none order-card-link'}" style="background-color: ${refData['color']};">
				<p class="font-medium-plus text-extra-bold font-white mb-10">${card.getAttribute('data-order-id')}</p>
				<p class="font-white mb-5"><span class="order-status text-extra-bold font-medium">${refData['title']}</span></p>
				<p class="font-white font-small"><span class="order-last-updated">${trackingDateFormatted ? '<span class="text-extra-bold">Last Updated:</span> ' + trackingDateFormatted : ''}</span></p>
				<p class="font-white font-small"><span class="order-location">${'locality' in trackingData ? '<span class="text-extra-bold">Location:</span> ' + trackingData['locality'] + ', ' + trackingData['countrycode'] : ''}</span></p>
			</div>
			</a>
		`

		cardItem.innerHTML = cardItem.innerHTML + orderCard
		if(enable) {
			this.enableCard(card, multiple);
		}
	},

	enableCard: function(card, multiple) {
		const cardItem = card.querySelector('.order-card-item');
		const cardLoading = card.querySelector('.order-loading');
		if(cardLoading) {
			cardLoading.remove()
		}

		if(multiple) {
			let randomId = (Math.random() + 1).toString(36).substring(7);
			let cardContainer = card.closest('.order-card');
			let arrowSvg = '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="444.819px" height="444.819px" viewBox="0 0 444.819 444.819" style="enable-background:new 0 0 444.819 444.819;" xml:space="preserve"><g><path d="M434.252,114.203l-21.409-21.416c-7.419-7.04-16.084-10.561-25.975-10.561c-10.095,0-18.657,3.521-25.7,10.561L222.41,231.549L83.653,92.791c-7.042-7.04-15.606-10.561-25.697-10.561c-9.896,0-18.559,3.521-25.979,10.561l-21.128,21.416C3.615,121.436,0,130.099,0,140.188c0,10.277,3.619,18.842,10.848,25.693l185.864,185.865c6.855,7.23,15.416,10.848,25.697,10.848c10.088,0,18.75-3.617,25.977-10.848l185.865-185.865c7.043-7.044,10.567-15.608,10.567-25.693C444.819,130.287,441.295,121.629,434.252,114.203z"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>'

			card.innerHTML = card.innerHTML + `
				<button aria-label="Previous" class="glider-prev glider-prev-${randomId}">${arrowSvg}</button>
				<button aria-label="Next" class="glider-next glider-next-${randomId}">${arrowSvg}</button>
			`

			const glider = new Glider(card.querySelector('.order-card-item'), {
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  draggable: false,
			  arrows: {
			    prev: '.glider-prev-' + randomId,
			    next: '.glider-next-' + randomId
			  }
			});

			const cardLinks = glider.ele.querySelectorAll('.order-card-link');
			for (var j = 0; j < cardLinks.length; j++) {
				fadeIn(cardLinks[j], 'block');
			}

		} else {
			if(cardLoading) {
				cardLoading.remove()
			}

			const cardLinks = cardItem.querySelectorAll('.order-card-link');
			for (var j = 0; j < cardLinks.length; j++) {
				fadeIn(cardLinks[j], 'block');
			}
		}
	},

	showOrder: function() {
		let orders = document.querySelector('.orders');
		if(orders) {
			orders.addEventListener('glider-loaded', function(event) {
				orders.style.height = 'auto';
				fadeIn(orders, 'block');
			});
		}
	},

	orders: async function() {
		const orderCards = document.querySelectorAll('.order-card');
		const orderDataObj = Cookies.getCookie('orderData') ? JSON.parse(Cookies.getCookie('orderData')) : {};
		this.showOrder();

		for (var i = orderCards.length - 1; i >= 0; i--) {
			let orderCard = orderCards[i];
			let orderData = orderCard.querySelectorAll('.order-card-data');
			let orderLink = orderCard.getAttribute('data-order-link');

			if(orderCard.getAttribute('data-order-cancelled') == 'true') {
				// Order cancelled
				this.updateOrdersCard(orderCard, {'type': 'CANCELLED'}, orderLink)
				this.enableCard(orderCard, false);
			} else if(orderCard.getAttribute('data-fulfillment-status') == 'null') {
				// Order unfulfilled
				this.updateOrdersCard(orderCard, {'type': 'UNFULFILLLED'}, orderLink);
				this.enableCard(orderCard, false);
			} else {
				// Order has partial fulfillment
				let partialFullfill = orderCard.getAttribute('data-fulfillment-status') == 'partial' ? true : false;
				let orderData = orderCard.querySelectorAll('.order-card-data');
				for (var j = 0; j < orderData.length; j++) {

					if(orderData[j].getAttribute('data-tracking-id')) {
						let ids = orderData[j].getAttribute('data-tracking-id');

						if(orderDataObj.hasOwnProperty(`order-${ids}`)) {
							let latestTrackingEvent = orderDataObj[`order-${ids}`];
							if(partialFullfill && j == orderData.length - 1) {
								this.updateOrdersCard(orderCard, {'type': 'UNFULFILLLED'}, orderLink, false, true);
							}
							this.updateOrdersCard(orderCard, latestTrackingEvent, orderLink, j == orderData.length - 1, orderData.length > 1)

						} else {
							let trackingDetails = await makeRequest('GET', `http://europe-west2-wcw-water.cloudfunctions.net/order-check?id=${ids}`);
							if(trackingDetails) {
								let trackingDetailsObj = JSON.parse(trackingDetails);
								
								if(trackingDetailsObj['trackingresponse']) {
									if('error' in trackingDetailsObj['trackingresponse']['trackingdetails']['trackingdetail']) {
										this.updateOrdersCard(orderCard, {'type': 'TRACKING NOT AVAILABLE'}, orderLink);
									} else {
										let trackingEvents = trackingDetailsObj['trackingresponse']['trackingdetails']['trackingdetail']['trackingevents']['trackingevent'];
										if(trackingEvents.length > 0) {
											let latestTrackingEvent = trackingEvents[0];

											orderDataObj[`order-${ids}`] = latestTrackingEvent
											if(partialFullfill && j == orderData.length - 1) {
												this.updateOrdersCard(orderCard, {'type': 'UNFULFILLLED'}, orderLink, false, true);
											}
											this.updateOrdersCard(orderCard, latestTrackingEvent, orderLink, j == orderData.length - 1, orderData.length > 1)
										} else {
											// Tracking not available
											this.updateOrdersCard(orderCard, {'type': 'TRACKING NOT AVAILABLE'}, orderLink);
										}
									}
								} else {
									// Tracking not available
									this.updateOrdersCard(orderCard, {'type': 'TRACKING NOT AVAILABLE'}, orderLink);
								}
							} else {
								// Tracking not available
								this.updateOrdersCard(orderCard, {'type': 'NOT_TRACKED'}, orderLink);
							}
						}


					} else {	
						// Not tracked or royal mail
						this.updateOrdersCard(orderCard, {'type': 'NOT_TRACKED'}, orderLink);
					}
				}
			}
		}
		Cookies.setCookie('orderData', JSON.stringify(orderDataObj), 0.5);
	},

	updateKlarna: function(price) {
		const klarnas = document.querySelectorAll('klarna-placement');
		for (let i = 0; i < klarnas.length; i++) {
			klarnas[i].dataset.purchaseAmount = price;
		}

		if(window.Klarna && window.Klarna.OnsiteMessaging) {
			window.Klarna.OnsiteMessaging.refresh()
		}
	}
}


;
const Product = {
	init: function(section, productData=null) {
		window['fullProduct'] = productData ? productData : fullProduct;

		let radios = section.querySelectorAll('[type="radio"]');
		for (var i = 0; i < radios.length; i++) {
			radios[i].addEventListener('change', function() {
				let bundleSelects = section.querySelectorAll('.bundle-select');
				this.variantSelector(radios, section, false);
				this.workoutBundlePrice(bundleSelects, section);
			}.bind(this));
		}
		this.variantSelector(radios, section);
		this.changeDots(section);
		this.changeImages(section);
		this.addToRecentlyViewed();
		this.initBundleProduct(section);
		this.vanInit(section);
		this.highlights(section);
		FinanceUtils.workoutFinance(true);
	},

	opacityDots: function(dots, slideId) {
		for (var i = 0; i < dots.length; i++) {
			if(dots[i].getAttribute('data-slide-id') == slideId) {
				dots[i].classList.add('glide__slide--custom-active');
			} else {
				dots[i].classList.remove('glide__slide--custom-active');
			}
		}
	},

	changeDots: function(section) {
		let dots = section.querySelectorAll('.glider__img-dot');
		let opacityDots = this.opacityDots
		for (var i = 0; i < dots.length; i++) {
			dots[i].addEventListener('click', function() {
				try {
					let slideId = this.getAttribute('data-slide-id');
					window[window['fullProduct']['handle'] + '-dots'].scrollItem(parseInt(slideId), false);
					setTimeout(function() { window[window['fullProduct']['handle']].scrollItem(slideId, true) }, 10);
					opacityDots(dots, slideId)
				} catch(e) {}
			})
		}
	},

	changeImages: function(section) {
		let dots = section.querySelectorAll('.glider__img-dot');
		try {
			window[window['fullProduct']['handle']].ele.addEventListener('scroll', function() {
				window[window['fullProduct']['handle'] + '-dots'].scrollItem(parseInt(window[window['fullProduct']['handle']].slide), false);
				this.opacityDots(dots, parseInt(window[window['fullProduct']['handle']].slide))
			}.bind(this));
		} catch(e) {}
	},

	changeInput: function(disable, section, soldOut = false) {
		let submitBtn = section.querySelector('[type="submit"]');
		let submitBtnSwipe = submitBtn ? submitBtn.parentElement : null;
		let submitBtnNew = section.querySelector('.newpdp_bt');
		let button_price = section.querySelector('.buton_price .price');
		let buyBtn = section.querySelector('.shopify-payment-button__button');
		let soldOutAlternative = section.querySelector('[data-sold-out-alternative]');

		if (soldOutAlternative) {
			soldOutAlternative.classList.toggle('d-none', !disable);
		}

		if (disable) {
			// Disable main button
			if (submitBtn) {
				submitBtn.setAttribute('disabled', true);
				submitBtn.innerHTML = soldOut ? 'sold out' : 'sold out';
			}

			// Disable alternate button if it exists
			if (submitBtnNew) {
				submitBtnNew.setAttribute('disabled', true);
				submitBtnNew.innerHTML = soldOut ? 'sold out' : 'sold out';
			}

			// Match the server-rendered sold-out wrapper state.
			if (submitBtnSwipe) {
				submitBtnSwipe.classList.add('std-btn__swipe', 'std-btn-swipe');
				submitBtnSwipe.classList.add('std-btn__swipe--disabled');
			}

			// Disable buy button
			if (buyBtn) {
				buyBtn.setAttribute('disabled', true);
			}

		} else {
			// Enable main button
			if (submitBtn) {
				submitBtn.removeAttribute('disabled');
				submitBtn.innerHTML = submitBtn.getAttribute('data-add-to-cart') || 'Add to Cart';
			}

			// Enable alternate button and update with price
			if (submitBtnNew) {
				submitBtnNew.removeAttribute('disabled');

				const addToCartText = (submitBtnNew.getAttribute('data-add-to-cart') || '').trim();
				const price = button_price ? button_price.textContent.trim() : '';

				if (addToCartText.toLowerCase() === 'add to cart') {
					submitBtnNew.innerHTML = `${addToCartText} | ${price}`;
				} else {
					submitBtnNew.innerHTML = addToCartText || 'Add to Cart';
				}
			}

			// Restore the same wrapper state as an initially available variant.
			if (submitBtnSwipe) {
				submitBtnSwipe.classList.remove('std-btn__swipe', 'std-btn-swipe', 'std-btn__swipe--disabled');
			}

			// Enable buy button
			if (buyBtn) {
				buyBtn.removeAttribute('disabled');
			}
		}
	},

	updatePriceEl(el, gbpPrice, amount, altPrice, price) {
		if(el) {
			el.setAttribute('data-gbp-price', gbpPrice.includes('&pound;') ? gbpPrice.replace('&pound;', '£') : gbpPrice);
			el.setAttribute('data-amount', amount);
			el.setAttribute('data-alt-price', altPrice.includes('&pound;') ? altPrice.replace('&pound;', '£') : altPrice);
			price = price.includes('&pound;') ? price.replace('&pound;', '£') : price;
			el.innerHTML = price;
		}
	},

	updatePrice: function(foundVariant) {
		const productPrices = document.querySelectorAll('#product-template .price');

		let currencyCode = 'USD'; // Default to USD for safety
		if (typeof Money !== 'undefined' && Money.getCurrency) {
			currencyCode = Money.getCurrency();
		}
		
		function formatMoney(amountInCents, locale = 'en-US') {
			const amountInDollars = amountInCents / 100;
			const formatter = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currencyCode, 
			});
			
			return formatter.format(amountInDollars);
		}
		let discount = 0;
		if(!(foundVariant.title.includes('Pack of') && !foundVariant.title.includes('Box of'))) {
			let tradeStatus = document.querySelector('#custom-boost-trade') ? document.querySelector('#custom-boost-trade').getAttribute('data-custom-boost-trade') : null;
			let tradeDiscount = tradeStatus ? fullProduct.tags.filter(function(i) { if(i.includes(`Wholesale-Pricing-${tradeStatus}`)) { return i } }) : null;
	      	discount = tradeStatus ? tradeDiscount.length > 0 ? (parseFloat(tradeDiscount[0].replace(`Wholesale-Pricing-${tradeStatus}-`, ''))) : 20 : 0
		}

		for (var i = 0; i < productPrices.length; i++) {
			if(productPrices[i].classList.contains('price-compare')) {
				productPrices[i].setAttribute('data-amount', foundVariant.compare_at_price > foundVariant.price ? foundVariant.compare_at_price : 0);
				foundVariant.compare_at_price ? foundVariant.compare_at_price > foundVariant.price ? productPrices[i].closest('.sale-price').classList.remove('d-none') : productPrices[i].closest('.sale-price').classList.add('d-none') : productPrices[i].closest('.sale-price').classList.add('d-none');
			} else {
				productPrices[i].setAttribute('data-amount', foundVariant.price);
				productPrices[i].setAttribute('data-discount', discount);
				this.updateProductPromos(document, foundVariant.price);
			}
			let amountOff = 0;
			const currentPrice = foundVariant.price;
			const comparePrice = foundVariant.compare_at_price;
			const savingsElements = document.querySelectorAll('#product-template .amount-save .discount-price');
			const amountSaveElements = document.querySelectorAll('#product-template .amount-save');
			const ComparePriceElements = document.querySelectorAll('#product-template .compare-price-wcw');
			if (comparePrice && comparePrice > currentPrice) {
				amountOff = comparePrice - currentPrice;
				
			}
			if (amountOff > 0) {
				const formattedAmountOff = formatMoney(amountOff);
			
				savingsElements.forEach(element => {
					element.setAttribute('data-amount',amountOff);
					element.textContent = formattedAmountOff;
					element.classList.remove('d-none'); 
				});
				amountSaveElements.forEach(element => {
					element.classList.remove('d-none');
				});
				ComparePriceElements.forEach(element => {
					element.classList.add('d-none');
				});
			} else {
				savingsElements.forEach(element => {
					element.setAttribute('data-amount', 0);
					element.textContent = '';
					element.classList.add('d-none');
				});
				 amountSaveElements.forEach(element => {
					element.classList.add('d-none');
				});
				ComparePriceElements.forEach(element => {
					element.classList.remove('d-none');
				});
			}
		}

		document.querySelectorAll('#product-template [data-sale-label]').forEach(element => {
			element.textContent = foundVariant.compare_at_price > foundVariant.price ? element.getAttribute('data-sale-label') : '';
		});

		Global.updateVat();
		Global.updateKlarna((foundVariant.price * 1.2).toFixed(0));

		// const priceMain = document.querySelector('#product-template .price-main');
		// const priceSecond = document.querySelector('#product-template .price-second');
		// const priceCompare = document.querySelector('#product-template .price-compare');		
		// // Get trade discount


 	// 	let priceWithDisc = foundVariant.title.includes('Pack of') || foundVariant.title.includes('Box of') ? foundVariant.price : foundVariant.price * (100/100*discount);
		// let priceWithDiscAndVat = (priceWithDisc * 1.2).toFixed(0);

		// // Compare
		// let comparePriceWithDisc = foundVariant.title.includes('Pack of') || foundVariant.title.includes('Box of') ? foundVariant.compare_at_price : foundVariant.compare_at_price * (100/100*discount);
		// let comparePriceWithDiscAndVat = (comparePriceWithDisc * 1.2).toFixed(0);

		// let currency = Money.getCurrency();
		// let vatStatus = Money.getVat();

		// let priceGbp = Currency.formatMoney(priceWithDisc, Currency.money_format[currency]);
		// let priceGbpVat = Currency.formatMoney(priceWithDiscAndVat, Currency.money_format[currency]);

		// // Compare
		// let comparePriceGbp = Currency.formatMoney(comparePriceWithDisc, Currency.money_format[currency]);
		// let comparePriceGbpVat = Currency.formatMoney(comparePriceWithDiscAndVat, Currency.money_format[currency]);

		// if(currency != 'GBP') {
		// 	let price =  Currency.convert(priceWithDisc, 'GBP', currency);
		// 	let priceFormatted = Currency.formatMoney(price, Currency.money_format[currency]);

		// 	let comparePrice =  Currency.convert(comparePriceWithDisc, 'GBP', currency);
		// 	let comparePriceFormatted = Currency.formatMoney(comparePrice, Currency.money_format[currency]);

		// 	this.updatePriceEl(priceMain, priceGbp, priceWithDisc, priceGbpVat, priceFormatted);
		// 	this.updatePriceEl(priceCompare, comparePriceGbp, comparePriceWithDisc, comparePriceGbpVat, comparePriceFormatted);
		// } else {
		// 	let priceFormatted = Currency.formatMoney(priceWithDisc, Currency.money_format[currency]);
		// 	let priceFormattedVat = Currency.formatMoney(priceWithDiscAndVat, Currency.money_format[currency]);

		// 	let comparePriceFormatted = Currency.formatMoney(comparePriceWithDisc, Currency.money_format[currency]);
		// 	let comparePriceFormattedVat = Currency.formatMoney(comparePriceWithDiscAndVat, Currency.money_format[currency]);

		// 	if(vatStatus == 'exc') {
		// 		this.updatePriceEl(priceMain, priceGbp, priceWithDisc, priceGbpVat, priceFormatted);
		// 		this.updatePriceEl(priceSecond, priceGbpVat, priceWithDiscAndVat, priceGbp, priceFormattedVat);
		// 		if(foundVariant.compare_at_price) {
		// 			if(priceCompare) {
		// 			    priceCompare.parentNode.classList.remove('d-none')
		// 			}
		// 			this.updatePriceEl(priceCompare, comparePriceGbp, comparePriceWithDisc, comparePriceGbpVat, comparePriceFormatted);
		// 		} else {
		// 			if(priceCompare) {
		// 			    priceCompare.parentNode.classList.add('d-none')
		// 			}
		// 		}
		// 	} else {
		// 		console.log(priceGbpVat, priceWithDiscAndVat, priceGbp, priceFormattedVat)
		// 		this.updatePriceEl(priceSecond, priceGbp, priceWithDisc, priceGbpVat, priceFormatted);
		// 		console.log(priceMain, priceGbpVat, priceWithDiscAndVat, priceGbp, priceFormattedVat)
		// 		this.updatePriceEl(priceMain, priceGbpVat, priceWithDiscAndVat, priceGbp, priceFormattedVat);
		// 		if(foundVariant.compare_at_price) {
		// 			if(priceCompare) {
		// 			    priceCompare.parentNode.classList.remove('d-none')
		// 			}
		// 			this.updatePriceEl(priceCompare, comparePriceGbpVat, comparePriceWithDiscAndVat, comparePriceGbp, comparePriceFormattedVat);
		// 		} else {
		// 			if(priceCompare) {
		// 			    priceCompare.parentNode.classList.add('d-none')
		// 			}
		// 		}
		// 	}
		// }
	},

	getProduct: async function(handle) {
		const url = `/products/${handle}.js`;
		const product = await new Promise(function(resolve, reject) {
			makeRequest('GET', url)
			.then(function(res){
				return JSON.parse(res)
			})
			.then(function(res) {
				resolve(res)
			})
			.catch(function(err) {
				resolve(null)
			})
		});
		return product
	},

	workoutBundlePrice: function(bundleSelects, section, rules=false) {
		if(bundleSelects.length > 0) {
			let total = 0;
			let compareTotal = 0;
			// const priceMain = section.querySelector('.price-main');
			// const priceSecond = section.querySelector('.price-second');
			// const priceCompare = section.querySelector('.price-compare');

			let tradeStatus = document.querySelector('#custom-boost-trade') ? document.querySelector('#custom-boost-trade').getAttribute('data-custom-boost-trade') : null;
			let tradeDiscount = tradeStatus ? fullProduct.tags.filter(function(i) { if(i.includes(`Wholesale-Pricing-${tradeStatus}`)) { return i } }) : null;
			let discount = tradeStatus ? tradeDiscount.length > 0 ? parseFloat(tradeDiscount[0].replace(`Wholesale-Pricing-${tradeStatus}-`, '')) : 20 : 0;

			for (var i = 0; i < bundleSelects.length; i++) {
				let bundleSelect = bundleSelects[i];
				rules = bundleSelect.classList.contains('rules-select') ? true : rules;
				let selectedOption = bundleSelect.options[bundleSelect.selectedIndex];
				let selectedOptionPrice = selectedOption.getAttribute('data-price');
				let selectedOptionCompare = selectedOption.getAttribute('data-compare');

				total = selectedOptionPrice ? (parseInt(selectedOptionPrice) + total) : total;
				compareTotal = selectedOptionPrice ? (parseInt(selectedOptionCompare) + compareTotal) : compareTotal;
			}

			if(rules) {
				let productSelector = section.querySelector('.variant-select');
				let productsOption = productSelector.options[productSelector.selectedIndex];
				let productsOptionPrice = productsOption.getAttribute('data-product-price');
				// let productsOptionCompare = productsOption.getAttribute('data-product-compare');
				productsOptionPrice = Math.ceil(productsOptionPrice - (productsOptionPrice/100*discount))
				total = productsOptionPrice ? (total + parseInt(productsOptionPrice)) : total;
				// compareTotal = productsOptionCompare ? (parseInt(productsOptionCompare) + compareTotal) : compareTotal;
			}


			const productPrices = document.querySelectorAll('#product-template .price:not(.price-compare)');
			for (var i = 0; i < productPrices.length; i++) {
				let productPrice = productPrices[i];
				productPrice.setAttribute('data-discount', '0');
				productPrice.setAttribute('data-amount', Math.ceil(total));
				this.updateProductPromos(document, Math.ceil(total));
				// productPrice.setAttribute('data-discount', tradeDiscountAmount);
			}

			Global.updateVat();
			Global.updateKlarna((total * 1.2).toFixed(0));

			// let currency = Money.getCurrency();
			// let vatStatus = Money.getVat();

			// let priceGbp = Currency.formatMoney(total, Currency.money_format[currency]);	
			// let priceGbpVat = Currency.formatMoney(total * 1.2, Currency.money_format[currency]);

			// let comparePriceGbp = Currency.formatMoney(compareTotal, Currency.money_format[currency]);	
			// let comparePriceGbpVat = Currency.formatMoney(compareTotal * 1.2, Currency.money_format[currency]);

			// if(currency != 'GBP') {
			// 	let price =  Currency.convert(total, 'GBP', currency);
			// 	let priceFormatted = Currency.formatMoney(price, Currency.money_format[currency]);

			// 	let comparePrice =  Currency.convert(compareTotal, 'GBP', currency);
			// 	let comparePriceFormatted = Currency.formatMoney(comparePrice, Currency.money_format[currency]);

			// 	this.updatePriceEl(priceMain, priceGbp, total, priceGbpVat, priceFormatted);
			// 	if(compareTotal > total) {
			// 		if(priceCompare) {
			// 		    priceCompare.parentNode.classList.remove('d-none')
			// 		}
			// 		this.updatePriceEl(priceCompare, comparePriceGbp, compareTotal, comparePriceGbpVat, comparePriceFormatted);
			// 	} else {
			// 		if(priceCompare) {
			// 		    priceCompare.parentNode.classList.add('d-none')
			// 		}
			// 	}
			// } else {
			// 	let priceFormatted = Currency.formatMoney(total, Currency.money_format[currency]);
			// 	let priceFormattedVat = Currency.formatMoney(total * 1.2, Currency.money_format[currency]);

			// 	let comparePriceFormatted = Currency.formatMoney(compareTotal, Currency.money_format[currency]);
			// 	let comparePriceFormattedVat = Currency.formatMoney(compareTotal * 1.2, Currency.money_format[currency]);

			// 	if(vatStatus == 'exc') {

			// 		this.updatePriceEl(priceMain, priceGbp, total, priceGbpVat, priceFormatted);
			// 		this.updatePriceEl(priceSecond, priceGbpVat, total * 1.2, priceGbp, priceFormattedVat);

			// 		if(compareTotal > total) {
			// 			if(priceCompare) {
			// 			    priceCompare.parentNode.classList.remove('d-none')
			// 			}
			// 			this.updatePriceEl(priceCompare, comparePriceGbp, compareTotal, comparePriceGbpVat, comparePriceFormatted);
			// 		} else {
			// 			if(priceCompare) {
			// 			    priceCompare.parentNode.classList.add('d-none')
			// 			}
			// 		}

			// 	} else {
			// 		this.updatePriceEl(priceSecond, priceGbp, total, priceGbpVat, priceFormatted);
			// 		this.updatePriceEl(priceMain, priceGbpVat, total * 1.2, priceGbp, priceFormattedVat);

			// 		if(compareTotal > total) {
			// 			if(priceCompare) {
			// 			    priceCompare.parentNode.classList.remove('d-none')
			// 			}
			// 			this.updatePriceEl(priceCompare, comparePriceGbpVat, compareTotal * 1.2, comparePriceGbp, comparePriceFormattedVat);
			// 		} else {
			// 			if(priceCompare) {
			// 			    priceCompare.parentNode.classList.add('d-none')
			// 			}
			// 		}
			// 	}
			// }
		}
	},

	createBundle: async function(bundle) {
		const products = {};
		let bundleSection = '';
		let tradeStatus = document.querySelector('#custom-boost-trade') ? document.querySelector('#custom-boost-trade').getAttribute('data-custom-boost-trade') : null;

		for (var i = 0; i < bundle['option'].length; i++) {
			let option = bundle['option'][i];
			let currency = Money.getCurrency();
			bundleSection = bundleSection +  `
				<div class="bundle__option">
					<div data-bundle-option="${option['option-name'].replace(' ', '')}" class="bundle__img bundle-image-container"">
						<a href="#">
							<img alt="${option['option-name']}" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4">
						</a>
					</div>
					<div class="bundle__select">
					<label for="${option['option-name'].replace(' ', '')}">${option['option-name']}</label>
					<select class="select-std bundle-select" id="${option['option-name'].replace(' ', '')}" name="id[]">
			`;

			for (var j = 0; j < option['variant'].length; j++) {
				let variant = option['variant'][j];
				let product = products[variant['product']] ? products[variant['product']] : await this.getProduct(variant['product']);
				
				if(product) {
					products[variant['product']] = product;
					let selectedVariant = product['variants'].find(function(x) { return x.id == variant['id'].replace('gid://shopify/ProductVariant/', '') });
					if(selectedVariant) {
						let tradeDiscount = tradeStatus ? product.tags.filter(function(i) { if(i.includes(`Wholesale-Pricing-${tradeStatus}`)) { return i } }) : null;
						let discount = tradeStatus ? tradeDiscount.length > 0 ? parseInt(tradeDiscount[0].replace(`Wholesale-Pricing-${tradeStatus}-`, '')) : 20 : 0;

						let priceFormatted = Currency.formatMoney(Math.ceil(selectedVariant.price - (selectedVariant.price / (100/discount))), Currency.money_format[currency]);
						let tempOption = `<option ${selectedVariant.available ? '' : 'disabled'} data-price="${selectedVariant.price - (selectedVariant.price / (100/discount))}" data-link-src="${product.url}" data-image-src="${selectedVariant.featured_image ? selectedVariant.featured_image.src : product.featured_image }" value="${selectedVariant.id}">${product.title} - ${variant.name} - ${priceFormatted} + VAT</option>`;
						bundleSection = bundleSection + tempOption;
					}
				}
			}

			bundleSection = bundleSection + `
				</select>
				</div>
			</div>
			`
		}

		return bundleSection;
	},

	initBundleProduct: function(section, rules=false) {
		const bundleSelects = section.querySelectorAll('.bundle-select');
		for (var i = 0; i < bundleSelects.length; i++) {
			bundleSelects[i].addEventListener('change', function() {
				this.updateBundleProduct(bundleSelects, section, rules);
			}.bind(this));
		}
		this.updateBundleProduct(bundleSelects, section, rules);
		this.storeBasePrice(section);
		this.bindQuantityPriceUpdate(section);
	},


    // Formats a raw price (in cents) into GBP currency string (e.g. £247.85)
	formatMoneyGBP: function(amount) {
		return '£' + (amount / 100).toFixed(2);
	},

    //////////////////////////////// MAJOR BUGS, BREAKS BUNDLES //////////////////////////////////


	// Updates the Add to Cart button text to always reflect the current button price
	refreshAddToCartButton: function(section) {
		const priceText = section.querySelector('.buton_price .price')?.textContent?.trim();
		const addToCartBtn = section.querySelector('.newpdp_bt');

		if (!addToCartBtn || addToCartBtn.disabled || !priceText) return;

		const baseText = addToCartBtn.getAttribute('data-add-to-cart') || addToCartBtn.textContent.split('|')[0].trim();

		addToCartBtn.innerHTML = `${baseText} | ${priceText}`;

		console.log('🔄 Add to cart button refreshed:', addToCartBtn.innerHTML);
	},

	// Waits until a DOM element exists before executing logic that depends on it
	waitForElement: function(selector, callback, timeout = 3000) {
		const start = Date.now();

		const timer = setInterval(() => {
			const el = document.querySelector(selector);
			if (el) {
				clearInterval(timer);
				callback(el);
			}
			if (Date.now() - start > timeout) {
				clearInterval(timer);
				console.warn('⏱ Element not found:', selector);
			}
		}, 50);
	},

	// Stores the original button price once so quantity changes can be calculated reliably
	storeBasePrice: function(section) {
		this.waitForElement('.buton_price .price', (priceEl) => {

			if (!priceEl.hasAttribute('data-amount')) {
				console.warn('❌ priceEl has no data-amount');
				return;
			}

			if (!priceEl.hasAttribute('data-base-amount')) {
				const baseAmount = priceEl.getAttribute('data-amount');
				priceEl.setAttribute('data-base-amount', baseAmount);

				console.log('💾 Base button price stored:', baseAmount);
			}
		});
	},

	// Recalculates and updates the button price whenever quantity is changed via + / − or typing
	bindQuantityPriceUpdate: function(section) {
		const qtyInput = section.querySelector('.quantity-selector');
		const plusBtn  = section.querySelector('.quantity__plus');
		const minusBtn = section.querySelector('.quantity__minus');

		if (!qtyInput) return;

		this.waitForElement('.buton_price .price', (priceEl) => {

			const recalcPrice = () => {
				const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
				const baseAmount = parseInt(priceEl.getAttribute('data-base-amount'), 10);

				if (!baseAmount) return;

				const newAmount = baseAmount * qty;

				// Update data + UI
				priceEl.setAttribute('data-amount', newAmount);
				priceEl.innerHTML = this.formatMoneyGBP(newAmount);

				console.log('💰 Button price recalculated:', {
					qty,
					baseAmount,
					newAmount
				});

				// 🔥 THIS is what you want
				this.refreshAddToCartButton(section);

				// Optional VAT refresh
				if (window.Money && typeof Money.updateVat === 'function') {
					Money.updateVat(false);
				}
			};



			plusBtn?.addEventListener('click', () => setTimeout(recalcPrice, 10));
			minusBtn?.addEventListener('click', () => setTimeout(recalcPrice, 10));
			qtyInput.addEventListener('input', recalcPrice);
		});
	},

	updateBundleProduct: function(bundleSelects, section, rules) {
		for (var i = 0; i < bundleSelects.length; i++) {
			let select = bundleSelects[i];
			let selectedOption = select.options[select.selectedIndex];
			let selectedSelector = select.id;
			let bundleOption = section.querySelector(`[data-bundle-option="${selectedSelector}"]`);

			let imageEl = bundleOption.querySelector('img');
			let linkEl = bundleOption.querySelector('a');

			let selectedImage = selectedOption.getAttribute('data-image-src');
			let selectedLink = selectedOption.getAttribute('data-link-src');
			
			if(!selectedOption.value) {
				bundleOption.parentNode.querySelector('select').setAttribute('name', '')
			} else {
				bundleOption.parentNode.querySelector('select').setAttribute('name', 'id[]')
			}

			if(selectedImage) { 
				imageEl.setAttribute('src', selectedImage); 
				imageEl.classList.remove('d-none');
			} else {
				imageEl.setAttribute('src', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4'); 
				bundleOption.classList.add('d-none');
			}
			if(selectedLink) {
				linkEl.setAttribute('href', selectedLink); 
				bundleOption.classList.remove('d-none');
			} else {
				linkEl.setAttribute('href', '#'); 
				bundleOption.classList.add('d-none');
			}
		}

		// const priceMainEl = section.querySelector('.price-main');
		// const priceSecondEl = section.querySelector('.price-second');

		// setTimeout(function () {
		// 	const buttonPrice = section.querySelector('.buton_price .price')?.textContent?.trim();
		// 	const addToCartNew = section.querySelector('.newpdp_bt');
		// 	if (addToCartNew){
		// 		const addToCartText = addToCartNew.getAttribute('data-add-to-cart');
		// 		addToCartNew.innerHTML = `${addToCartText} | ${buttonPrice}`;
		// 		console.log('buttonPrice test:', buttonPrice);
		// 	}
		// }, 300);
		

		// 🔥 Re-apply quantity price after variant change
		setTimeout(() => {
			const qtyInput = section.querySelector('.quantity-selector');
			const priceEl  = section.querySelector('.buton_price .price');

			if (!qtyInput || !priceEl) return;

			const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

			// Always treat current variant price as BASE (qty = 1)
			const baseAmount = parseInt(priceEl.getAttribute('data-amount'), 10);
			if (!baseAmount) return;

			priceEl.setAttribute('data-base-amount', baseAmount);

			// Keep the raw amount in cents so the active VAT and currency setting is
			// applied consistently after a bundle option changes.
			const finalAmount = baseAmount * qty;
			priceEl.setAttribute('data-amount', finalAmount);
			Global.updateVat(false);
			this.refreshAddToCartButton(section);

			console.log('🔁 Variant change → qty reapplied', {
				qty,
				baseAmount,
				finalAmount
			});
		}, 350);

		const price = this.workoutBundlePrice(bundleSelects, section, rules);
	},

	initBundle: async function(bundleSelector, section, retry=false) {
		const infiniteAsset = bundleSelector.getAttribute('data-asset-url');
		// let infiniteOptions = retry ? null : Cookies.getCookie('infiniteOptions');
		infiniteOptions = await makeRequest('GET', 'https://' + infiniteAsset);
		let submitBtnSwipe = section.querySelector('.std-btn-swipe');
		const addToCart = section.querySelector('button[type="submit"]');
		const bundleProperties = section.querySelector('#bundle-properties');
		let infiniteFound = false;

		if(infiniteOptions) {
			let infiniteOptionsArr = JSON.parse(infiniteOptions);
			if(infiniteOptionsArr) {
				for (var i = 0; i < infiniteOptionsArr['options'].length; i++) {
					let option = infiniteOptionsArr['options'][i];
					if(option['product-id'] == 'gid://shopify/Product/' + window['fullProduct']['id']) {
						infiniteFound = true
						let bundleSection = await this.createBundle(option);
						bundleSelector.innerHTML = bundleSection;
						const sale = document.querySelector('#product-template .sale-price');
						console.log(sale)
						if(sale) {
							sale.remove();
						}
					}	
				}
			}
		}
		if(infiniteFound) {
			this.initBundleProduct(section);
			if(submitBtnSwipe) {
				submitBtnSwipe.classList.remove('std-btn__swipe--disabled');
			}
			if(addToCart) {
				addToCart.removeAttribute('disabled');
			}
			bundleProperties.setAttribute('value', `${window['fullProduct'].title.replace('"', '')}##${(Math.random() + 1).toString(36).substring(3)}`)
		} else if(!retry) {
			this.initBundle(bundleSelector, section, true);
		}
	},

	createRuleOption: async function(ruleShows, products) {
		let tradeStatus = document.querySelector('#custom-boost-trade') ? document.querySelector('#custom-boost-trade').getAttribute('data-custom-boost-trade') : null;

		let option = `
		<div class="bundle__option">
			<div data-bundle-option="${ruleShows['name'].replace(' ', '')}" class="bundle__img bundle-image-container">
				<a href="">
					<img alt="${ruleShows['name']}" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4">
				</a>
			</div>
			<div class="bundle__select">
			<label for="${ruleShows['name'].replace(' ', '')}">${ruleShows['name']}</label>
			<select class="select-std bundle-select rules-select" id="${ruleShows['name'].replace(' ', '')}" name="id[]">
			<option disabled selected hidden>None</option><option value="">None</option>
		`;
		let currency = Money.getCurrency();

		for (var j = 0; j < ruleShows['show'].length; j++) {
			let rule = ruleShows['show'][j];
			let product = products[rule['handle']] ? products[rule['handle']] : rule['handle'] ? await this.getProduct(rule['handle']) : null;
			if(product) {
				products[rule['handle']] = product;
				let selectedVariant = product['variants'].find(function(x) { return x.id == rule['variant'] });

				if(selectedVariant) {
					let tradeDiscount = tradeStatus ? product.tags.filter(function(i) { if(i.includes(`Wholesale-Pricing-${tradeStatus}`)) { return i } }) : null;
					let discount = tradeStatus ? tradeDiscount.length > 0 ? parseFloat(tradeDiscount[0].replace(`Wholesale-Pricing-${tradeStatus}-`, '')) : 20 : 0;

					let priceFormatted = Currency.formatMoney(Math.ceil(selectedVariant.price - (selectedVariant.price / (100/discount))), Currency.money_format[currency]);
					let tempOption = `<option data-price="${Math.ceil(selectedVariant.price - (selectedVariant.price / (100/discount)))}" ${selectedVariant.available ? '' : 'disabled'} data-link-src="${product.url}" data-image-src="${selectedVariant.featured_image ? selectedVariant.featured_image.src : product.featured_image }" value="${selectedVariant.id}">${product.title} - ${ruleShows['show'][j]['show']} - ${priceFormatted} + VAT</option>`;
					option = option + tempOption;
				}
			}
		}

		option = option + `
			</select>
			</div>
		</div>
		`

		return [ products, option ]
	},

	checkInfiniteOptions: async function(section) {
		let infiniteRules = '';
		let infiniteEl = section.querySelector('#infinite');
		let selector = section.querySelector('.variant-select');
		let shopifyPaymentBtn = section.querySelector('.shopify-payment-button');
		let products = {};

		if(infiniteEl && window['rules']) {
			for (var i = 0; i < window['rules']['rules'].length; i++) {
				let rule = window['rules']['rules'][i];
				for (var j = 0; j < rule['conditions'].length; j++) {
					let condition = rule['conditions'][j]
					if(condition['type'] == "tag") {
						if(window['fullProduct']['tags'].includes(condition['rule'])) {
							if(rule['name']=='Angle Neck' && window['fullProduct']['tags'].includes('Pole Options Orbital') && condition['rule']=='Pole Options'){ 		// Added by Aryan
								continue; 	
							}
							let ruleData = await this.createRuleOption(rule, products);
							infiniteRules = infiniteRules + ruleData[1];
							products = ruleData[0];
						};
					} else if(condition['type'] == "handle") {
						if(condition['rule'] == window['fullProduct']['handle']) {
							let ruleData = await this.createRuleOption(rule, products);
							infiniteRules = infiniteRules + ruleData[1];
							products = ruleData[0];
						};
					} else if(condition['type'] == "type") {
						if(condition['rule'] == window['fullProduct']['type']) {
							let ruleData = await this.createRuleOption(rule, products);
							infiniteRules = infiniteRules + ruleData[1];
							products = ruleData[0];
						};
					} else {
						if(condition['rule'] == window['fullProduct']['title']) {
							let ruleData = await this.createRuleOption(rule, products);
							infiniteRules = infiniteRules + ruleData[1];
							products = ruleData[0];
						};
					};
				}
			}	

			if(infiniteRules) {
				infiniteEl.innerHTML = infiniteRules;
				selector.setAttribute('name', 'id[]');
				if(shopifyPaymentBtn) {
					shopifyPaymentBtn.parentNode.removeChild(shopifyPaymentBtn);
				}
				this.initBundleProduct(section, true);
			}
		}
	},

	variantSelector: async function(radios, section, first=true) {
		if(window['fullProduct']) {
			let variantSelect = section.querySelector('.variant-select');
			let dots = section.querySelectorAll('.glider__img-dot');
			const sku = section.querySelector('#sku');
			const bundleSelector = section.querySelector('#bundle-block');
			const productData = window['fullProduct']['variants'];
			const addToCart = section.querySelector('[type="submit"]');
			let foundVariant;

			if(bundleSelector) {
				if(first) { this.initBundle(bundleSelector, section) };
			} else {
				if(first) { 
					this.checkInfiniteOptions(section) 
					foundVariant = window['fullProduct']['variants'][0];
				};
				if(radios.length > 0) {
					let options = []

					for(var i=0;i<radios.length;i++) {
						if(radios[i].checked) {
							options.push(radios[i].value)
						}
					}

					let urlParams = new URLSearchParams(window.location.search);
					let variantIdParam = urlParams.get('variant');

					if(first && (variantIdParam && !window.location.pathname.includes('/blogs'))) {
						foundVariant = fullProduct['variants'].find(function(x) { return x['id'] == variantIdParam });
					} else {
						foundVariant = this.findVariant(options, radios);
					}
				}

				if(foundVariant) {
					window['foundVariant'] = foundVariant;
					await this.refreshProductMediaSection(foundVariant.id, section);
					this.updateOptionSelectors(section);
					this.updatePrice(foundVariant);
					// 🔥 Apply quantity on variant change (FIX)
					setTimeout(() => {
					const qtyInput = section.querySelector('.quantity-selector');
					const priceEl  = section.querySelector('.buton_price .price');

					if (!qtyInput || !priceEl) return;

					const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);

					// Variant price is always base (qty = 1)
					const baseAmount = parseInt(priceEl.getAttribute('data-amount'), 10);
					if (!baseAmount) return;

					// Store new base
					priceEl.setAttribute('data-base-amount', baseAmount);

					// Keep the amount in cents and let the shared VAT/currency formatter
					// render it. Writing a hard-coded GBP value here bypassed VAT after
					// a variant change.
					const finalAmount = baseAmount * qty;
					priceEl.setAttribute('data-amount', finalAmount);
					Global.updateVat(false);
					this.refreshAddToCartButton(section);

					console.log('🔁 Variant change (single) → qty applied', {
						qty,
						baseAmount,
						finalAmount
					});

					}, 200);
					this.vanInit(section);
					if(sku && foundVariant.sku) {
						sku.innerHTML = foundVariant.sku;
					}
					if(section.querySelector('.finance-block')) {
						section.querySelector('.finance-block').setAttribute('data-finance-price', foundVariant.price);
						FinanceUtils.workoutFinance();
					}

					window.history.replaceState('', '', `${window.location.pathname}?variant=${foundVariant.id}`);
					
					try {
					if(foundVariant['available']) {
						variantSelect.value = foundVariant.id

						
						// Update image if exists
						if(foundVariant.featured_image) {
							let imageId = foundVariant.featured_media.id;
							if(imageId && window[window['fullProduct']['handle']]) {
								try {
									let imageSlide = section.querySelector(`[data-image-id="${imageId}"]`)
									let imageSlideId = imageSlide.getAttribute('data-slide-id');
									window[window['fullProduct']['handle']].scrollItem(imageSlideId, true)
									// Update other selects
									window[window['fullProduct']['handle'] + '-dots'].scrollItem(parseInt(imageSlideId), false);
									this.opacityDots(dots, imageSlideId)
								} catch(e) {
									console.log(e)
								}
							}
						}
						
						this.changeInput(false, section);
					} else {
						this.changeInput(true, section, true);
					}
					} catch(e) {}

					this.updateFinance(section, foundVariant);
				} else {
					this.changeInput(true, section, true);
				}

				////////////////////////// Added by Company Dev ////////////////////////////
				// Hide unavailable variant options
				for (var i = 0; i < productData[0]['options'].length; i++) {
					for (var j = i + 1; j < productData[0]['options'].length; j++) {
						let variantSection = section.querySelector(`[data-variant-input="${j}"]`);
						if (variantSection) {
							let variantInputs = variantSection.querySelectorAll('input');
							let firstAvailableInput = null;

							for (var l = 0; l < variantInputs.length; l++) {
								let input = variantInputs[l];
								let value = input.value;
								let findVariant;

								if (j == 1) {
									let optionOne = document.querySelector(`[data-variant-input="0"] input:checked`);
									findVariant = productData.find(x => x['options'][j] == value && x['options'][0] == optionOne.value && x['available']);
								} else if (j == 2) {
									let optionOne = document.querySelector(`[data-variant-input="0"] input:checked`);
									let optionTwo = document.querySelector(`[data-variant-input="1"] input:checked`);
									findVariant = productData.find(x => x['options'][j] == value && x['options'][0] == optionOne.value && x['options'][1] == optionTwo.value && x['available']);
								}

								let label = input.id ? variantSection.querySelector(`label[for="${input.id}"]`) : input.closest('label');

								if (!findVariant) {
									if (label) label.style.display = 'none';
									input.style.display = 'none';
								} else {
									if (label) label.style.display = '';
									input.style.display = '';

									// Set firstAvailableInput if not already set
									if (!firstAvailableInput) {
										firstAvailableInput = input;
									}
								}
							}

							function isLabelVisible(input) {
								const id = input.getAttribute('id');
								if (!id) return false;
								const label = document.querySelector(`label[for="${id}"]`);
								if (!label) return false;
								return label.getClientRects().length > 0;
							}
							let selectedInput = Array.from(variantInputs).find(input => input.checked);

							let selectedInputIsHidden = !selectedInput || !isLabelVisible(selectedInput);

							let firstVisibleInput = Array.from(variantInputs).find(input => isLabelVisible(input));

							if (selectedInputIsHidden && firstVisibleInput) {
								firstVisibleInput.click();
								const submitBtn = section.querySelector('[type="submit"]');
								submitBtn.removeAttribute('disabled');
							}
						}
					}
				}

				// if(addToCart) {
				// 	!foundVariant ? addToCart.setAttribute('disabled', true) : !foundVariant['available'] ? addToCart.setAttribute('disabled', true) : addToCart.removeAttribute('disabled');
				// }
				
				////////////////////////// End Addition ////////////////////////////

			}
		}
	},

	refreshProductMediaSection: async function(variantId, section) {
		const handle = window.fullProduct.handle;
		const sectionId = this.getProductMediaSectionId(section);
		
		const url = `/products/${handle}?variant=${variantId}&section_id=${sectionId}`;
		const res = await fetch(url);
		const html = await res.text();
		const doc = new DOMParser().parseFromString(html, 'text/html');
		
		const newMainGlider = doc.querySelector(`.glider[data-window-id="${handle}"]`);
		const currentMainGlider = section.querySelector(`.glider[data-window-id="${handle}"]`);
		
		const newDotsGlider = doc.querySelector(`.glider[data-window-id="${handle}-dots"]`);
		const currentDotsGlider = section.querySelector(`.glider[data-window-id="${handle}-dots"]`);
		
		if (newMainGlider && currentMainGlider && window[handle] && window[handle].ele) {
			const currentTrack = window[handle].ele.querySelector('.glider-track');
			if (currentTrack) {
				currentTrack.innerHTML = newMainGlider.innerHTML;
				window[handle].refresh(true);
			}
		} else if (newMainGlider && currentMainGlider) {
			currentMainGlider.replaceWith(newMainGlider);
			Global.glider();
		}
		
		if (newDotsGlider && currentDotsGlider && window[handle + '-dots'] && window[handle + '-dots'].ele) {
			const dotsTrack = window[handle + '-dots'].ele.querySelector('.glider-track');
			if (dotsTrack) {
				dotsTrack.innerHTML = newDotsGlider.innerHTML;
				window[handle + '-dots'].refresh(true);
			}
		}
		
		Product.changeDots(section);
		Product.changeImages(section);

		// Reset to first slide on variant change
		if (window[handle] && typeof window[handle].scrollItem === 'function') {
			window[handle].scrollItem(0, false);
		}
		if (window[handle + '-dots'] && typeof window[handle + '-dots'].scrollItem === 'function') {
			window[handle + '-dots'].scrollItem(0, false);
		}
		Product.opacityDots(section.querySelectorAll('.glider__img-dot'), 0);
	},

	getProductMediaSectionId: function(section) {
		if (section && section.classList) {
			if (section.classList.contains('van-product')) {
				return 'product-template-van';
			}

			if (section.classList.contains('adavanced_template-product')) {
				return 'advanced-product-template';
			}

			if (section.classList.contains('main__template-product')) {
				return 'new-product-template';
			}
		}

		return 'product-template';
	},


	updateProductPromos: async function(section, total) {
		const cart = await makeRequest('GET', '/cart.json');
		if(cart) {
			const cartData = JSON.parse(cart);
			const cartAmount = cartData['original_total_price'];
			const promos = section.querySelectorAll('.product-discount-option');
			const promosReverse = Array.from(promos).reverse();

			for (let i = 0; i < promosReverse.length; i++) {
				promos[i].style.display = 'none';
			}
			
			let updatedIndex = null;
			for (let i = 0; i < promosReverse.length; i++) {
				const promoAmount = promosReverse[i].getAttribute('data-discount-amount');
				if(promoAmount) {
					const promoAmountParsed = parseInt(promoAmount);
					if(cartAmount + total >= promoAmountParsed && cartAmount < promoAmountParsed) {
						updatedIndex = i
						break
					}
				}
			}

			if(updatedIndex != null) {
				promosReverse[updatedIndex].style.display = 'block';
			}
		}
	},

	updateFinance: function(section, variant) {
		let productFinance = section.querySelector('#product-finance');

		if(productFinance) {
			let product = productFinance.querySelector('#product');
			let price = productFinance.querySelector('#price');

			let currency = Money.getCurrency();
			let priceAmount = Currency.formatMoney(variant.price, Currency.money_format[currency]);

			product.value = variant.name;
			price.value = priceAmount.replace('&pound;', '£');
		}
	},

	findVariant: function(options, radios) {
		if(window['fullProduct']) {
			const productData = window['fullProduct']['variants'];

			for (var i = 0; i < productData.length; i++) {
				let foundVariant = true;
				let variant = productData[i];

				for (var j = 0; j < options.length; j++) {
					if(foundVariant) {
						if(variant['options'][j] !== options[j]) {
							foundVariant = false
						}
					}
				}

				if(foundVariant) {
					return variant
				}
			}
		}

		return null
	},

	updateOptionSelectors: function(section) {
		for (var i = 0; i < window['foundVariant']['options'].length; i++) {
			let option = window['foundVariant']['options'][i];
			let optionGroupInputContain = section.querySelector(`[data-variant-input="${i}"]`)
			if(optionGroupInputContain) {
				let optionGroupInputs = optionGroupInputContain.querySelectorAll('input');
				for (var j = 0; j < optionGroupInputs.length; j++) {
					optionGroupInputs[j].checked = optionGroupInputs[j].value == option;
				}
			}
		}
	},

	addToRecentlyViewed: function() {
		if(window['fullProduct']) {
			if(window['fullProduct']['handle']) {
				let recentlyViewed = Cookies.getCookie('recently-viewed') ? Cookies.getCookie('recently-viewed').split(',') : [];
				let index = recentlyViewed.indexOf(window['fullProduct']['handle']);
				if (index > -1) {
				  recentlyViewed.splice(index, 1);
				}

				recentlyViewed.unshift(window['fullProduct']['handle']);
				if(recentlyViewed.length > 10) {
					recentlyViewed.pop();
				}
				Cookies.setCookie('recently-viewed', recentlyViewed, 100);
			}
		}
	},

	vanInit: function(section) {
		const vanSections = section.querySelectorAll('.van-hide')
		if(section.classList.contains('van-product') && window['foundVariant']) {
			for (var i = 0; i < vanSections.length; i++) {
				if(window['foundVariant']['id'] == vanSections[i].getAttribute('data-variant-id')) {
					vanSections[i].style.height = 'auto';
					vanSections[i].style.opacity = '1';
				} else {
					vanSections[i].style.height = '0';
					vanSections[i].style.opacity = '0';
				}
			}
		}
		this.vanPrice(section);
	},

	vanPrice: function(section) {
		const vanMonthlyPrice = section.querySelectorAll('.van-finance-price');
		const monthlyCost = FinanceUtils.getPriceBreakdown(window['foundVariant']['price']);
		for (var i = 0; i < vanMonthlyPrice.length; i++) {
			vanMonthlyPrice[i].innerHTML = Currency.formatMoney(monthlyCost, Currency.money_format[Money.getCurrency()]);
		}
	},

	highlights: function(section) {
		const highlightSection = section.querySelectorAll('.van-highlight');
		for (let i = 0; i < highlightSection.length; i++) {
			const highlights = highlightSection[i].querySelectorAll('.van-highlight-item');
			if(highlights.length > 0) {
				this.updateHighlight(highlights, 0)
			}
		}
	},

	updateHighlight: function(highlight, key) {
			for (let i = 0; i < highlight.length; i++) {
				if(i == key) {
					highlight[i].classList.add('van-product__highlight--active');
				} else {
					highlight[i].classList.remove('van-product__highlight--active');
				}				
			}

			setTimeout(() => {
				this.updateHighlight(highlight, key + 1 >= highlight.length ? 0 : key + 1)
			}, 3000)	
	}

}
;
const Cart = {
	init: function() {
		let currency = Money.getCurrency();
		if(currency == 'GBP') {
			const bar = document.querySelector('#shipping-bar')
			if(bar) {
				bar.classList.remove('d-none')
			}
		}
		
		const cartAmountEl = document.querySelector('#cart-bar-amount');

		if(cartAmountEl) {
			let cartAmount = cartAmountEl.getAttribute('data-amount');
			const cartDeals = document.querySelectorAll('.cart-bar-data');
			const cartBarInner = document.querySelector('#cart-bar-inner');
			const cartBarPrice = document.querySelector('#cart-bar-price');
			const cartTitle = document.querySelector('#cart-bar-title');
			const cartSubtitle = document.querySelector('#cart-bar-subtitle')

			const cartBar = document.querySelector('#cart-bar');
			cartAmount = Money.getCurrency() == 'GBP' ? parseFloat(cartAmount) * 1.2 : parseFloat(cartAmount);

			if(cartDeals.length > 0 ) {
				let selectedDeal = {};
				let maxDeal = {};
				
				for (var i = 0; i < cartDeals.length; i++) {
					// Hasn't reached deal
					if(parseFloat(cartDeals[i].getAttribute('data-amount')) > cartAmount) {
						if(selectedDeal['amount']) {
							if(selectedDeal['amount'] > parseFloat(cartDeals[i].getAttribute('data-amount'))) {
								selectedDeal = {
									'amount': parseFloat(cartDeals[i].getAttribute('data-amount')),
									'subtitle': cartDeals[i].getAttribute('data-subtitle'),
									'deal': cartDeals[i].getAttribute('data-name')
								}
							}
						} else {
							selectedDeal = {
								'amount': parseFloat(cartDeals[i].getAttribute('data-amount')),
								'subtitle': cartDeals[i].getAttribute('data-subtitle'),
								'deal': cartDeals[i].getAttribute('data-name')
							}
						}
					} else {
						if(!selectedDeal['amount']) {
							maxDeal = {
								'amount': parseFloat(cartDeals[i].getAttribute('data-amount')),
								'subtitle': cartDeals[i].getAttribute('data-subtitle'),
								'deal': cartDeals[i].getAttribute('data-name')
							}
						} else if(parseFloat(cartDeals[i].getAttribute('data-amount')) > selectedDeal['amount']) {
							maxDeal = {
								'amount': parseFloat(cartDeals[i].getAttribute('data-amount')),
								'subtitle': cartDeals[i].getAttribute('data-subtitle'),
								'deal': cartDeals[i].getAttribute('data-name')
							}
						}
					}
				}

				let percentage = !selectedDeal['amount'] ? 100 : cartAmount / selectedDeal['amount'] * 100;
				selectedDeal = !selectedDeal['amount'] ? maxDeal : selectedDeal;

				if(percentage > 20 || !selectedDeal['amount']) {
					cartBarInner.style.width = percentage + '%';
					cartBarPrice.style.left = `${percentage - 15}%`;
					cartBarPrice.innerHTML = parseInt(percentage ) + '%';
					cartTitle.innerHTML = selectedDeal['deal'];
					cartSubtitle.innerHTML = selectedDeal['subtitle'];
				} else {
					cartBar.style.display = 'none';
				}
			}
		}
	}
};
// const postcodes = {
// 	AB1: "soft",
// 	AB10: "soft",
// 	AB11: "soft",
// 	AB12: "soft",
// 	AB13: "soft",
// 	AB14: "soft",
// 	AB15: "soft",
// 	AB16: "soft",
// 	AB2: "soft",
// 	AB21: "soft",
// 	AB22: "soft",
// 	AB23: "soft",
// 	AB24: "soft",
// 	AB25: "soft",
// 	AB3: "soft",
// 	AB30: "soft",
// 	AB31: "soft",
// 	AB32: "soft",
// 	AB33: "soft",
// 	AB34: "soft",
// 	AB35: "soft",
// 	AB36: "soft",
// 	AB37: "soft",
// 	AB38: "soft",
// 	AB39: "soft",
// 	AB4: "soft",
// 	AB41: "soft",
// 	AB42: "soft",
// 	AB43: "soft",
// 	AB44: "soft",
// 	AB45: "soft",
// 	AB5: "soft",
// 	AB51: "soft",
// 	AB52: "soft",
// 	AB53: "soft",
// 	AB54: "soft",
// 	AB55: "soft",
// 	AB56: "soft",
// 	AB9: "soft",
// 	AB99: "soft",
// 	AL1: "hard",
// 	AL10: "hard",
// 	AL2: "hard",
// 	AL3: "hard",
// 	AL4: "hard",
// 	AL5: "hard",
// 	AL6: "hard",
// 	AL7: "hard",
// 	AL8: "hard",
// 	AL9: "hard",
// 	B1: "soft",
// 	B10: "soft",
// 	B11: "soft",
// 	B12: "soft",
// 	B13: "soft",
// 	B14: "soft",
// 	B15: "soft",
// 	B16: "soft",
// 	B17: "soft",
// 	B18: "soft",
// 	B19: "soft",
// 	B2: "soft",
// 	B20: "soft",
// 	B21: "soft",
// 	B22: "soft",
// 	B23: "soft",
// 	B24: "soft",
// 	B25: "soft",
// 	B26: "soft",
// 	B27: "soft",
// 	B28: "soft",
// 	B29: "soft",
// 	B3: "soft",
// 	B30: "soft",
// 	B31: "soft",
// 	B32: "soft",
// 	B33: "soft",
// 	B34: "soft",
// 	B35: "soft",
// 	B36: "soft",
// 	B37: "soft",
// 	B38: "soft",
// 	B4: "soft",
// 	B40: "soft",
// 	B42: "soft",
// 	B43: "soft",
// 	B44: "soft",
// 	B45: "soft",
// 	B46: "soft",
// 	B47: "soft",
// 	B48: "soft",
// 	B49: "hard",
// 	B5: "soft",
// 	B50: "soft",
// 	B6: "soft",
// 	B60: "soft",
// 	B61: "soft",
// 	B62: "soft",
// 	B63: "soft",
// 	B64: "hard",
// 	B65: "soft",
// 	B66: "soft",
// 	B67: "soft",
// 	B68: "soft",
// 	B69: "soft",
// 	B7: "soft",
// 	B70: "soft",
// 	B71: "soft",
// 	B72: "soft",
// 	B73: "soft",
// 	B74: "soft",
// 	B75: "soft",
// 	B76: "soft",
// 	B77: "hard",
// 	B78: "hard",
// 	B79: "hard",
// 	B8: "soft",
// 	B80: "soft",
// 	B9: "soft",
// 	B90: "soft",
// 	B91: "soft",
// 	B92: "soft",
// 	B93: "soft",
// 	B94: "soft",
// 	B95: "soft",
// 	B96: "soft",
// 	B97: "soft",
// 	B98: "soft",
// 	B99: "soft",
// 	BA1: "hard",
// 	BA10: "hard",
// 	BA11: "hard",
// 	BA12: "hard",
// 	BA13: "hard",
// 	BA14: "hard",
// 	BA15: "hard",
// 	BA16: "hard",
// 	BA2: "soft",
// 	BA20: "soft",
// 	BA21: "soft",
// 	BA22: "soft",
// 	BA3: "hard",
// 	BA4: "soft",
// 	BA5: "hard",
// 	BA6: "soft",
// 	BA7: "hard",
// 	BA8: "hard",
// 	BA9: "hard",
// 	BB0: "soft",
// 	BB1: "soft",
// 	BB10: "soft",
// 	BB11: "soft",
// 	BB12: "soft",
// 	BB18: "soft",
// 	BB2: "soft",
// 	BB3: "soft",
// 	BB4: "soft",
// 	BB5: "soft",
// 	BB6: "soft",
// 	BB7: "soft",
// 	BB8: "soft",
// 	BB9: "soft",
// 	BB94: "soft",
// 	BD1: "soft",
// 	BD10: "soft",
// 	BD11: "soft",
// 	BD12: "soft",
// 	BD13: "soft",
// 	BD14: "soft",
// 	BD15: "soft",
// 	BD16: "soft",
// 	BD17: "soft",
// 	BD18: "soft",
// 	BD19: "soft",
// 	BD2: "soft",
// 	BD20: "soft",
// 	BD21: "soft",
// 	BD22: "soft",
// 	BD23: "soft",
// 	BD24: "soft",
// 	BD3: "soft",
// 	BD4: "soft",
// 	BD5: "soft",
// 	BD6: "soft",
// 	BD7: "soft",
// 	BD8: "soft",
// 	BD9: "soft",
// 	BD97: "soft",
// 	BD98: "soft",
// 	BD99: "soft",
// 	BH1: "hard",
// 	BH10: "hard",
// 	BH11: "hard",
// 	BH12: "soft",
// 	BH13: "soft",
// 	BH14: "hard",
// 	BH15: "hard",
// 	BH16: "hard",
// 	BH17: "hard",
// 	BH18: "hard",
// 	BH19: "hard",
// 	BH2: "hard",
// 	BH20: "hard",
// 	BH21: "hard",
// 	BH22: "hard",
// 	BH23: "hard",
// 	BH24: "hard",
// 	BH25: "hard",
// 	BH3: "hard",
// 	BH31: "hard",
// 	BH4: "hard",
// 	BH5: "hard",
// 	BH6: "hard",
// 	BH7: "hard",
// 	BH8: "soft",
// 	BH9: "hard",
// 	BL0: "soft",
// 	BL1: "soft",
// 	BL11: "soft",
// 	BL2: "soft",
// 	BL3: "soft",
// 	BL4: "soft",
// 	BL5: "soft",
// 	BL6: "soft",
// 	BL7: "soft",
// 	BL78: "soft",
// 	BL8: "soft",
// 	BL9: "soft",
// 	BN1: "hard",
// 	BN10: "hard",
// 	BN11: "hard",
// 	BN12: "hard",
// 	BN13: "hard",
// 	BN14: "hard",
// 	BN15: "hard",
// 	BN16: "hard",
// 	BN17: "hard",
// 	BN18: "hard",
// 	BN2: "soft",
// 	BN20: "soft",
// 	BN21: "hard",
// 	BN22: "hard",
// 	BN23: "hard",
// 	BN24: "soft",
// 	BN25: "hard",
// 	BN26: "hard",
// 	BN27: "hard",
// 	BN3: "hard",
// 	BN4: "hard",
// 	BN41: "hard",
// 	BN42: "hard",
// 	BN43: "hard",
// 	BN44: "soft",
// 	BN45: "hard",
// 	BN5: "soft",
// 	BN50: "soft",
// 	BN51: "soft",
// 	BN52: "soft",
// 	BN6: "hard",
// 	BN7: "hard",
// 	BN8: "hard",
// 	BN88: "hard",
// 	BN9: "hard",
// 	BN91: "hard",
// 	BN95: "hard",
// 	BN99: "hard",
// 	BR1: "hard",
// 	BR2: "hard",
// 	BR3: "hard",
// 	BR4: "hard",
// 	BR5: "hard",
// 	BR6: "hard",
// 	BR7: "hard",
// 	BR8: "hard",
// 	BR98: "hard",
// 	BS0: "hard",
// 	BS1: "hard",
// 	BS10: "soft",
// 	BS11: "hard",
// 	BS12: "hard",
// 	BS13: "soft",
// 	BS14: "hard",
// 	BS15: "soft",
// 	BS16: "soft",
// 	BS17: "hard",
// 	BS18: "hard",
// 	BS19: "hard",
// 	BS2: "soft",
// 	BS20: "soft",
// 	BS21: "hard",
// 	BS22: "hard",
// 	BS23: "hard",
// 	BS24: "soft",
// 	BS25: "hard",
// 	BS26: "hard",
// 	BS27: "soft",
// 	BS28: "hard",
// 	BS29: "soft",
// 	BS3: "hard",
// 	BS30: "hard",
// 	BS31: "soft",
// 	BS32: "hard",
// 	BS34: "hard",
// 	BS35: "hard",
// 	BS36: "hard",
// 	BS37: "hard",
// 	BS38: "soft",
// 	BS39: "hard",
// 	BS4: "hard",
// 	BS40: "hard",
// 	BS41: "soft",
// 	BS48: "hard",
// 	BS49: "hard",
// 	BS5: "hard",
// 	BS6: "hard",
// 	BS7: "soft",
// 	BS77: "soft",
// 	BS8: "soft",
// 	BS80: "soft",
// 	BS9: "hard",
// 	BS98: "hard",
// 	BS99: "hard",
// 	BT1: "soft",
// 	BT10: "soft",
// 	BT11: "soft",
// 	BT12: "soft",
// 	BT13: "soft",
// 	BT14: "soft",
// 	BT15: "soft",
// 	BT16: "soft",
// 	BT17: "soft",
// 	BT18: "soft",
// 	BT19: "soft",
// 	BT2: "soft",
// 	BT20: "soft",
// 	BT21: "soft",
// 	BT22: "soft",
// 	BT23: "soft",
// 	BT24: "soft",
// 	BT25: "soft",
// 	BT26: "soft",
// 	BT27: "soft",
// 	BT28: "soft",
// 	BT29: "soft",
// 	BT3: "soft",
// 	BT30: "soft",
// 	BT31: "soft",
// 	BT32: "soft",
// 	BT33: "soft",
// 	BT34: "soft",
// 	BT35: "soft",
// 	BT36: "soft",
// 	BT37: "soft",
// 	BT38: "soft",
// 	BT39: "soft",
// 	BT4: "soft",
// 	BT40: "soft",
// 	BT41: "soft",
// 	BT42: "soft",
// 	BT43: "soft",
// 	BT44: "soft",
// 	BT45: "soft",
// 	BT46: "soft",
// 	BT47: "soft",
// 	BT48: "soft",
// 	BT49: "soft",
// 	BT5: "soft",
// 	BT51: "soft",
// 	BT52: "soft",
// 	BT53: "soft",
// 	BT54: "soft",
// 	BT55: "soft",
// 	BT56: "soft",
// 	BT57: "soft",
// 	BT58: "soft",
// 	BT6: "soft",
// 	BT60: "soft",
// 	BT61: "soft",
// 	BT62: "soft",
// 	BT63: "soft",
// 	BT64: "soft",
// 	BT65: "soft",
// 	BT66: "soft",
// 	BT67: "soft",
// 	BT68: "soft",
// 	BT69: "soft",
// 	BT7: "soft",
// 	BT70: "soft",
// 	BT71: "soft",
// 	BT74: "soft",
// 	BT75: "soft",
// 	BT76: "soft",
// 	BT77: "soft",
// 	BT78: "soft",
// 	BT79: "soft",
// 	BT8: "soft",
// 	BT80: "soft",
// 	BT81: "soft",
// 	BT82: "soft",
// 	BT9: "soft",
// 	BT92: "soft",
// 	BT93: "soft",
// 	BT94: "soft",
// 	BT99: "soft",
// 	CA1: "soft",
// 	CA10: "soft",
// 	CA11: "soft",
// 	CA12: "soft",
// 	CA13: "soft",
// 	CA14: "soft",
// 	CA15: "soft",
// 	CA16: "soft",
// 	CA17: "soft",
// 	CA18: "soft",
// 	CA19: "soft",
// 	CA2: "soft",
// 	CA20: "soft",
// 	CA21: "soft",
// 	CA22: "soft",
// 	CA23: "soft",
// 	CA24: "soft",
// 	CA25: "soft",
// 	CA26: "soft",
// 	CA27: "soft",
// 	CA28: "soft",
// 	CA3: "soft",
// 	CA4: "soft",
// 	CA5: "soft",
// 	CA6: "soft",
// 	CA7: "soft",
// 	CA8: "soft",
// 	CA9: "soft",
// 	CA95: "soft",
// 	CA99: "soft",
// 	CB1: "hard",
// 	CB10: "hard",
// 	CB11: "hard",
// 	CB2: "hard",
// 	CB21: "hard",
// 	CB22: "hard",
// 	CB23: "hard",
// 	CB24: "hard",
// 	CB25: "hard",
// 	CB3: "hard",
// 	CB4: "hard",
// 	CB5: "hard",
// 	CB6: "hard",
// 	CB7: "hard",
// 	CB8: "hard",
// 	CB9: "hard",
// 	CF1: "soft",
// 	CF10: "soft",
// 	CF11: "soft",
// 	CF14: "soft",
// 	CF15: "soft",
// 	CF2: "soft",
// 	CF21: "soft",
// 	CF23: "soft",
// 	CF24: "soft",
// 	CF3: "soft",
// 	CF30: "soft",
// 	CF31: "soft",
// 	CF32: "soft",
// 	CF33: "soft",
// 	CF34: "soft",
// 	CF35: "soft",
// 	CF36: "soft",
// 	CF37: "soft",
// 	CF38: "soft",
// 	CF39: "soft",
// 	CF4: "soft",
// 	CF40: "soft",
// 	CF41: "soft",
// 	CF42: "soft",
// 	CF43: "soft",
// 	CF44: "soft",
// 	CF45: "soft",
// 	CF46: "soft",
// 	CF47: "soft",
// 	CF48: "soft",
// 	CF5: "soft",
// 	CF6: "soft",
// 	CF61: "soft",
// 	CF62: "soft",
// 	CF63: "soft",
// 	CF64: "soft",
// 	CF7: "soft",
// 	CF71: "soft",
// 	CF72: "soft",
// 	CF8: "soft",
// 	CF81: "soft",
// 	CF82: "soft",
// 	CF83: "soft",
// 	CF91: "soft",
// 	CF95: "soft",
// 	CF99: "soft",
// 	CH1: "soft",
// 	CH2: "soft",
// 	CH25: "soft",
// 	CH26: "soft",
// 	CH27: "soft",
// 	CH28: "soft",
// 	CH29: "soft",
// 	CH3: "soft",
// 	CH30: "soft",
// 	CH31: "soft",
// 	CH32: "soft",
// 	CH33: "soft",
// 	CH34: "soft",
// 	CH4: "soft",
// 	CH41: "soft",
// 	CH42: "soft",
// 	CH43: "soft",
// 	CH44: "soft",
// 	CH45: "soft",
// 	CH46: "soft",
// 	CH47: "soft",
// 	CH48: "soft",
// 	CH49: "soft",
// 	CH5: "soft",
// 	CH6: "soft",
// 	CH60: "soft",
// 	CH61: "soft",
// 	CH62: "soft",
// 	CH63: "soft",
// 	CH64: "soft",
// 	CH65: "soft",
// 	CH66: "soft",
// 	CH7: "soft",
// 	CH70: "soft",
// 	CH8: "soft",
// 	CH88: "soft",
// 	CH99: "soft",
// 	CM0: "hard",
// 	CM1: "hard",
// 	CM11: "hard",
// 	CM12: "hard",
// 	CM13: "hard",
// 	CM14: "hard",
// 	CM15: "hard",
// 	CM16: "hard",
// 	CM17: "hard",
// 	CM18: "hard",
// 	CM19: "hard",
// 	CM2: "hard",
// 	CM20: "soft",
// 	CM21: "hard",
// 	CM22: "hard",
// 	CM23: "hard",
// 	CM24: "hard",
// 	CM3: "hard",
// 	CM4: "soft",
// 	CM5: "hard",
// 	CM6: "hard",
// 	CM7: "hard",
// 	CM77: "hard",
// 	CM8: "hard",
// 	CM9: "hard",
// 	CM92: "hard",
// 	CM98: "hard",
// 	CM99: "hard",
// 	CO1: "hard",
// 	CO10: "hard",
// 	CO11: "hard",
// 	CO12: "hard",
// 	CO13: "hard",
// 	CO14: "hard",
// 	CO15: "hard",
// 	CO16: "hard",
// 	CO2: "hard",
// 	CO3: "hard",
// 	CO4: "hard",
// 	CO5: "hard",
// 	CO6: "hard",
// 	CO7: "soft",
// 	CO8: "soft",
// 	CO9: "hard",
// 	CR0: "hard",
// 	CR2: "hard",
// 	CR3: "soft",
// 	CR4: "soft",
// 	CR44: "soft",
// 	CR5: "soft",
// 	CR6: "soft",
// 	CR7: "hard",
// 	CR8: "hard",
// 	CR9: "hard",
// 	CR90: "hard",
// 	CT1: "hard",
// 	CT10: "hard",
// 	CT11: "hard",
// 	CT12: "hard",
// 	CT13: "hard",
// 	CT14: "hard",
// 	CT15: "hard",
// 	CT16: "hard",
// 	CT17: "hard",
// 	CT18: "hard",
// 	CT19: "hard",
// 	CT2: "hard",
// 	CT20: "hard",
// 	CT21: "hard",
// 	CT3: "hard",
// 	CT4: "hard",
// 	CT5: "hard",
// 	CT50: "hard",
// 	CT6: "hard",
// 	CT7: "hard",
// 	CT8: "hard",
// 	CT9: "hard",
// 	CV1: "soft",
// 	CV10: "soft",
// 	CV11: "soft",
// 	CV12: "soft",
// 	CV13: "soft",
// 	CV2: "soft",
// 	CV21: "soft",
// 	CV22: "soft",
// 	CV23: "soft",
// 	CV3: "soft",
// 	CV31: "soft",
// 	CV32: "soft",
// 	CV33: "soft",
// 	CV34: "soft",
// 	CV35: "soft",
// 	CV36: "soft",
// 	CV37: "soft",
// 	CV4: "soft",
// 	CV47: "soft",
// 	CV5: "soft",
// 	CV6: "soft",
// 	CV7: "soft",
// 	CV8: "soft",
// 	CV9: "soft",
// 	CW1: "soft",
// 	CW10: "soft",
// 	CW11: "soft",
// 	CW12: "soft",
// 	CW2: "soft",
// 	CW3: "soft",
// 	CW4: "soft",
// 	CW5: "soft",
// 	CW6: "soft",
// 	CW7: "soft",
// 	CW8: "soft",
// 	CW9: "soft",
// 	CW98: "soft",
// 	DA1: "hard",
// 	DA10: "hard",
// 	DA11: "hard",
// 	DA12: "hard",
// 	DA13: "hard",
// 	DA14: "hard",
// 	DA15: "soft",
// 	DA16: "hard",
// 	DA17: "hard",
// 	DA18: "hard",
// 	DA2: "hard",
// 	DA3: "hard",
// 	DA4: "hard",
// 	DA5: "hard",
// 	DA6: "hard",
// 	DA7: "hard",
// 	DA8: "hard",
// 	DA9: "hard",
// 	DD1: "soft",
// 	DD10: "soft",
// 	DD11: "soft",
// 	DD2: "soft",
// 	DD3: "soft",
// 	DD4: "soft",
// 	DD5: "soft",
// 	DD6: "soft",
// 	DD7: "soft",
// 	DD8: "soft",
// 	DD9: "soft",
// 	DE1: "soft",
// 	DE11: "soft",
// 	DE12: "soft",
// 	DE13: "soft",
// 	DE14: "soft",
// 	DE15: "soft",
// 	DE2: "soft",
// 	DE21: "soft",
// 	DE22: "soft",
// 	DE23: "soft",
// 	DE24: "soft",
// 	DE3: "soft",
// 	DE4: "soft",
// 	DE45: "soft",
// 	DE5: "soft",
// 	DE55: "soft",
// 	DE56: "soft",
// 	DE6: "soft",
// 	DE65: "soft",
// 	DE7: "soft",
// 	DE72: "soft",
// 	DE73: "soft",
// 	DE74: "soft",
// 	DE75: "soft",
// 	DE99: "soft",
// 	DG1: "soft",
// 	DG10: "soft",
// 	DG11: "soft",
// 	DG12: "soft",
// 	DG13: "soft",
// 	DG14: "soft",
// 	DG16: "soft",
// 	DG2: "soft",
// 	DG3: "soft",
// 	DG4: "soft",
// 	DG5: "soft",
// 	DG6: "soft",
// 	DG7: "soft",
// 	DG8: "soft",
// 	DG9: "soft",
// 	DH1: "soft",
// 	DH2: "soft",
// 	DH3: "soft",
// 	DH4: "soft",
// 	DH5: "soft",
// 	DH6: "soft",
// 	DH7: "soft",
// 	DH8: "soft",
// 	DH9: "soft",
// 	DH97: "soft",
// 	DH98: "soft",
// 	DH99: "soft",
// 	DL1: "soft",
// 	DL10: "soft",
// 	DL11: "soft",
// 	DL12: "soft",
// 	DL13: "soft",
// 	DL14: "soft",
// 	DL15: "soft",
// 	DL16: "soft",
// 	DL17: "soft",
// 	DL2: "soft",
// 	DL3: "soft",
// 	DL4: "soft",
// 	DL5: "soft",
// 	DL6: "soft",
// 	DL7: "soft",
// 	DL8: "soft",
// 	DL9: "soft",
// 	DL98: "soft",
// 	DN1: "hard",
// 	DN10: "hard",
// 	DN11: "hard",
// 	DN12: "soft",
// 	DN14: "hard",
// 	DN15: "hard",
// 	DN16: "hard",
// 	DN17: "hard",
// 	DN18: "hard",
// 	DN19: "hard",
// 	DN2: "hard",
// 	DN20: "hard",
// 	DN21: "hard",
// 	DN22: "soft",
// 	DN3: "soft",
// 	DN31: "soft",
// 	DN32: "hard",
// 	DN33: "hard",
// 	DN34: "hard",
// 	DN35: "hard",
// 	DN36: "hard",
// 	DN37: "hard",
// 	DN38: "soft",
// 	DN39: "hard",
// 	DN4: "hard",
// 	DN40: "hard",
// 	DN41: "hard",
// 	DN5: "hard",
// 	DN55: "hard",
// 	DN6: "soft",
// 	DN7: "soft",
// 	DN8: "soft",
// 	DN9: "soft",
// 	DT1: "hard",
// 	DT10: "hard",
// 	DT11: "hard",
// 	DT2: "hard",
// 	DT3: "hard",
// 	DT4: "hard",
// 	DT5: "hard",
// 	DT6: "hard",
// 	DT7: "soft",
// 	DT8: "hard",
// 	DT9: "hard",
// 	DY1: "soft",
// 	DY10: "soft",
// 	DY11: "soft",
// 	DY12: "soft",
// 	DY13: "soft",
// 	DY14: "soft",
// 	DY2: "soft",
// 	DY3: "soft",
// 	DY4: "soft",
// 	DY5: "hard",
// 	DY6: "soft",
// 	DY7: "soft",
// 	DY8: "soft",
// 	DY9: "soft",
// 	E1: "hard",
// 	E10: "hard",
// 	E11: "hard",
// 	E12: "hard",
// 	E13: "hard",
// 	E14: "hard",
// 	E15: "hard",
// 	E16: "hard",
// 	E17: "hard",
// 	E18: "hard",
// 	E1W: "hard",
// 	E2: "hard",
// 	E20: "hard",
// 	E3: "hard",
// 	E4: "soft",
// 	E5: "hard",
// 	E6: "hard",
// 	E7: "hard",
// 	E77: "hard",
// 	E8: "hard",
// 	E9: "hard",
// 	E98: "hard",
// 	EC1A: "hard",
// 	EC1M: "hard",
// 	EC1N: "hard",
// 	EC1P: "hard",
// 	EC1R: "hard",
// 	EC1V: "hard",
// 	EC1Y: "hard",
// 	EC2A: "hard",
// 	EC2M: "hard",
// 	EC2N: "hard",
// 	EC2P: "hard",
// 	EC2R: "hard",
// 	EC2V: "hard",
// 	EC2Y: "hard",
// 	EC3A: "hard",
// 	EC3B: "hard",
// 	EC3M: "hard",
// 	EC3N: "hard",
// 	EC3P: "hard",
// 	EC3R: "hard",
// 	EC3V: "hard",
// 	EC4A: "hard",
// 	EC4M: "hard",
// 	EC4N: "hard",
// 	EC4P: "hard",
// 	EC4R: "hard",
// 	EC4V: "hard",
// 	EC4Y: "hard",
// 	EC50: "hard",
// 	EC88: "hard",
// 	EH1: "soft",
// 	EH10: "soft",
// 	EH11: "soft",
// 	EH12: "soft",
// 	EH13: "soft",
// 	EH14: "soft",
// 	EH15: "soft",
// 	EH16: "soft",
// 	EH17: "soft",
// 	EH18: "soft",
// 	EH19: "soft",
// 	EH2: "soft",
// 	EH20: "soft",
// 	EH21: "soft",
// 	EH22: "soft",
// 	EH23: "soft",
// 	EH24: "soft",
// 	EH25: "soft",
// 	EH26: "soft",
// 	EH27: "soft",
// 	EH28: "soft",
// 	EH29: "soft",
// 	EH3: "soft",
// 	EH30: "soft",
// 	EH31: "soft",
// 	EH32: "soft",
// 	EH33: "soft",
// 	EH34: "soft",
// 	EH35: "soft",
// 	EH36: "soft",
// 	EH37: "soft",
// 	EH38: "soft",
// 	EH39: "soft",
// 	EH4: "soft",
// 	EH40: "soft",
// 	EH41: "soft",
// 	EH42: "soft",
// 	EH43: "soft",
// 	EH44: "soft",
// 	EH45: "soft",
// 	EH46: "soft",
// 	EH47: "soft",
// 	EH48: "soft",
// 	EH49: "soft",
// 	EH5: "soft",
// 	EH51: "soft",
// 	EH52: "soft",
// 	EH53: "soft",
// 	EH54: "soft",
// 	EH55: "soft",
// 	EH6: "soft",
// 	EH7: "soft",
// 	EH77: "soft",
// 	EH8: "soft",
// 	EH9: "soft",
// 	EH91: "soft",
// 	EH95: "soft",
// 	EH99: "soft",
// 	EN1: "hard",
// 	EN10: "hard",
// 	EN11: "hard",
// 	EN2: "hard",
// 	EN3: "hard",
// 	EN4: "hard",
// 	EN5: "hard",
// 	EN6: "hard",
// 	EN7: "hard",
// 	EN77: "hard",
// 	EN8: "hard",
// 	EN9: "hard",
// 	EX1: "hard",
// 	EX10: "hard",
// 	EX11: "hard",
// 	EX12: "hard",
// 	EX13: "hard",
// 	EX14: "hard",
// 	EX15: "hard",
// 	EX16: "soft",
// 	EX17: "soft",
// 	EX18: "hard",
// 	EX19: "hard",
// 	EX2: "soft",
// 	EX20: "soft",
// 	EX21: "soft",
// 	EX22: "soft",
// 	EX23: "soft",
// 	EX24: "soft",
// 	EX3: "soft",
// 	EX31: "soft",
// 	EX32: "soft",
// 	EX33: "soft",
// 	EX34: "soft",
// 	EX35: "soft",
// 	EX36: "soft",
// 	EX37: "soft",
// 	EX38: "soft",
// 	EX39: "soft",
// 	EX4: "soft",
// 	EX5: "soft",
// 	EX6: "hard",
// 	EX7: "hard",
// 	EX8: "hard",
// 	EX9: "hard",
// 	FK1: "soft",
// 	FK10: "soft",
// 	FK11: "soft",
// 	FK12: "soft",
// 	FK13: "soft",
// 	FK14: "soft",
// 	FK15: "soft",
// 	FK16: "soft",
// 	FK17: "soft",
// 	FK18: "soft",
// 	FK19: "soft",
// 	FK2: "soft",
// 	FK20: "soft",
// 	FK21: "soft",
// 	FK3: "soft",
// 	FK4: "soft",
// 	FK5: "soft",
// 	FK6: "soft",
// 	FK7: "soft",
// 	FK8: "soft",
// 	FK9: "soft",
// 	FY0: "soft",
// 	FY1: "soft",
// 	FY2: "soft",
// 	FY3: "soft",
// 	FY4: "soft",
// 	FY5: "soft",
// 	FY6: "soft",
// 	FY7: "soft",
// 	FY8: "soft",
// 	G1: "hard",
// 	G11: "hard",
// 	G12: "hard",
// 	G13: "hard",
// 	G14: "hard",
// 	G15: "hard",
// 	G2: "soft",
// 	G20: "soft",
// 	G21: "soft",
// 	G22: "soft",
// 	G23: "soft",
// 	G3: "soft",
// 	G31: "soft",
// 	G32: "soft",
// 	G33: "soft",
// 	G34: "soft",
// 	G4: "soft",
// 	G40: "soft",
// 	G41: "soft",
// 	G42: "soft",
// 	G43: "soft",
// 	G44: "soft",
// 	G45: "soft",
// 	G46: "soft",
// 	G5: "soft",
// 	G51: "soft",
// 	G52: "soft",
// 	G53: "soft",
// 	G58: "soft",
// 	G59: "soft",
// 	G60: "soft",
// 	G61: "soft",
// 	G62: "soft",
// 	G63: "soft",
// 	G64: "soft",
// 	G65: "soft",
// 	G66: "soft",
// 	G67: "soft",
// 	G68: "soft",
// 	G69: "soft",
// 	G70: "soft",
// 	G71: "soft",
// 	G72: "soft",
// 	G73: "soft",
// 	G74: "soft",
// 	G75: "soft",
// 	G76: "soft",
// 	G77: "soft",
// 	G78: "soft",
// 	G79: "soft",
// 	G80: "soft",
// 	G81: "soft",
// 	G82: "soft",
// 	G83: "soft",
// 	G84: "soft",
// 	G9: "hard",
// 	G90: "hard",
// 	GL1: "hard",
// 	GL10: "hard",
// 	GL11: "soft",
// 	GL12: "hard",
// 	GL13: "soft",
// 	GL14: "soft",
// 	GL15: "soft",
// 	GL16: "soft",
// 	GL17: "soft",
// 	GL18: "hard",
// 	GL19: "hard",
// 	GL2: "soft",
// 	GL20: "soft",
// 	GL3: "soft",
// 	GL4: "soft",
// 	GL5: "soft",
// 	GL50: "soft",
// 	GL51: "soft",
// 	GL52: "soft",
// 	GL53: "soft",
// 	GL54: "hard",
// 	GL55: "hard",
// 	GL56: "hard",
// 	GL6: "soft",
// 	GL7: "hard",
// 	GL8: "hard",
// 	GL9: "hard",
// 	GU1: "hard",
// 	GU10: "hard",
// 	GU11: "hard",
// 	GU12: "hard",
// 	GU13: "hard",
// 	GU14: "hard",
// 	GU15: "hard",
// 	GU16: "hard",
// 	GU17: "hard",
// 	GU18: "hard",
// 	GU19: "hard",
// 	GU2: "hard",
// 	GU20: "hard",
// 	GU21: "hard",
// 	GU22: "hard",
// 	GU23: "hard",
// 	GU24: "hard",
// 	GU25: "hard",
// 	GU26: "hard",
// 	GU27: "hard",
// 	GU28: "soft",
// 	GU29: "soft",
// 	GU3: "soft",
// 	GU30: "soft",
// 	GU31: "soft",
// 	GU32: "hard",
// 	GU33: "soft",
// 	GU34: "soft",
// 	GU35: "soft",
// 	GU4: "soft",
// 	GU46: "soft",
// 	GU47: "hard",
// 	GU5: "hard",
// 	GU51: "hard",
// 	GU52: "hard",
// 	GU6: "soft",
// 	GU7: "soft",
// 	GU8: "soft",
// 	GU9: "hard",
// 	GU95: "hard",
// 	HA0: "hard",
// 	HA1: "hard",
// 	HA2: "hard",
// 	HA3: "hard",
// 	HA4: "hard",
// 	HA5: "hard",
// 	HA6: "hard",
// 	HA7: "hard",
// 	HA8: "hard",
// 	HA9: "hard",
// 	HD1: "soft",
// 	HD2: "soft",
// 	HD3: "soft",
// 	HD4: "soft",
// 	HD5: "soft",
// 	HD6: "soft",
// 	HD7: "soft",
// 	HD8: "soft",
// 	HD9: "soft",
// 	HG1: "soft",
// 	HG2: "soft",
// 	HG3: "soft",
// 	HG4: "soft",
// 	HG5: "soft",
// 	HP1: "hard",
// 	HP10: "hard",
// 	HP11: "hard",
// 	HP12: "hard",
// 	HP13: "hard",
// 	HP14: "hard",
// 	HP15: "hard",
// 	HP16: "hard",
// 	HP17: "hard",
// 	HP18: "hard",
// 	HP19: "hard",
// 	HP2: "hard",
// 	HP20: "hard",
// 	HP21: "hard",
// 	HP22: "hard",
// 	HP23: "hard",
// 	HP27: "hard",
// 	HP3: "hard",
// 	HP4: "hard",
// 	HP5: "hard",
// 	HP6: "soft",
// 	HP7: "hard",
// 	HP8: "hard",
// 	HP9: "hard",
// 	HR1: "soft",
// 	HR2: "soft",
// 	HR3: "soft",
// 	HR4: "soft",
// 	HR5: "soft",
// 	HR6: "soft",
// 	HR7: "soft",
// 	HR8: "soft",
// 	HR9: "soft",
// 	HS1: "soft",
// 	HS2: "soft",
// 	HS3: "soft",
// 	HS4: "soft",
// 	HS5: "soft",
// 	HS6: "soft",
// 	HS7: "soft",
// 	HS8: "soft",
// 	HS9: "soft",
// 	HU1: "hard",
// 	HU10: "hard",
// 	HU11: "hard",
// 	HU12: "hard",
// 	HU13: "hard",
// 	HU14: "hard",
// 	HU15: "hard",
// 	HU16: "hard",
// 	HU17: "hard",
// 	HU18: "hard",
// 	HU19: "hard",
// 	HU2: "hard",
// 	HU20: "hard",
// 	HU3: "hard",
// 	HU4: "hard",
// 	HU5: "hard",
// 	HU55: "hard",
// 	HU6: "hard",
// 	HU7: "hard",
// 	HU8: "hard",
// 	HU9: "hard",
// 	HX1: "soft",
// 	HX2: "soft",
// 	HX3: "soft",
// 	HX4: "soft",
// 	HX5: "soft",
// 	HX6: "soft",
// 	HX7: "soft",
// 	IG1: "hard",
// 	IG10: "hard",
// 	IG11: "hard",
// 	IG2: "hard",
// 	IG3: "hard",
// 	IG4: "hard",
// 	IG5: "hard",
// 	IG6: "hard",
// 	IG7: "hard",
// 	IG8: "hard",
// 	IG9: "hard",
// 	IP1: "hard",
// 	IP10: "hard",
// 	IP11: "hard",
// 	IP12: "hard",
// 	IP13: "hard",
// 	IP14: "hard",
// 	IP15: "hard",
// 	IP16: "hard",
// 	IP17: "hard",
// 	IP18: "hard",
// 	IP19: "hard",
// 	IP2: "hard",
// 	IP20: "hard",
// 	IP21: "hard",
// 	IP22: "hard",
// 	IP23: "hard",
// 	IP24: "hard",
// 	IP25: "hard",
// 	IP26: "hard",
// 	IP27: "hard",
// 	IP28: "hard",
// 	IP29: "hard",
// 	IP3: "hard",
// 	IP30: "hard",
// 	IP31: "hard",
// 	IP32: "hard",
// 	IP33: "hard",
// 	IP4: "hard",
// 	IP5: "hard",
// 	IP6: "hard",
// 	IP7: "hard",
// 	IP8: "hard",
// 	IP9: "hard",
// 	IP98: "hard",
// 	IV1: "soft",
// 	IV10: "soft",
// 	IV11: "soft",
// 	IV12: "soft",
// 	IV13: "soft",
// 	IV14: "soft",
// 	IV15: "soft",
// 	IV16: "soft",
// 	IV17: "soft",
// 	IV18: "soft",
// 	IV19: "soft",
// 	IV2: "soft",
// 	IV20: "soft",
// 	IV21: "soft",
// 	IV22: "soft",
// 	IV23: "soft",
// 	IV24: "soft",
// 	IV25: "soft",
// 	IV26: "soft",
// 	IV27: "soft",
// 	IV28: "soft",
// 	IV3: "soft",
// 	IV30: "soft",
// 	IV31: "soft",
// 	IV32: "soft",
// 	IV33: "soft",
// 	IV34: "soft",
// 	IV35: "soft",
// 	IV36: "soft",
// 	IV4: "soft",
// 	IV40: "soft",
// 	IV41: "soft",
// 	IV42: "soft",
// 	IV43: "soft",
// 	IV44: "soft",
// 	IV45: "soft",
// 	IV46: "soft",
// 	IV47: "soft",
// 	IV48: "soft",
// 	IV49: "soft",
// 	IV5: "soft",
// 	IV51: "soft",
// 	IV52: "soft",
// 	IV53: "soft",
// 	IV54: "soft",
// 	IV55: "soft",
// 	IV56: "soft",
// 	IV6: "soft",
// 	IV63: "soft",
// 	IV7: "soft",
// 	IV8: "soft",
// 	IV9: "soft",
// 	IV99: "soft",
// 	JE2: "soft",
// 	JE3: "soft",
// 	KA1: "soft",
// 	KA10: "soft",
// 	KA11: "soft",
// 	KA12: "soft",
// 	KA13: "soft",
// 	KA14: "soft",
// 	KA15: "soft",
// 	KA16: "soft",
// 	KA17: "soft",
// 	KA18: "soft",
// 	KA19: "soft",
// 	KA2: "soft",
// 	KA20: "soft",
// 	KA21: "soft",
// 	KA22: "soft",
// 	KA23: "soft",
// 	KA24: "soft",
// 	KA25: "soft",
// 	KA26: "soft",
// 	KA27: "soft",
// 	KA28: "soft",
// 	KA29: "soft",
// 	KA3: "soft",
// 	KA30: "soft",
// 	KA4: "soft",
// 	KA5: "soft",
// 	KA6: "soft",
// 	KA7: "soft",
// 	KA8: "soft",
// 	KA9: "soft",
// 	KT1: "hard",
// 	KT10: "hard",
// 	KT11: "hard",
// 	KT12: "hard",
// 	KT13: "hard",
// 	KT14: "hard",
// 	KT15: "hard",
// 	KT16: "hard",
// 	KT17: "hard",
// 	KT18: "hard",
// 	KT19: "hard",
// 	KT2: "soft",
// 	KT20: "soft",
// 	KT21: "soft",
// 	KT22: "soft",
// 	KT23: "soft",
// 	KT24: "hard",
// 	KT3: "hard",
// 	KT4: "hard",
// 	KT5: "hard",
// 	KT6: "hard",
// 	KT7: "hard",
// 	KT8: "hard",
// 	KT9: "hard",
// 	KY1: "soft",
// 	KY10: "soft",
// 	KY11: "soft",
// 	KY12: "soft",
// 	KY13: "soft",
// 	KY14: "soft",
// 	KY15: "soft",
// 	KY16: "soft",
// 	KY2: "soft",
// 	KY3: "soft",
// 	KY4: "soft",
// 	KY5: "soft",
// 	KY6: "soft",
// 	KY7: "soft",
// 	KY8: "soft",
// 	KY9: "soft",
// 	KY99: "soft",
// 	L1: "soft",
// 	L10: "soft",
// 	L11: "soft",
// 	L12: "soft",
// 	L13: "soft",
// 	L14: "soft",
// 	L15: "soft",
// 	L16: "soft",
// 	L17: "soft",
// 	L18: "soft",
// 	L19: "soft",
// 	L2: "soft",
// 	L20: "soft",
// 	L21: "soft",
// 	L22: "soft",
// 	L23: "soft",
// 	L24: "soft",
// 	L25: "soft",
// 	L26: "soft",
// 	L27: "soft",
// 	L28: "soft",
// 	L29: "soft",
// 	L3: "soft",
// 	L30: "soft",
// 	L31: "soft",
// 	L32: "soft",
// 	L33: "soft",
// 	L34: "soft",
// 	L35: "soft",
// 	L36: "soft",
// 	L37: "soft",
// 	L38: "soft",
// 	L39: "soft",
// 	L4: "soft",
// 	L40: "soft",
// 	L41: "soft",
// 	L42: "soft",
// 	L43: "soft",
// 	L44: "soft",
// 	L45: "soft",
// 	L46: "soft",
// 	L47: "soft",
// 	L48: "soft",
// 	L49: "soft",
// 	L5: "soft",
// 	L6: "soft",
// 	L60: "soft",
// 	L61: "soft",
// 	L62: "soft",
// 	L63: "soft",
// 	L64: "soft",
// 	L65: "soft",
// 	L66: "soft",
// 	L67: "soft",
// 	L68: "soft",
// 	L69: "soft",
// 	L7: "soft",
// 	L70: "soft",
// 	L71: "soft",
// 	L72: "soft",
// 	L73: "soft",
// 	L74: "soft",
// 	L75: "soft",
// 	L8: "soft",
// 	L80: "soft",
// 	L9: "soft",
// 	LA1: "soft",
// 	LA10: "soft",
// 	LA11: "soft",
// 	LA12: "soft",
// 	LA13: "soft",
// 	LA14: "soft",
// 	LA15: "soft",
// 	LA16: "soft",
// 	LA17: "soft",
// 	LA18: "soft",
// 	LA19: "soft",
// 	LA2: "soft",
// 	LA20: "soft",
// 	LA21: "soft",
// 	LA22: "soft",
// 	LA23: "soft",
// 	LA3: "soft",
// 	LA4: "soft",
// 	LA5: "soft",
// 	LA6: "soft",
// 	LA7: "soft",
// 	LA8: "soft",
// 	LA9: "soft",
// 	LD1: "soft",
// 	LD2: "soft",
// 	LD3: "soft",
// 	LD4: "soft",
// 	LD5: "soft",
// 	LD6: "soft",
// 	LD7: "soft",
// 	LD8: "soft",
// 	LE1: "soft",
// 	LE10: "soft",
// 	LE11: "soft",
// 	LE12: "soft",
// 	LE13: "soft",
// 	LE14: "hard",
// 	LE15: "soft",
// 	LE16: "soft",
// 	LE17: "soft",
// 	LE18: "hard",
// 	LE19: "soft",
// 	LE2: "hard",
// 	LE21: "hard",
// 	LE3: "soft",
// 	LE4: "soft",
// 	LE41: "soft",
// 	LE5: "soft",
// 	LE55: "soft",
// 	LE6: "soft",
// 	LE65: "hard",
// 	LE67: "soft",
// 	LE7: "soft",
// 	LE8: "soft",
// 	LE87: "soft",
// 	LE9: "soft",
// 	LE94: "soft",
// 	LE95: "soft",
// 	LE99: "soft",
// 	LL11: "soft",
// 	LL12: "soft",
// 	LL13: "soft",
// 	LL14: "soft",
// 	LL15: "soft",
// 	LL16: "soft",
// 	LL17: "soft",
// 	LL18: "soft",
// 	LL19: "soft",
// 	LL20: "soft",
// 	LL21: "soft",
// 	LL22: "soft",
// 	LL23: "soft",
// 	LL24: "soft",
// 	LL25: "soft",
// 	LL26: "soft",
// 	LL27: "soft",
// 	LL28: "soft",
// 	LL29: "soft",
// 	LL30: "soft",
// 	LL31: "soft",
// 	LL32: "soft",
// 	LL33: "soft",
// 	LL34: "soft",
// 	LL35: "soft",
// 	LL36: "soft",
// 	LL37: "soft",
// 	LL38: "soft",
// 	LL39: "soft",
// 	LL40: "soft",
// 	LL41: "soft",
// 	LL42: "soft",
// 	LL43: "soft",
// 	LL44: "soft",
// 	LL45: "soft",
// 	LL46: "soft",
// 	LL47: "soft",
// 	LL48: "soft",
// 	LL49: "soft",
// 	LL51: "soft",
// 	LL52: "soft",
// 	LL53: "soft",
// 	LL54: "soft",
// 	LL55: "soft",
// 	LL56: "soft",
// 	LL57: "soft",
// 	LL58: "soft",
// 	LL59: "soft",
// 	LL60: "soft",
// 	LL61: "soft",
// 	LL62: "soft",
// 	LL63: "soft",
// 	LL64: "soft",
// 	LL65: "soft",
// 	LL66: "soft",
// 	LL67: "soft",
// 	LL68: "soft",
// 	LL69: "soft",
// 	LL70: "soft",
// 	LL71: "soft",
// 	LL72: "soft",
// 	LL73: "soft",
// 	LL74: "soft",
// 	LL75: "soft",
// 	LL76: "soft",
// 	LL77: "soft",
// 	LL78: "soft",
// 	LN1: "soft",
// 	LN10: "soft",
// 	LN11: "hard",
// 	LN12: "soft",
// 	LN13: "hard",
// 	LN2: "hard",
// 	LN3: "hard",
// 	LN4: "soft",
// 	LN5: "hard",
// 	LN6: "soft",
// 	LN7: "soft",
// 	LN8: "soft",
// 	LN9: "hard",
// 	LS1: "soft",
// 	LS10: "soft",
// 	LS11: "soft",
// 	LS12: "soft",
// 	LS13: "soft",
// 	LS14: "soft",
// 	LS15: "soft",
// 	LS16: "soft",
// 	LS17: "soft",
// 	LS18: "soft",
// 	LS19: "soft",
// 	LS2: "soft",
// 	LS20: "soft",
// 	LS21: "soft",
// 	LS22: "soft",
// 	LS23: "soft",
// 	LS24: "soft",
// 	LS25: "soft",
// 	LS26: "soft",
// 	LS27: "soft",
// 	LS28: "soft",
// 	LS29: "soft",
// 	LS3: "soft",
// 	LS4: "soft",
// 	LS5: "soft",
// 	LS6: "soft",
// 	LS7: "soft",
// 	LS8: "soft",
// 	LS88: "soft",
// 	LS9: "soft",
// 	LS98: "soft",
// 	LS99: "soft",
// 	LU1: "hard",
// 	LU2: "hard",
// 	LU3: "hard",
// 	LU4: "hard",
// 	LU5: "hard",
// 	LU6: "hard",
// 	LU7: "hard",
// 	LU95: "hard",
// 	M1: "soft",
// 	M10: "soft",
// 	M11: "soft",
// 	M12: "soft",
// 	M13: "soft",
// 	M14: "soft",
// 	M15: "soft",
// 	M16: "soft",
// 	M17: "soft",
// 	M18: "soft",
// 	M19: "soft",
// 	M2: "soft",
// 	M20: "soft",
// 	M21: "soft",
// 	M22: "soft",
// 	M23: "soft",
// 	M24: "soft",
// 	M25: "soft",
// 	M26: "soft",
// 	M27: "soft",
// 	M28: "soft",
// 	M29: "soft",
// 	M3: "soft",
// 	M30: "soft",
// 	M31: "soft",
// 	M32: "soft",
// 	M33: "soft",
// 	M34: "soft",
// 	M35: "soft",
// 	M38: "soft",
// 	M4: "soft",
// 	M40: "soft",
// 	M41: "soft",
// 	M43: "soft",
// 	M44: "soft",
// 	M45: "soft",
// 	M46: "soft",
// 	M5: "soft",
// 	M50: "soft",
// 	M52: "soft",
// 	M6: "soft",
// 	M60: "soft",
// 	M61: "soft",
// 	M7: "soft",
// 	M8: "soft",
// 	M9: "soft",
// 	M90: "soft",
// 	M99: "soft",
// 	ME1: "hard",
// 	ME10: "hard",
// 	ME11: "hard",
// 	ME12: "hard",
// 	ME13: "hard",
// 	ME14: "hard",
// 	ME15: "hard",
// 	ME16: "hard",
// 	ME17: "hard",
// 	ME18: "hard",
// 	ME19: "soft",
// 	ME2: "soft",
// 	ME20: "soft",
// 	ME3: "hard",
// 	ME4: "hard",
// 	ME5: "hard",
// 	ME6: "hard",
// 	ME7: "hard",
// 	ME8: "hard",
// 	ME9: "hard",
// 	ME99: "hard",
// 	MK1: "hard",
// 	MK10: "hard",
// 	MK11: "hard",
// 	MK12: "hard",
// 	MK13: "hard",
// 	MK14: "hard",
// 	MK15: "hard",
// 	MK16: "hard",
// 	MK17: "hard",
// 	MK18: "hard",
// 	MK19: "hard",
// 	MK2: "hard",
// 	MK3: "hard",
// 	MK4: "hard",
// 	MK40: "hard",
// 	MK41: "hard",
// 	MK42: "hard",
// 	MK43: "hard",
// 	MK44: "hard",
// 	MK45: "hard",
// 	MK46: "hard",
// 	MK5: "hard",
// 	MK6: "hard",
// 	MK7: "hard",
// 	MK77: "hard",
// 	MK8: "hard",
// 	MK9: "hard",
// 	MK98: "hard",
// 	ML1: "soft",
// 	ML10: "soft",
// 	ML11: "soft",
// 	ML12: "soft",
// 	ML2: "soft",
// 	ML3: "soft",
// 	ML4: "soft",
// 	ML5: "soft",
// 	ML6: "soft",
// 	ML7: "soft",
// 	ML8: "soft",
// 	ML9: "soft",
// 	N1: "hard",
// 	N10: "hard",
// 	N11: "hard",
// 	N12: "hard",
// 	N13: "hard",
// 	N14: "hard",
// 	N15: "hard",
// 	N16: "hard",
// 	N17: "hard",
// 	N18: "hard",
// 	N19: "hard",
// 	N1C: "hard",
// 	N1P: "hard",
// 	N2: "hard",
// 	N20: "hard",
// 	N21: "hard",
// 	N22: "hard",
// 	N3: "hard",
// 	N4: "hard",
// 	N5: "hard",
// 	N6: "hard",
// 	N7: "hard",
// 	N8: "hard",
// 	N81: "hard",
// 	N9: "hard",
// 	NE1: "soft",
// 	NE10: "soft",
// 	NE11: "soft",
// 	NE12: "soft",
// 	NE13: "soft",
// 	NE15: "soft",
// 	NE16: "soft",
// 	NE17: "soft",
// 	NE18: "soft",
// 	NE19: "soft",
// 	NE2: "soft",
// 	NE20: "soft",
// 	NE21: "soft",
// 	NE22: "soft",
// 	NE23: "soft",
// 	NE24: "soft",
// 	NE25: "soft",
// 	NE26: "soft",
// 	NE27: "soft",
// 	NE28: "soft",
// 	NE29: "soft",
// 	NE3: "soft",
// 	NE30: "soft",
// 	NE31: "soft",
// 	NE32: "soft",
// 	NE33: "soft",
// 	NE34: "soft",
// 	NE35: "soft",
// 	NE36: "soft",
// 	NE37: "soft",
// 	NE38: "soft",
// 	NE39: "soft",
// 	NE4: "soft",
// 	NE40: "soft",
// 	NE41: "soft",
// 	NE42: "soft",
// 	NE43: "soft",
// 	NE44: "soft",
// 	NE45: "soft",
// 	NE46: "soft",
// 	NE47: "soft",
// 	NE48: "soft",
// 	NE49: "soft",
// 	NE5: "soft",
// 	NE6: "soft",
// 	NE61: "soft",
// 	NE62: "soft",
// 	NE63: "soft",
// 	NE64: "soft",
// 	NE65: "soft",
// 	NE66: "soft",
// 	NE67: "soft",
// 	NE68: "soft",
// 	NE69: "soft",
// 	NE7: "soft",
// 	NE70: "soft",
// 	NE71: "soft",
// 	NE8: "soft",
// 	NE82: "soft",
// 	NE83: "soft",
// 	NE85: "soft",
// 	NE88: "soft",
// 	NE89: "soft",
// 	NE9: "soft",
// 	NE92: "soft",
// 	NE98: "soft",
// 	NE99: "soft",
// 	NG1: "soft",
// 	NG10: "soft",
// 	NG11: "soft",
// 	NG12: "soft",
// 	NG13: "soft",
// 	NG14: "soft",
// 	NG15: "soft",
// 	NG16: "soft",
// 	NG17: "soft",
// 	NG18: "soft",
// 	NG19: "soft",
// 	NG2: "soft",
// 	NG20: "soft",
// 	NG21: "soft",
// 	NG22: "soft",
// 	NG23: "hard",
// 	NG24: "hard",
// 	NG25: "hard",
// 	NG3: "soft",
// 	NG31: "hard",
// 	NG32: "hard",
// 	NG33: "hard",
// 	NG34: "soft",
// 	NG4: "soft",
// 	NG5: "soft",
// 	NG6: "soft",
// 	NG7: "soft",
// 	NG70: "soft",
// 	NG8: "soft",
// 	NG80: "soft",
// 	NG9: "soft",
// 	NG90: "soft",
// 	NN1: "hard",
// 	NN10: "hard",
// 	NN11: "soft",
// 	NN12: "hard",
// 	NN13: "hard",
// 	NN14: "soft",
// 	NN15: "hard",
// 	NN16: "hard",
// 	NN17: "soft",
// 	NN18: "hard",
// 	NN2: "soft",
// 	NN29: "hard",
// 	NN3: "hard",
// 	NN4: "hard",
// 	NN5: "soft",
// 	NN6: "hard",
// 	NN7: "hard",
// 	NN8: "soft",
// 	NN9: "hard",
// 	NN99: "hard",
// 	NP1: "soft",
// 	NP10: "soft",
// 	NP11: "soft",
// 	NP12: "soft",
// 	NP13: "soft",
// 	NP15: "soft",
// 	NP16: "soft",
// 	NP18: "soft",
// 	NP19: "soft",
// 	NP2: "soft",
// 	NP20: "soft",
// 	NP22: "soft",
// 	NP23: "soft",
// 	NP24: "soft",
// 	NP25: "soft",
// 	NP26: "soft",
// 	NP3: "soft",
// 	NP4: "soft",
// 	NP44: "soft",
// 	NP5: "soft",
// 	NP6: "soft",
// 	NP7: "soft",
// 	NP8: "soft",
// 	NP9: "soft",
// 	NPT: "soft",
// 	NR1: "hard",
// 	NR10: "hard",
// 	NR11: "hard",
// 	NR12: "hard",
// 	NR13: "hard",
// 	NR14: "hard",
// 	NR15: "hard",
// 	NR16: "hard",
// 	NR17: "hard",
// 	NR18: "hard",
// 	NR19: "hard",
// 	NR2: "hard",
// 	NR20: "hard",
// 	NR21: "hard",
// 	NR22: "hard",
// 	NR23: "hard",
// 	NR24: "hard",
// 	NR25: "hard",
// 	NR26: "hard",
// 	NR27: "hard",
// 	NR28: "hard",
// 	NR29: "hard",
// 	NR3: "hard",
// 	NR30: "hard",
// 	NR31: "hard",
// 	NR32: "hard",
// 	NR33: "hard",
// 	NR34: "hard",
// 	NR35: "hard",
// 	NR4: "hard",
// 	NR5: "hard",
// 	NR6: "hard",
// 	NR7: "hard",
// 	NR8: "hard",
// 	NR9: "hard",
// 	NR99: "hard",
// 	NW1: "hard",
// 	NW10: "hard",
// 	NW11: "hard",
// 	NW1W: "hard",
// 	NW2: "hard",
// 	NW26: "hard",
// 	NW3: "soft",
// 	NW4: "hard",
// 	NW5: "hard",
// 	NW6: "hard",
// 	NW7: "hard",
// 	NW8: "hard",
// 	NW9: "hard",
// 	OL1: "soft",
// 	OL10: "soft",
// 	OL11: "soft",
// 	OL12: "soft",
// 	OL13: "soft",
// 	OL14: "soft",
// 	OL15: "soft",
// 	OL16: "soft",
// 	OL2: "soft",
// 	OL3: "soft",
// 	OL4: "soft",
// 	OL5: "soft",
// 	OL6: "soft",
// 	OL7: "soft",
// 	OL8: "soft",
// 	OL9: "soft",
// 	OL95: "soft",
// 	OX1: "hard",
// 	OX10: "hard",
// 	OX11: "hard",
// 	OX12: "hard",
// 	OX13: "hard",
// 	OX14: "hard",
// 	OX15: "hard",
// 	OX16: "hard",
// 	OX17: "hard",
// 	OX18: "hard",
// 	OX2: "hard",
// 	OX20: "hard",
// 	OX25: "hard",
// 	OX26: "hard",
// 	OX27: "hard",
// 	OX28: "hard",
// 	OX29: "hard",
// 	OX3: "hard",
// 	OX33: "hard",
// 	OX39: "hard",
// 	OX4: "hard",
// 	OX44: "hard",
// 	OX49: "hard",
// 	OX5: "hard",
// 	OX6: "hard",
// 	OX7: "hard",
// 	OX8: "hard",
// 	OX9: "hard",
// 	PA1: "soft",
// 	PA10: "soft",
// 	PA11: "soft",
// 	PA12: "soft",
// 	PA13: "soft",
// 	PA14: "soft",
// 	PA15: "soft",
// 	PA16: "soft",
// 	PA17: "soft",
// 	PA18: "soft",
// 	PA19: "soft",
// 	PA2: "soft",
// 	PA20: "soft",
// 	PA21: "soft",
// 	PA22: "soft",
// 	PA23: "soft",
// 	PA24: "soft",
// 	PA25: "soft",
// 	PA26: "soft",
// 	PA27: "soft",
// 	PA28: "soft",
// 	PA29: "soft",
// 	PA3: "soft",
// 	PA30: "soft",
// 	PA31: "soft",
// 	PA32: "soft",
// 	PA33: "soft",
// 	PA34: "soft",
// 	PA35: "soft",
// 	PA36: "soft",
// 	PA37: "soft",
// 	PA38: "soft",
// 	PA39: "soft",
// 	PA4: "soft",
// 	PA40: "soft",
// 	PA41: "soft",
// 	PA42: "soft",
// 	PA43: "soft",
// 	PA44: "soft",
// 	PA45: "soft",
// 	PA46: "soft",
// 	PA47: "soft",
// 	PA48: "soft",
// 	PA49: "soft",
// 	PA5: "soft",
// 	PA6: "soft",
// 	PA60: "soft",
// 	PA61: "soft",
// 	PA62: "soft",
// 	PA63: "soft",
// 	PA64: "soft",
// 	PA65: "soft",
// 	PA66: "soft",
// 	PA67: "soft",
// 	PA68: "soft",
// 	PA69: "soft",
// 	PA7: "soft",
// 	PA70: "soft",
// 	PA71: "soft",
// 	PA72: "soft",
// 	PA73: "soft",
// 	PA74: "soft",
// 	PA75: "soft",
// 	PA76: "soft",
// 	PA77: "soft",
// 	PA78: "soft",
// 	PA8: "soft",
// 	PA80: "soft",
// 	PA81: "soft",
// 	PA82: "soft",
// 	PA83: "soft",
// 	PA84: "soft",
// 	PA85: "soft",
// 	PA86: "soft",
// 	PA87: "soft",
// 	PA88: "soft",
// 	PA9: "soft",
// 	PA98: "soft",
// 	PE1: "hard",
// 	PE10: "hard",
// 	PE11: "hard",
// 	PE12: "hard",
// 	PE13: "hard",
// 	PE14: "hard",
// 	PE15: "soft",
// 	PE16: "hard",
// 	PE17: "hard",
// 	PE18: "hard",
// 	PE19: "hard",
// 	PE2: "hard",
// 	PE20: "hard",
// 	PE21: "hard",
// 	PE22: "hard",
// 	PE23: "hard",
// 	PE24: "hard",
// 	PE25: "hard",
// 	PE26: "hard",
// 	PE27: "hard",
// 	PE28: "hard",
// 	PE29: "hard",
// 	PE3: "hard",
// 	PE30: "hard",
// 	PE31: "hard",
// 	PE32: "hard",
// 	PE33: "hard",
// 	PE34: "hard",
// 	PE35: "hard",
// 	PE36: "hard",
// 	PE37: "hard",
// 	PE38: "soft",
// 	PE4: "hard",
// 	PE5: "hard",
// 	PE6: "hard",
// 	PE7: "soft",
// 	PE8: "hard",
// 	PE9: "hard",
// 	PE99: "hard",
// 	PH1: "soft",
// 	PH10: "soft",
// 	PH11: "soft",
// 	PH12: "soft",
// 	PH13: "soft",
// 	PH14: "soft",
// 	PH15: "soft",
// 	PH16: "soft",
// 	PH17: "soft",
// 	PH18: "soft",
// 	PH19: "soft",
// 	PH2: "soft",
// 	PH20: "soft",
// 	PH21: "soft",
// 	PH22: "soft",
// 	PH23: "soft",
// 	PH24: "soft",
// 	PH25: "soft",
// 	PH26: "soft",
// 	PH3: "soft",
// 	PH30: "soft",
// 	PH31: "soft",
// 	PH32: "soft",
// 	PH33: "soft",
// 	PH34: "soft",
// 	PH35: "soft",
// 	PH36: "soft",
// 	PH37: "soft",
// 	PH38: "soft",
// 	PH39: "soft",
// 	PH4: "soft",
// 	PH40: "soft",
// 	PH41: "soft",
// 	PH42: "soft",
// 	PH43: "soft",
// 	PH44: "soft",
// 	PH49: "soft",
// 	PH5: "soft",
// 	PH50: "soft",
// 	PH6: "soft",
// 	PH7: "soft",
// 	PH8: "soft",
// 	PH9: "soft",
// 	PL1: "soft",
// 	PL10: "soft",
// 	PL11: "soft",
// 	PL12: "soft",
// 	PL13: "soft",
// 	PL14: "soft",
// 	PL15: "soft",
// 	PL16: "soft",
// 	PL17: "soft",
// 	PL18: "soft",
// 	PL19: "soft",
// 	PL2: "soft",
// 	PL20: "soft",
// 	PL21: "soft",
// 	PL22: "soft",
// 	PL23: "soft",
// 	PL24: "soft",
// 	PL25: "soft",
// 	PL26: "soft",
// 	PL27: "soft",
// 	PL28: "soft",
// 	PL29: "soft",
// 	PL3: "soft",
// 	PL30: "soft",
// 	PL31: "soft",
// 	PL32: "soft",
// 	PL33: "soft",
// 	PL34: "soft",
// 	PL35: "soft",
// 	PL4: "soft",
// 	PL5: "soft",
// 	PL6: "soft",
// 	PL7: "soft",
// 	PL8: "soft",
// 	PL9: "soft",
// 	PL95: "soft",
// 	PO1: "hard",
// 	PO10: "hard",
// 	PO11: "hard",
// 	PO12: "hard",
// 	PO13: "hard",
// 	PO14: "hard",
// 	PO15: "hard",
// 	PO16: "hard",
// 	PO17: "hard",
// 	PO18: "hard",
// 	PO19: "hard",
// 	PO2: "hard",
// 	PO20: "hard",
// 	PO21: "hard",
// 	PO22: "hard",
// 	PO24: "hard",
// 	PO3: "hard",
// 	PO30: "hard",
// 	PO31: "hard",
// 	PO32: "hard",
// 	PO33: "soft",
// 	PO34: "soft",
// 	PO35: "hard",
// 	PO36: "soft",
// 	PO37: "hard",
// 	PO38: "hard",
// 	PO39: "hard",
// 	PO4: "hard",
// 	PO40: "hard",
// 	PO41: "hard",
// 	PO5: "hard",
// 	PO6: "hard",
// 	PO7: "hard",
// 	PO8: "hard",
// 	PO9: "hard",
// 	PR0: "soft",
// 	PR1: "soft",
// 	PR11: "soft",
// 	PR2: "soft",
// 	PR25: "soft",
// 	PR26: "soft",
// 	PR3: "soft",
// 	PR4: "soft",
// 	PR5: "soft",
// 	PR6: "soft",
// 	PR7: "soft",
// 	PR8: "soft",
// 	PR9: "soft",
// 	RG1: "hard",
// 	RG10: "hard",
// 	RG11: "hard",
// 	RG12: "hard",
// 	RG13: "hard",
// 	RG14: "hard",
// 	RG15: "hard",
// 	RG16: "hard",
// 	RG17: "hard",
// 	RG18: "hard",
// 	RG19: "hard",
// 	RG2: "hard",
// 	RG20: "hard",
// 	RG21: "hard",
// 	RG22: "hard",
// 	RG23: "hard",
// 	RG24: "hard",
// 	RG25: "hard",
// 	RG26: "hard",
// 	RG27: "hard",
// 	RG28: "hard",
// 	RG29: "hard",
// 	RG3: "hard",
// 	RG30: "hard",
// 	RG31: "hard",
// 	RG4: "hard",
// 	RG40: "hard",
// 	RG41: "hard",
// 	RG42: "hard",
// 	RG45: "hard",
// 	RG5: "hard",
// 	RG6: "hard",
// 	RG7: "hard",
// 	RG8: "hard",
// 	RG9: "hard",
// 	RH1: "soft",
// 	RH10: "soft",
// 	RH11: "soft",
// 	RH12: "soft",
// 	RH13: "soft",
// 	RH14: "soft",
// 	RH15: "soft",
// 	RH16: "soft",
// 	RH17: "soft",
// 	RH18: "soft",
// 	RH19: "soft",
// 	RH2: "hard",
// 	RH20: "hard",
// 	RH3: "soft",
// 	RH4: "soft",
// 	RH5: "soft",
// 	RH6: "soft",
// 	RH7: "soft",
// 	RH77: "soft",
// 	RH8: "soft",
// 	RH9: "soft",
// 	RM1: "hard",
// 	RM10: "hard",
// 	RM11: "soft",
// 	RM12: "hard",
// 	RM13: "hard",
// 	RM14: "hard",
// 	RM15: "hard",
// 	RM16: "hard",
// 	RM17: "hard",
// 	RM18: "hard",
// 	RM19: "hard",
// 	RM2: "hard",
// 	RM20: "hard",
// 	RM3: "hard",
// 	RM4: "hard",
// 	RM5: "hard",
// 	RM50: "hard",
// 	RM6: "hard",
// 	RM7: "hard",
// 	RM8: "hard",
// 	RM9: "hard",
// 	S1: "soft",
// 	S10: "soft",
// 	S11: "soft",
// 	S12: "soft",
// 	S13: "soft",
// 	S14: "soft",
// 	S17: "soft",
// 	S18: "soft",
// 	S19: "soft",
// 	S2: "soft",
// 	S20: "soft",
// 	S21: "soft",
// 	S25: "soft",
// 	S26: "soft",
// 	S3: "soft",
// 	S30: "soft",
// 	S31: "soft",
// 	S32: "soft",
// 	S33: "soft",
// 	S35: "soft",
// 	S36: "soft",
// 	S4: "soft",
// 	S40: "soft",
// 	S41: "soft",
// 	S42: "soft",
// 	S43: "soft",
// 	S44: "soft",
// 	S45: "soft",
// 	S49: "soft",
// 	S5: "soft",
// 	S6: "soft",
// 	S60: "soft",
// 	S61: "hard",
// 	S62: "hard",
// 	S63: "hard",
// 	S64: "hard",
// 	S65: "hard",
// 	S66: "hard",
// 	S69: "soft",
// 	S7: "soft",
// 	S70: "soft",
// 	S71: "soft",
// 	S72: "hard",
// 	S73: "hard",
// 	S74: "hard",
// 	S75: "soft",
// 	S8: "soft",
// 	S80: "soft",
// 	S81: "soft",
// 	S9: "soft",
// 	S94: "soft",
// 	S95: "soft",
// 	S96: "soft",
// 	S97: "soft",
// 	S98: "soft",
// 	S99: "soft",
// 	SA1: "soft",
// 	SA10: "soft",
// 	SA11: "soft",
// 	SA12: "soft",
// 	SA13: "soft",
// 	SA14: "soft",
// 	SA15: "soft",
// 	SA16: "soft",
// 	SA17: "soft",
// 	SA18: "soft",
// 	SA19: "soft",
// 	SA2: "soft",
// 	SA20: "soft",
// 	SA3: "soft",
// 	SA31: "soft",
// 	SA32: "soft",
// 	SA33: "soft",
// 	SA34: "soft",
// 	SA35: "soft",
// 	SA36: "soft",
// 	SA37: "soft",
// 	SA38: "soft",
// 	SA39: "soft",
// 	SA4: "soft",
// 	SA40: "soft",
// 	SA41: "soft",
// 	SA42: "soft",
// 	SA43: "soft",
// 	SA44: "soft",
// 	SA45: "soft",
// 	SA46: "soft",
// 	SA47: "soft",
// 	SA48: "soft",
// 	SA5: "soft",
// 	SA6: "soft",
// 	SA61: "soft",
// 	SA62: "soft",
// 	SA63: "soft",
// 	SA64: "soft",
// 	SA65: "soft",
// 	SA66: "soft",
// 	SA67: "soft",
// 	SA68: "soft",
// 	SA69: "soft",
// 	SA7: "soft",
// 	SA70: "soft",
// 	SA71: "soft",
// 	SA72: "soft",
// 	SA73: "soft",
// 	SA8: "soft",
// 	SA80: "soft",
// 	SA9: "soft",
// 	SA99: "soft",
// 	SE1: "hard",
// 	SE10: "hard",
// 	SE11: "hard",
// 	SE12: "hard",
// 	SE13: "hard",
// 	SE14: "hard",
// 	SE15: "hard",
// 	SE16: "hard",
// 	SE17: "hard",
// 	SE18: "hard",
// 	SE19: "hard",
// 	SE1P: "hard",
// 	SE2: "hard",
// 	SE20: "hard",
// 	SE21: "hard",
// 	SE22: "hard",
// 	SE23: "hard",
// 	SE24: "hard",
// 	SE25: "soft",
// 	SE26: "hard",
// 	SE27: "soft",
// 	SE28: "hard",
// 	SE3: "hard",
// 	SE4: "hard",
// 	SE5: "hard",
// 	SE6: "hard",
// 	SE7: "hard",
// 	SE8: "hard",
// 	SE9: "hard",
// 	SE99: "hard",
// 	SG1: "hard",
// 	SG10: "hard",
// 	SG11: "hard",
// 	SG12: "hard",
// 	SG13: "hard",
// 	SG14: "hard",
// 	SG15: "hard",
// 	SG16: "hard",
// 	SG17: "hard",
// 	SG18: "hard",
// 	SG19: "hard",
// 	SG2: "hard",
// 	SG3: "hard",
// 	SG4: "hard",
// 	SG5: "hard",
// 	SG6: "hard",
// 	SG7: "hard",
// 	SG8: "hard",
// 	SG9: "hard",
// 	SK1: "soft",
// 	SK10: "soft",
// 	SK11: "soft",
// 	SK12: "soft",
// 	SK13: "soft",
// 	SK14: "soft",
// 	SK15: "soft",
// 	SK16: "soft",
// 	SK17: "soft",
// 	SK2: "soft",
// 	SK22: "soft",
// 	SK23: "soft",
// 	SK3: "soft",
// 	SK4: "soft",
// 	SK5: "soft",
// 	SK6: "soft",
// 	SK7: "soft",
// 	SK8: "soft",
// 	SK9: "soft",
// 	SL0: "hard",
// 	SL1: "hard",
// 	SL2: "hard",
// 	SL3: "hard",
// 	SL4: "hard",
// 	SL5: "hard",
// 	SL6: "hard",
// 	SL60: "hard",
// 	SL7: "hard",
// 	SL8: "hard",
// 	SL9: "hard",
// 	SL95: "hard",
// 	SM1: "soft",
// 	SM2: "hard",
// 	SM3: "soft",
// 	SM4: "soft",
// 	SM5: "soft",
// 	SM6: "soft",
// 	SM7: "hard",
// 	SN1: "hard",
// 	SN10: "hard",
// 	SN11: "hard",
// 	SN12: "hard",
// 	SN13: "hard",
// 	SN14: "hard",
// 	SN15: "hard",
// 	SN16: "hard",
// 	SN17: "hard",
// 	SN2: "hard",
// 	SN25: "hard",
// 	SN26: "hard",
// 	SN3: "hard",
// 	SN38: "hard",
// 	SN4: "hard",
// 	SN42: "hard",
// 	SN5: "hard",
// 	SN6: "hard",
// 	SN7: "hard",
// 	SN8: "hard",
// 	SN86: "hard",
// 	SN9: "soft",
// 	SN99: "soft",
// 	SO1: "hard",
// 	SO14: "hard",
// 	SO15: "hard",
// 	SO16: "hard",
// 	SO17: "hard",
// 	SO18: "hard",
// 	SO19: "hard",
// 	SO2: "hard",
// 	SO20: "hard",
// 	SO21: "hard",
// 	SO22: "hard",
// 	SO23: "hard",
// 	SO24: "hard",
// 	SO25: "hard",
// 	SO3: "hard",
// 	SO30: "hard",
// 	SO31: "hard",
// 	SO32: "hard",
// 	SO4: "hard",
// 	SO40: "hard",
// 	SO41: "hard",
// 	SO42: "hard",
// 	SO43: "hard",
// 	SO45: "hard",
// 	SO5: "hard",
// 	SO50: "hard",
// 	SO51: "hard",
// 	SO52: "hard",
// 	SO53: "hard",
// 	SO9: "hard",
// 	SO97: "hard",
// 	SP1: "hard",
// 	SP10: "hard",
// 	SP11: "hard",
// 	SP2: "hard",
// 	SP3: "hard",
// 	SP4: "hard",
// 	SP5: "hard",
// 	SP6: "hard",
// 	SP7: "hard",
// 	SP8: "hard",
// 	SP9: "hard",
// 	SR1: "soft",
// 	SR2: "soft",
// 	SR3: "soft",
// 	SR4: "soft",
// 	SR43: "soft",
// 	SR5: "soft",
// 	SR6: "soft",
// 	SR7: "soft",
// 	SR8: "soft",
// 	SR88: "soft",
// 	SR9: "soft",
// 	SS0: "soft",
// 	SS1: "hard",
// 	SS11: "hard",
// 	SS12: "hard",
// 	SS13: "hard",
// 	SS14: "hard",
// 	SS15: "hard",
// 	SS16: "hard",
// 	SS17: "soft",
// 	SS2: "hard",
// 	SS22: "hard",
// 	SS3: "hard",
// 	SS4: "hard",
// 	SS5: "hard",
// 	SS6: "soft",
// 	SS7: "hard",
// 	SS8: "hard",
// 	SS9: "hard",
// 	SS99: "hard",
// 	ST1: "hard",
// 	ST10: "hard",
// 	ST11: "soft",
// 	ST12: "soft",
// 	ST13: "soft",
// 	ST14: "soft",
// 	ST15: "hard",
// 	ST16: "hard",
// 	ST17: "soft",
// 	ST18: "hard",
// 	ST19: "soft",
// 	ST2: "hard",
// 	ST20: "hard",
// 	ST21: "soft",
// 	ST3: "hard",
// 	ST4: "soft",
// 	ST5: "soft",
// 	ST55: "soft",
// 	ST6: "soft",
// 	ST7: "soft",
// 	ST8: "soft",
// 	ST9: "hard",
// 	SW10: "hard",
// 	SW11: "hard",
// 	SW12: "hard",
// 	SW13: "hard",
// 	SW14: "hard",
// 	SW15: "hard",
// 	SW16: "hard",
// 	SW17: "hard",
// 	SW18: "hard",
// 	SW19: "hard",
// 	SW1A: "hard",
// 	SW1E: "hard",
// 	SW1H: "hard",
// 	SW1P: "hard",
// 	SW1V: "hard",
// 	SW1W: "hard",
// 	SW1X: "hard",
// 	SW1Y: "hard",
// 	SW2: "hard",
// 	SW20: "hard",
// 	SW3: "hard",
// 	SW4: "soft",
// 	SW5: "hard",
// 	SW6: "hard",
// 	SW7: "hard",
// 	SW8: "hard",
// 	SW9: "hard",
// 	SW95: "hard",
// 	SW99: "hard",
// 	SY1: "soft",
// 	SY10: "soft",
// 	SY11: "soft",
// 	SY12: "soft",
// 	SY13: "soft",
// 	SY14: "soft",
// 	SY15: "soft",
// 	SY16: "soft",
// 	SY17: "soft",
// 	SY18: "soft",
// 	SY19: "soft",
// 	SY2: "soft",
// 	SY20: "soft",
// 	SY21: "soft",
// 	SY22: "soft",
// 	SY23: "soft",
// 	SY24: "soft",
// 	SY25: "soft",
// 	SY3: "soft",
// 	SY4: "hard",
// 	SY5: "soft",
// 	SY6: "soft",
// 	SY7: "soft",
// 	SY8: "soft",
// 	SY9: "soft",
// 	SY99: "soft",
// 	TA1: "soft",
// 	TA10: "soft",
// 	TA11: "soft",
// 	TA12: "soft",
// 	TA13: "soft",
// 	TA14: "soft",
// 	TA15: "soft",
// 	TA16: "soft",
// 	TA17: "soft",
// 	TA18: "soft",
// 	TA19: "soft",
// 	TA2: "soft",
// 	TA20: "soft",
// 	TA21: "soft",
// 	TA22: "soft",
// 	TA23: "soft",
// 	TA24: "soft",
// 	TA3: "soft",
// 	TA4: "soft",
// 	TA5: "soft",
// 	TA6: "soft",
// 	TA7: "soft",
// 	TA8: "soft",
// 	TA9: "soft",
// 	TD1: "soft",
// 	TD10: "soft",
// 	TD11: "soft",
// 	TD12: "soft",
// 	TD13: "soft",
// 	TD14: "soft",
// 	TD15: "soft",
// 	TD2: "soft",
// 	TD3: "soft",
// 	TD4: "soft",
// 	TD5: "soft",
// 	TD6: "soft",
// 	TD7: "soft",
// 	TD8: "soft",
// 	TD9: "soft",
// 	TF1: "hard",
// 	TF10: "hard",
// 	TF11: "soft",
// 	TF12: "hard",
// 	TF13: "soft",
// 	TF2: "hard",
// 	TF3: "hard",
// 	TF4: "soft",
// 	TF5: "hard",
// 	TF6: "soft",
// 	TF7: "hard",
// 	TF8: "hard",
// 	TF9: "soft",
// 	TN1: "hard",
// 	TN10: "hard",
// 	TN11: "hard",
// 	TN12: "soft",
// 	TN13: "soft",
// 	TN14: "hard",
// 	TN15: "hard",
// 	TN16: "hard",
// 	TN17: "soft",
// 	TN18: "hard",
// 	TN19: "hard",
// 	TN2: "soft",
// 	TN20: "soft",
// 	TN21: "soft",
// 	TN22: "soft",
// 	TN23: "hard",
// 	TN24: "hard",
// 	TN25: "hard",
// 	TN26: "hard",
// 	TN27: "hard",
// 	TN28: "hard",
// 	TN29: "hard",
// 	TN3: "hard",
// 	TN30: "hard",
// 	TN31: "soft",
// 	TN32: "hard",
// 	TN33: "hard",
// 	TN34: "soft",
// 	TN35: "soft",
// 	TN36: "hard",
// 	TN37: "soft",
// 	TN38: "soft",
// 	TN39: "soft",
// 	TN4: "soft",
// 	TN40: "soft",
// 	TN5: "soft",
// 	TN6: "soft",
// 	TN7: "hard",
// 	TN8: "soft",
// 	TN9: "hard",
// 	TQ1: "soft",
// 	TQ10: "soft",
// 	TQ11: "soft",
// 	TQ12: "soft",
// 	TQ13: "soft",
// 	TQ14: "soft",
// 	TQ2: "soft",
// 	TQ3: "soft",
// 	TQ4: "soft",
// 	TQ5: "soft",
// 	TQ6: "soft",
// 	TQ7: "soft",
// 	TQ8: "soft",
// 	TQ9: "soft",
// 	TR1: "soft",
// 	TR10: "soft",
// 	TR11: "soft",
// 	TR12: "soft",
// 	TR13: "soft",
// 	TR14: "soft",
// 	TR15: "soft",
// 	TR16: "soft",
// 	TR17: "soft",
// 	TR18: "soft",
// 	TR19: "soft",
// 	TR2: "soft",
// 	TR20: "soft",
// 	TR21: "soft",
// 	TR22: "soft",
// 	TR23: "soft",
// 	TR24: "soft",
// 	TR25: "soft",
// 	TR26: "soft",
// 	TR27: "soft",
// 	TR3: "soft",
// 	TR4: "soft",
// 	TR5: "soft",
// 	TR6: "soft",
// 	TR7: "soft",
// 	TR8: "soft",
// 	TR9: "soft",
// 	TR93: "soft",
// 	TS1: "soft",
// 	TS10: "soft",
// 	TS11: "soft",
// 	TS12: "soft",
// 	TS13: "soft",
// 	TS14: "soft",
// 	TS15: "soft",
// 	TS16: "soft",
// 	TS17: "soft",
// 	TS18: "soft",
// 	TS19: "soft",
// 	TS2: "soft",
// 	TS20: "soft",
// 	TS21: "soft",
// 	TS22: "soft",
// 	TS23: "soft",
// 	TS24: "soft",
// 	TS25: "soft",
// 	TS26: "soft",
// 	TS27: "soft",
// 	TS28: "soft",
// 	TS29: "soft",
// 	TS3: "soft",
// 	TS4: "soft",
// 	TS5: "soft",
// 	TS6: "soft",
// 	TS7: "soft",
// 	TS8: "soft",
// 	TS9: "soft",
// 	TS90: "soft",
// 	TW1: "hard",
// 	TW10: "hard",
// 	TW11: "hard",
// 	TW12: "hard",
// 	TW13: "hard",
// 	TW14: "hard",
// 	TW15: "hard",
// 	TW16: "hard",
// 	TW17: "hard",
// 	TW18: "hard",
// 	TW19: "hard",
// 	TW2: "hard",
// 	TW20: "hard",
// 	TW3: "hard",
// 	TW4: "hard",
// 	TW5: "hard",
// 	TW6: "hard",
// 	TW7: "hard",
// 	TW8: "hard",
// 	TW9: "hard",
// 	UB1: "hard",
// 	UB10: "hard",
// 	UB11: "hard",
// 	UB18: "hard",
// 	UB2: "hard",
// 	UB3: "hard",
// 	UB4: "hard",
// 	UB5: "hard",
// 	UB6: "hard",
// 	UB7: "hard",
// 	UB8: "hard",
// 	UB9: "hard",
// 	W10: "hard",
// 	W11: "soft",
// 	W12: "hard",
// 	W13: "hard",
// 	W14: "hard",
// 	W1A: "hard",
// 	W1B: "hard",
// 	W1C: "hard",
// 	W1D: "hard",
// 	W1E: "hard",
// 	W1F: "hard",
// 	W1G: "hard",
// 	W1H: "hard",
// 	W1J: "hard",
// 	W1K: "hard",
// 	W1M: "hard",
// 	W1N: "hard",
// 	W1P: "hard",
// 	W1R: "hard",
// 	W1S: "hard",
// 	W1T: "hard",
// 	W1U: "hard",
// 	W1V: "hard",
// 	W1W: "hard",
// 	W1X: "hard",
// 	W1Y: "hard",
// 	W2: "hard",
// 	W3: "hard",
// 	W4: "hard",
// 	W5: "hard",
// 	W6: "hard",
// 	W7: "hard",
// 	W8: "hard",
// 	W9: "hard",
// 	WA1: "soft",
// 	WA10: "soft",
// 	WA11: "soft",
// 	WA12: "hard",
// 	WA13: "soft",
// 	WA14: "soft",
// 	WA15: "soft",
// 	WA16: "soft",
// 	WA2: "soft",
// 	WA3: "soft",
// 	WA4: "soft",
// 	WA5: "soft",
// 	WA55: "soft",
// 	WA6: "soft",
// 	WA7: "soft",
// 	WA8: "soft",
// 	WA88: "soft",
// 	WA9: "soft",
// 	WC1A: "hard",
// 	WC1B: "hard",
// 	WC1E: "hard",
// 	WC1H: "hard",
// 	WC1N: "hard",
// 	WC1R: "hard",
// 	WC1V: "hard",
// 	WC1X: "hard",
// 	WC2A: "hard",
// 	WC2B: "hard",
// 	WC2E: "hard",
// 	WC2H: "hard",
// 	WC2N: "hard",
// 	WC2R: "hard",
// 	WC99: "hard",
// 	WD1: "hard",
// 	WD17: "hard",
// 	WD18: "hard",
// 	WD19: "hard",
// 	WD2: "hard",
// 	WD23: "hard",
// 	WD24: "hard",
// 	WD25: "hard",
// 	WD3: "hard",
// 	WD4: "hard",
// 	WD5: "hard",
// 	WD6: "hard",
// 	WD7: "hard",
// 	WD99: "hard",
// 	WF1: "soft",
// 	WF10: "soft",
// 	WF11: "soft",
// 	WF12: "soft",
// 	WF13: "soft",
// 	WF14: "soft",
// 	WF15: "soft",
// 	WF16: "soft",
// 	WF17: "soft",
// 	WF2: "soft",
// 	WF3: "soft",
// 	WF4: "soft",
// 	WF5: "soft",
// 	WF6: "soft",
// 	WF7: "soft",
// 	WF8: "soft",
// 	WF9: "soft",
// 	WF90: "soft",
// 	WR1: "soft",
// 	WR10: "soft",
// 	WR11: "soft",
// 	WR12: "soft",
// 	WR13: "soft",
// 	WR14: "soft",
// 	WR15: "soft",
// 	WR2: "soft",
// 	WR3: "soft",
// 	WR4: "soft",
// 	WR5: "soft",
// 	WR6: "soft",
// 	WR7: "soft",
// 	WR78: "soft",
// 	WR8: "soft",
// 	WR9: "soft",
// 	WR99: "soft",
// 	WS1: "soft",
// 	WS10: "soft",
// 	WS11: "soft",
// 	WS12: "hard",
// 	WS13: "soft",
// 	WS14: "soft",
// 	WS15: "soft",
// 	WS2: "soft",
// 	WS3: "soft",
// 	WS4: "soft",
// 	WS5: "soft",
// 	WS6: "soft",
// 	WS7: "soft",
// 	WS8: "hard",
// 	WS9: "soft",
// 	WV1: "soft",
// 	WV10: "soft",
// 	WV11: "soft",
// 	WV12: "soft",
// 	WV13: "soft",
// 	WV14: "soft",
// 	WV15: "soft",
// 	WV16: "hard",
// 	WV2: "soft",
// 	WV3: "soft",
// 	WV4: "soft",
// 	WV5: "soft",
// 	WV6: "hard",
// 	WV7: "hard",
// 	WV8: "soft",
// 	WV9: "soft",
// 	WV98: "soft",
// 	WV99: "soft",
// 	YO1: "hard",
// 	YO10: "hard",
// 	YO11: "hard",
// 	YO12: "hard",
// 	YO13: "soft",
// 	YO14: "hard",
// 	YO15: "hard",
// 	YO16: "hard",
// 	YO17: "hard",
// 	YO18: "hard",
// 	YO19: "hard",
// 	YO2: "hard",
// 	YO21: "hard",
// 	YO22: "hard",
// 	YO23: "hard",
// 	YO24: "hard",
// 	YO25: "hard",
// 	YO26: "hard",
// 	YO3: "hard",
// 	YO30: "hard",
// 	YO31: "hard",
// 	YO32: "hard",
// 	YO4: "hard",
// 	YO41: "hard",
// 	YO42: "hard",
// 	YO43: "hard",
// 	YO5: "hard",
// 	YO51: "hard",
// 	YO6: "soft",
// 	YO60: "soft",
// 	YO61: "soft",
// 	YO62: "hard",
// 	YO7: "hard",
// 	YO8: "hard",
// 	YO90: "hard",
// 	YO91: "hard",
// 	YO95: "hard",
// }
// // Todo: Add test
// class SystemBuilderFunc {
// 	constructor(section) {
// 		// All Data
// 		this.defaultData = {
// 			'select-van': {
// 				'van-pretitle': '',
// 				'van-title': '',
// 				'van-img': 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/Untitled_design_8.png?v=1631820045',
// 				'van-selected-type': null,
// 				'van-selected-size': null,
// 				'show-completed': false,
// 				'completed': false
// 			},
// 			'select-filtration': {
// 				'completed': false,
// 				'filtration': null,
// 				'pretitle': '',
// 				'title': '',
// 				'man': null
// 			},
// 			'select-system': {
// 				'completed': false,
// 				'system-sizes': null,
// 				'system-reels': null,
// 				'selected-reels': null,
// 				'system': null,
// 				'system-img': '',
// 				'system-name': null,
// 				'amount': 0,
// 				'amount-prev': 0,
// 				'discount': 0,
// 				'products': {}
// 			},
// 			'select-hot': {
// 				'hot-option': null,
// 				'hop-operators': null,
// 				'hot-product': null,
// 				'hot-image': 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/all_systems_3.png',
// 				'completed': false
// 			},
// 			'select-accessories': {
// 				'completed': false,
// 				'products': {}
// 			},
// 			'select-fitting': {
// 				'completed': false,
// 				'handle': null,
// 				'img': null,
// 				'amount': 0,
// 				'location': null
// 			},
// 			'select-total': {
// 				'completed': false
// 			}
// 		}
// 		this.data = Cookies.getCookie('system-builder') ? JSON.parse(Cookies.getCookie('system-builder')) : this.defaultData;

// 		// Select Van
// 		this.selectVan = section.querySelector('#select-van');
// 		this.vanPretitle = section.querySelector('#select-van-pretitle');
// 		this.vanTitle = section.querySelector('#select-van-title');
// 		this.vanImg = section.querySelector('#select-van-img');
// 		this.vanLicense = section.querySelector('#select-van-license');
// 		this.vanLicenseResults = section.querySelector('#select-van-results')
// 		this.vanLicenseLoading = this.vanLicenseResults.querySelector('.sb-loading');
// 		this.vanLicenseResultsList = this.vanLicenseResults.querySelector('#select-van-results-list');
// 		this.vanNone = section.querySelector('#select-van-none');
// 		this.vanSizes = section.querySelector('#select-van-sizes');
// 		this.vanNotListed = section.querySelector('#select-van-not-listed');
// 		this.vanExplanation = section.querySelector('#select-van-explanation');
// 		this.vanSizeText = section.querySelector('#select-van-size');

// 		this.vanOptions = {
// 			'van-pretitle': 'Van Selected',
// 			'no-van-title': 'No Van Selected',
// 			'no-van': 'I Don\'t Have My Van Yet',
// 			'van-img-default': 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/Untitled_design_8.png?v=1631820045',
// 			'no-van-img-default': 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/Untitled_design_9_280b0821-a576-432f-911a-324390df215f.png?v=1631820044',
// 			'no-licence-found': '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">No Van Found</p>'
// 		}

// 		// Select Filtration
// 		this.selectFiltration = section.querySelector('#select-filtration');
// 		this.selectFiltrationPretitle = section.querySelector('#select-filtration-pretitle');
// 		this.selectFiltrationTitle = section.querySelector('#select-filtration-title');
// 		this.selectFiltrationImg = section.querySelector('#select-filtration-img');
// 		this.selectFiltrationSelects = section.querySelector('#filtration-select');
// 		this.selectFiltrationSelectsBtns = this.selectFiltrationSelects.querySelectorAll('.sb-btn');
// 		this.selectFiltrationRo = this.selectFiltrationSelects.querySelector('#filtration-ro-di');
// 		this.selectFiltrationDi = this.selectFiltrationSelects.querySelector('#filtration-di-only');
// 		this.selectMan = section.querySelector('#man-select');
// 		this.selectManBtns = this.selectMan.querySelectorAll('.sb-btn');

// 		this.filtPostcode = section.querySelector('#select-filtration-postcode');
// 		this.filtPostcodeResults = section.querySelector('#select-filtration-results');
// 		this.filtPostcodeLoading = this.filtPostcodeResults.querySelector('.sb-loading');
// 		this.filtPostcodeResultsList = this.filtPostcodeResults.querySelector('#select-filtration-results-list');
// 		this.filtAnswer = section.querySelector('#select-filtration-answer');

// 		// Select
// 		this.selectSystem = section.querySelector('#select-system');
// 		this.selectSystemSection = section.querySelector('#select-system-section');
// 		this.systemProducts = this.selectSystem.querySelectorAll('.sb-product');
// 		this.systemPretitle = section.querySelector('#select-system-pretitle');
// 		this.systemTitle = section.querySelector('#select-system-title');
// 		this.systemImg = section.querySelector('#select-system-img');
// 		this.systemPrice = section.querySelector('#select-system-price');
// 		this.systemPoints = section.querySelector('#select-system-points');

// 		this.systemSizes = section.querySelectorAll('.sb__sizes');
// 		this.systemReels = section.querySelector('#select-system-reel');
// 		this.systemReelOptions = this.systemReels.querySelectorAll('.select-system-reel');

// 		this.selectHot = section.querySelector('#select-hot');
// 		this.selectHotOptions = section.querySelector('#select-hot-options');
// 		this.selectHotOperators = section.querySelector('#select-hot-operators');
// 		this.selectHotProducts = section.querySelector('#hot-product-select');
// 		this.selectHotProductOptions = section.querySelectorAll('.sb-hot-product');
// 		this.selectHotProductImg = section.querySelector('#select-hot-img');

// 		// Accessories
// 		this.selectAccessories = section.querySelector('#select-accessories');
// 		this.selectAccessoriesProducts = section.querySelectorAll('.sb-product-accessory');
// 		this.selectAccessoriesImg = section.querySelector('#select-accessories-img');
// 		this.selectAccessoriesContainer = section.querySelector('#select-accessories-container');

// 		// Fitting
// 		this.selectFitting = section.querySelector('#select-fitting');
// 		this.selectFittingPretitle = section.querySelector('#select-fitting-pretitle');
// 		this.selectFittingTitle = section.querySelector('#select-fitting-title');
// 		this.selectFittingOptions = section.querySelectorAll('.select-fitting-option');
// 		this.selectFittingImg = section.querySelector('#select-fitting-img');
// 		this.selectFittingHtml = section.querySelectorAll('.select-fitting-html');
// 		this.selectFittingPrice = section.querySelector('#select-fitting-price');

// 		// Total
// 		this.selectTotal = section.querySelector('#select-total');
// 		this.selectTotalSelection = section.querySelector('#select-total-selection');
// 		this.selectFormOptions = section.querySelector('#select-form-options');

// 		// Total Price
// 		this.selectTotalPrice = section.querySelectorAll('.select-total-price');
// 		this.selectFinance = section.querySelector('#select-finance');
// 		this.financeBlock = section.querySelector('.finance-block');
// 		this.selectBuyBtn = section.querySelector('#select-total-buy');

// 		// All Sections
// 		this.allSections = [
// 			this.selectVan,
// 			this.selectFiltration,
// 			this.selectSystem,
// 			this.selectHot,
// 			this.selectAccessories,
// 			this.selectFitting,
// 			this.selectTotal
// 		]

// 		this.allFunctions = {
// 			'select-van': 'initVan',
// 			'select-filtration': 'initFiltration',
// 			'select-system': 'initSystem',
// 			'select-hot': 'initHot',
// 			'select-accessories': 'initAccessories',
// 			'select-fitting': 'initFitting',
// 			'select-total': 'initTotal'
// 		}

// 		this.completedSections = []

// 		// Image
// 		this.filtrationImg = 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/{{id}}.png'
// 		this.systemDefaultImg = 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/all_systems.png?v=1633342182'
// 		this.fittingDefault = 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/all_systems_1.png?v=1633342516'

// 		// All Arrow
// 		this.arrows = {
// 			'select-van': document.querySelector('#arrow-van'),
// 			'select-filtration': document.querySelector('#arrow-filtration'),
// 			'select-system': document.querySelector('#arrow-system'),
// 			'select-hot': document.querySelector('#arrow-hot'),
// 			'select-accessories': document.querySelector('#arrow-accessory'),
// 			'select-fitting': document.querySelector('#arrow-fitting'),
// 			'select-total': document.querySelector('#arrow-total')
// 		}

// 		this.totalHtml = {
// 			'result': '<p><span class="text-extra-bold mt-5 mr-5">{{k}}:</span>{{v}}</p>',
// 			'product': `
// 				<div class="col-one-half col-lg-one-third sb__product--selected sb__product">
// 					<div class="product-block">
// 					  	<div class="relative">
// 					  		<img src="{{productImg}}" alt="{{productTitle}}">
// 					    </div>
// 					    <p class="text-mediumbold mb-5">{{productTitle}}</p>
// 					    {{productPrice}}
// 					    {{productDetails}}
// 					</div>
// 				</div>
// 			`,
// 			'price': `
// 				<p 
// 					data-gbp-price="{{priceAmountFormatted}}"
// 					data-amount="{{priceAmount}}"
// 					data-alt-price="{{vatPriceAmountFormatted}}" 
// 					data-vat-status="exc" 
// 				  	data-discount="0"
// 					class="text-light font-medium-plus font-green price-main money price-gbp">{{priceAmountFormatted}}</p> 
// 				<p 
// 					data-alt-price="{{priceAmountFormatted}}" 
// 					data-vat-status="inc"
// 				  	data-discount="0"
// 					class="font-tiny font-light-grey price-second money price-gbp">{{vatPriceAmountFormatted}}</p> 
// 			`
// 		}


// 	}

// 	get getData() {
// 		let data = this.data;
// 		return data ? data : this.defaultData;
// 	}

// 	set setData(updateData) {
// 		/*
// 		Takes object
// 			step: Current step
// 			k: Key of what's changing
// 			v: New value
// 		*/
// 		const { step, k, v } = updateData;
// 		this.data[step][k] = v;
// 		Cookies.setCookie('system-builder', JSON.stringify(this.data), 90);
// 	}

// 	set setProduct(updateData) {
// 		/*
// 		Takes array
// 			0: ID
// 			1: Product data
// 		*/
// 		let dupProductObj = Object.assign({}, this.data['select-accessories'])
// 		dupProductObj['products'][updateData[0]] = updateData[1]
// 		Object.assign(this.data['select-accessories'], dupProductObj);

// 		Cookies.setCookie('system-builder', JSON.stringify(this.data), 90);
// 	}

// 	set deleteProduct(updateId) {
// 		let dupProductObj = Object.assign({}, this.data['select-accessories'])
// 		delete dupProductObj['products'][updateId];
// 		Object.assign(this.data['select-accessories'], dupProductObj);

// 		Cookies.setCookie('system-builder', JSON.stringify(this.data), 90);
// 	}

// 	set setDefaultData(step) {
// 		if(step == 'select-accessories') {
// 			Object.assign(this.data[step], {
// 				'completed': false,
// 				'products': {}
// 			});
// 		} else {
// 			Object.assign(this.data[step], this.defaultData[step]);
// 		}
// 	}

// 	visitedSection(section, status) {
// 		if(!status) {
// 			this.arrows[section].classList.add('sb__arrow--new');
// 			this.arrows[section].classList.remove('sb__arrow--active');
// 		} else if(status == 'active') {
// 			this.arrows[section].classList.remove('sb__arrow--new');
// 			this.arrows[section].classList.add('sb__arrow--active');
// 		} else if(status == 'visited') {
// 			this.arrows[section].classList.remove('sb__arrow--new');
// 			this.arrows[section].classList.remove('sb__arrow--active');
// 		}
// 	}

// 	hideAllSections(toShow) {
// 		for (var i = 0; i < this.allSections.length; i++) {
// 			if(this.allSections[i].id == toShow.id) {
// 				this.allSections[i].classList.remove('d-none');
// 			} else {
// 				this.allSections[i].classList.add('d-none');
// 			}
// 		}
// 	}

// 	initTotal() {
// 		this.hideAllSections(this.selectTotal);
// 		this.updateTotal();

// 		if(!this.completedSections.includes('initTotal')) {
// 			this.selectBuyBtn.addEventListener('click', function() {
// 				// const 
// 			})
// 			this.completedSections.push('initTotal');
// 		}	

// 	}

// 	updateTotal() {
// 		this.selectTotalSelection.innerHTML = '';

// 		// Update Van
// 		let vanStr = this.data['select-van']['van-selected-type'] == 'no-van' ? 'Not Purchased' : this.data['select-van']['van-selected-type'] == 'not-listed' ? 'Not Listed' : `${this.data['select-van']['van-pretitle']} ${this.data['select-van']['van-title']}`
// 		this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `
// 			<p class="text-extra-bold mb-10 font-medium">Van</p>
// 			${this.totalHtml.result.replace('{{k}}', 'Vehicle').replace('{{v}}',vanStr)}
// 			${this.totalHtml.result.replace('{{k}}', 'Size').replace('{{v}}', this.data['select-van']['van-selected-size'] ? this.data['select-van']['van-selected-size'] : 'N/A')}
// 			<img class="width-whole mt-5" src="${this.data['select-van']['van-img']}">
// 			<div data-step="select-van" class="sb-arrow text-bold mt-5">
// 				<p class="text-right">Edit</p>
// 			</div>
// 		`

// 		// Filtration
// 		this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `
// 			<p class="text-extra-bold mb-10 font-medium">Filtration</p>
// 			${this.totalHtml.result.replace('{{k}}', 'Filtration').replace('{{v}}', this.data['select-filtration']['filtration'].toUpperCase())}
// 			${this.totalHtml.result.replace('{{k}}', 'No. of Operators').replace('{{v}}', capitalizeWords(this.data['select-filtration']['man']))}
// 			<div data-step="select-filtration" class="sb-arrow text-bold mt-5">
// 				<p class="text-right">Edit</p>
// 			</div>
// 		`

// 		// System
// 		let currentPrice = this.data['select-system']['system']['price']
// 		let currentPriceFormatted = Currency.formatMoney(currentPrice, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')
// 		let currentVatPriceFormatted = Currency.formatMoney(currentPrice * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')
// 		let productPrice = this.totalHtml.price
// 			.replace(/\{{priceAmount}}/g, this.data['select-system']['system']['price'])
// 			.replace(/\{{priceAmountFormatted}}/g, currentPriceFormatted)
// 			.replace(/\{{vatPriceAmountFormatted}}/g, currentVatPriceFormatted)
// 		this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `
// 			<p class="text-extra-bold mb-10 font-medium">System</p>
// 			${this.totalHtml.result.replace('{{k}}', 'Size').replace('{{v}}', this.data['select-system']['system-sizes'] + ' Litre')}
// 			${this.data['select-system']['selected-reel'] ? this.totalHtml.result.replace('{{k}}', 'Reel Type').replace('{{v}}', this.data['select-system']['selected-reel']) : ''}
// 			<div class="row">
// 			${this.totalHtml.product
// 				.replace('{{productImg}}', this.data['select-system']['system-img'])
// 				.replace(/\{{productTitle}}/g, this.data['select-system']['system-name'])
// 				.replace(/\{{productPrice}}/g, productPrice)
// 				.replace('{{productDetails}}', '')}
// 			</div>
// 			<div data-step="select-system" class="sb-arrow width-whole text-bold mt-5">
// 				<p class="text-right">Edit</p>
// 			</div>
// 		`

// 		// Hot Water
// 		if(this.data['select-hot']['hot-product']) {
// 			let currentPrice = this.data['select-hot']['hot-product']['price']
// 			let currentPriceFormatted = Currency.formatMoney(currentPrice, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')
// 			let currentVatPriceFormatted = Currency.formatMoney(currentPrice * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')
// 			let productPrice = this.totalHtml.price
// 				.replace(/\{{priceAmount}}/g, this.data['select-system']['system']['price'])
// 				.replace(/\{{priceAmountFormatted}}/g, currentPriceFormatted)
// 				.replace(/\{{vatPriceAmountFormatted}}/g, currentVatPriceFormatted)
			
// 			this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `
// 				<p class="text-extra-bold mb-10 font-medium">Hot Water Upgrade</p>
// 				<div class="row">
// 				${this.totalHtml.product
// 					.replace('{{productImg}}', this.data['select-hot']['hot-image'])
// 					.replace(/\{{productTitle}}/g, this.data['select-hot']['hot-product']['name'])
// 					.replace(/\{{productPrice}}/g, productPrice)
// 					.replace('{{productDetails}}', '')}
// 				</div>
// 				<div data-step="select-hot" class="sb-arrow width-whole text-bold mt-5">
// 					<p class="text-right">Edit</p>
// 				</div>
// 			`
// 		} else {
// 			this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `
// 			<p class="text-extra-bold mb-10 font-medium">Hot Water Upgrade</p>
// 			${this.totalHtml.result.replace('{{k}}', 'Upgrade').replace('{{v}}', 'Not Selected')}
// 			`
// 		}

// 		// Fitting
// 		let fittingPrice = '';
// 		if(this.data['select-fitting']['location'] != 'Delivered') {
// 			let currentFittingPrice = this.data['select-fitting']['amount']
// 			let currentFittingPriceFormatted = Currency.formatMoney(currentFittingPrice, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')
// 			let currentFittingVatPriceFormatted = Currency.formatMoney(currentFittingPrice * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')

// 			fittingPrice = this.totalHtml.price
// 				.replace(/\{{priceAmount}}/g, currentFittingPrice)
// 				.replace(/\{{priceAmountFormatted}}/g, currentFittingPriceFormatted)
// 				.replace(/\{{vatPriceAmountFormatted}}/g, currentFittingVatPriceFormatted)
// 		}
// 		this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `
// 			<p class="text-extra-bold mb-10 font-medium">Fitting</p>
// 			${this.totalHtml.result.replace('{{k}}', 'Fitting').replace('{{v}}', this.data['select-fitting']['location'])}
// 			${fittingPrice}
// 			<div data-step="select-fitting" class="sb-arrow text-bold mt-5">
// 				<p class="text-right">Edit</p>
// 			</div>
// 		`

// 		// Accessories
// 		let accessoryStr = `
// 			<p class="text-extra-bold mb-10 font-medium">Accessories</p>
// 			<div class="row">`

// 		for (var i = 0; i < Object.values(this.data['select-accessories']['products']).length; i++) {
// 			let acProduct = Object.values(this.data['select-accessories']['products'])[i]
// 			let productAcPrice;
// 			if(acProduct['included']) {
// 				productAcPrice = '<p class="text-light font-medium-plus font-green">Included</p>'
// 			} else {
// 				let currentAcPrice = acProduct['price']
// 				let currentAcPriceFormatted = Currency.formatMoney(currentAcPrice, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')
// 				let currentAcVatPriceFormatted = Currency.formatMoney(currentAcPrice * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£')

// 				productAcPrice = this.totalHtml.price
// 					.replace(/\{{priceAmount}}/g, currentAcPrice)
// 					.replace(/\{{priceAmountFormatted}}/g, currentAcPriceFormatted)
// 					.replace(/\{{vatPriceAmountFormatted}}/g, currentAcVatPriceFormatted)
// 			}

// 			accessoryStr = accessoryStr + `
// 				${this.totalHtml.product
// 					.replace('{{productImg}}', acProduct['featured_image'])
// 					.replace(/\{{productTitle}}/g, acProduct['included'] ? acProduct['name'] : acProduct['product-title'])
// 					.replace(/\{{productPrice}}/g, productAcPrice)
// 					.replace('{{productDetails}}', !acProduct['included'] ? `
// 						${this.totalHtml['result'].replace('{{k}}', 'Selected').replace('{{v}}', `${acProduct['title']} x${acProduct['quantity']}`)}
// 					` : '')}
// 			`

// 			// Variants & Quantity
// 		}
// 		this.selectTotalSelection.innerHTML = this.selectTotalSelection.innerHTML + `${accessoryStr}			
// 		<div data-step="select-accessories" class="sb-arrow width-whole text-bold mt-5">
// 				<p class="text-right">Edit</p>
// 			</div>
// 		</div>`
// 		let accessoriesText = '';
// 		for (var i = 0; i < Object.values(this.data['select-accessories']['products']).length; i++) {
// 			let accessory = Object.values(this.data['select-accessories']['products'])[i];
// 			accessoriesText = accessoriesText + `${accessory['included'] ? '' : `${accessory['sku']}: ${accessory['name']} ${accessory['quantity'] ? `x${accessory['quantity']}` : ''} `}`;
// 		}


// 		const customFormOptions = [
// 			{'van': `${vanStr} - ${this.data['select-van']['van-selected-size'] ? `${this.spitOutText(this.data['select-van']['van-selected-size'])} van size` : ''}`},
// 			{'filtration': `${this.spitOutText(this.data['select-filtration']['filtration'])} - ${this.spitOutText(this.data['select-filtration']['man'])} operator`},
// 			{'system': `${this.spitOutText(this.data['select-system']['system-sizes'])} litre - ${this.data['select-system']['selected-reels'] ? this.spitOutText(this.data['select-system']['selected-reels']) : 'No included reel'} -${this.spitOutText(this.data['select-system']['system']['name'])}`},
// 			{'hot-water-upgrade': this.data['select-hot']['hot-product'] ? this.data['select-hot']['hot-product']['name'] : 'N/A'},
// 			{'accessories': accessoriesText},
// 			{'fitting': this.spitOutText(this.data['select-fitting']['location'])},
// 			{'total': `£${(this.getTotalPrice() / 100).toFixed(2)}`}
// 		]

// 		this.selectFormOptions.innerHTML = '';
// 		for (var i = 0; i < customFormOptions.length; i++) {
// 			const customFormOption = customFormOptions[i];
// 			this.selectFormOptions.innerHTML = this.selectFormOptions.innerHTML + `
// 				<input class="input-std" value="${Object.values(customFormOption)[0]}" type="${Object.keys(customFormOption)[0]}" name="contact[${Object.keys(customFormOption)[0]}]">
// 			`
// 		}

// 		Global.updateVat(false);
// 		this.totalHtml.result
// 	}

// 	initFitting() {
// 		this.hideAllSections(this.selectFitting);
// 		this.updateFitting();

// 		if(!this.completedSections.includes('initFitting')) {
// 			for (var i = 0; i < this.selectFittingOptions.length; i++) {
// 				let selectFittingOption = this.selectFittingOptions[i];
// 				this.selectFittingOptions[i].addEventListener('click', function() {
// 					this.setData = {
// 						'step': 'select-fitting', 
// 						'k': 'handle', 
// 						'v': selectFittingOption.getAttribute('data-location-handle')
// 					};
// 					this.setData = {
// 						'step': 'select-fitting', 
// 						'k': 'amount', 
// 						'v': selectFittingOption.getAttribute('data-fitting-price') ? selectFittingOption.getAttribute('data-fitting-price') : 0
// 					};
// 					this.setData = {
// 						'step': 'select-fitting', 
// 						'k': 'location', 
// 						'v': selectFittingOption.getAttribute('data-location')
// 					};
// 					this.setData = {
// 						'step': 'select-fitting', 
// 						'k': 'variant', 
// 						'v': selectFittingOption.getAttribute('data-location-id')
// 					};

// 					this.updateFitting();
// 				}.bind(this));
// 			}
// 			this.completedSections.push('initFitting');
// 		}
// 	}

// 	updateFitting() {
// 		// 'select-fitting': {
// 		// 	'completed': false
// 		// 	'handle': null,
// 		// 	'img': null,
// 		// 	'price': null,
// 		// 	'location': null
// 		// }
// 		let fittingInfo = this.data['select-fitting'];

// 		for (var i = 0; i < this.selectFittingOptions.length; i++) {
// 			if(this.selectFittingOptions[i].id == `fitting-${fittingInfo['handle']}`) {
// 				this.selectFittingOptions[i].classList.add('sb__btn--selected');
// 			} else {
// 				this.selectFittingOptions[i].classList.remove('sb__btn--selected');
// 			}
// 		}	

// 		// Update img
// 		this.selectFittingImg.setAttribute('src', this.fittingDefault);
// 		if(!this.data['select-fitting']['location']) {
// 			this.selectFittingImg.classList.remove('d-none');
// 		} else {
// 			this.selectFittingImg.classList.add('d-none');
// 		}

// 		// Update map		
// 		for (var i = 0; i < this.selectFittingHtml.length; i++) {
// 			if(this.selectFittingHtml[i].id == `html-${this.data['select-fitting']['handle']}`) {
// 				this.selectFittingHtml[i].classList.remove('d-none');
// 			} else {
// 				this.selectFittingHtml[i].classList.add('d-none');
// 			}
// 		}

// 		// Update price
// 		let amount = parseInt(this.data['select-fitting']['amount']);
// 		this.selectFittingPrice.querySelector('.price-main').setAttribute('data-amount', amount);
// 		this.selectFittingPrice.querySelector('.price-main').setAttribute('data-discount', this.data['select-system']['discount']);
// 		this.selectFittingPrice.querySelector('.price-main').setAttribute('data-alt-price', Currency.formatMoney(amount * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£'));
// 		this.selectFittingPrice.querySelector('.price-second').setAttribute('data-amount', amount * 1.2);
// 		this.selectFittingPrice.querySelector('.price-second').setAttribute('data-alt-price', Currency.formatMoney(amount, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£'));
// 		this.selectFittingPrice.querySelector('.price-second').textContent = (Currency.formatMoney(amount * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£'));

// 		this.selectFittingPrice.querySelector('.price-second').setAttribute('data-discount', this.data['select-system']['discount']);
// 		Global.updateCurrency();

// 		if(amount == 0) {
// 			this.selectFittingPrice.classList.add('d-none');
// 		} else {
// 			this.selectFittingPrice.classList.remove('d-none');
// 		}
		
// 		// Update text
// 		this.selectFittingPretitle.innerHTML = 'Selected Location';
// 		if(this.data['select-fitting']['location']) {
// 			this.selectFittingTitle.innerHTML = this.data['select-fitting']['location'];
// 		} else {
// 			this.selectFittingTitle.innerHTML = 'None Selected';
// 		}

// 		this.checkShowCompleted(this.selectFitting, fittingInfo['location']);
// 		this.updateTotalPrice();
// 	}

// 	initAccessories() {
// 		this.hideAllSections(this.selectAccessories);
// 		this.updateAccessories();

// 		if(!this.completedSections.includes('initAccessories')) {
// 			for (var i = 0; i < this.selectAccessoriesProducts.length; i++) {
// 				let selectAccessoriesProduct = this.selectAccessoriesProducts[i];
// 				if(!selectAccessoriesProduct.classList.contains('sb-product-included')) {
// 					let selectedSelect = selectAccessoriesProduct.querySelector('select');
// 					let selectedQuantity = selectAccessoriesProduct.querySelector('[type="number"]');
// 					let selectedMinus = selectAccessoriesProduct.querySelector('.minus');
// 					let selectedPlus = selectAccessoriesProduct.querySelector('.plus');

// 					this.selectAccessoriesProducts[i].addEventListener('click', function(e) {
// 						if(e.target.closest('.product-block')) {
// 							let selectedInput = selectedSelect.options[selectedSelect.selectedIndex].getAttribute('data-variant');

// 							if(!this.data['select-accessories']['products'][selectAccessoriesProduct.id]) {
// 								let productObj = JSON.parse(selectedInput);
// 								productObj['quantity'] = selectedQuantity.value
// 								productObj['product-title'] = selectAccessoriesProduct.getAttribute('data-variant-name');
// 								productObj['featured_image'] = productObj['featured_image'] ? productObj['featured_image'] : selectAccessoriesProduct.getAttribute('data-product-img')
// 								this.setProduct = [selectAccessoriesProduct.id, productObj];
// 							} else {
// 								this.deleteProduct = selectAccessoriesProduct.id;
// 							}
// 						} else {
// 							if(!selectAccessoriesProduct.classList.contains('sb__product--selected')) {
// 								let selectedSelect = selectAccessoriesProduct.querySelector('select');
// 								let selectedInput = selectedSelect.options[selectedSelect.selectedIndex].getAttribute('data-variant');
// 								let selectedInputObj = JSON.parse(selectedInput);
// 								selectedInputObj['product-title'] = selectAccessoriesProduct.getAttribute('data-variant-name');
// 								productObj['featured_image'] = productObj['featured_image'] ? productObj['featured_image'] : selectAccessoriesProduct.getAttribute('data-product-img')
// 								this.setProduct = [selectAccessoriesProduct.id, JSON.parse(selectedInput)];
// 							}
// 						}
// 						this.updateAccessories()
// 					}.bind(this));

// 					let productSelect = selectAccessoriesProduct.querySelector('select');
// 					let eventListeners = [
// 						{'obj': productSelect, 'event': 'change'},
// 						{'obj': selectedQuantity, 'event': 'change'},
// 						{'obj': selectedMinus, 'event': 'quantity'},
// 						{'obj': selectedPlus, 'event': 'quantity'}
// 					]

// 					for (var j = 0; j < eventListeners.length; j++) {
// 						eventListeners[j]['obj'].addEventListener(eventListeners[j]['event'], function(e) {
// 							let selectedInput = productSelect.options[productSelect.selectedIndex].getAttribute('data-variant');
							
// 							let productObj = JSON.parse(selectedInput);
// 							productObj['quantity'] = selectedQuantity.value;
// 							productObj['included'] = false;
// 							productObj['featured_image'] = productObj['featured_image'] ? productObj['featured_image'] : selectAccessoriesProduct.getAttribute('data-product-img')
// 							this.setProduct = [selectAccessoriesProduct.id, productObj];

// 							this.updateAccessories();
// 						}.bind(this));
// 					}
// 				}
// 			}

// 			this.completedSections.push('initAccessories');
// 		}


// 		// this.setData = {
// 		// 	'step': 'select-accessories', 
// 		// 	'k': 'completed', 
// 		// 	'v': true
// 		// };
// 	}

// 	updateAccessories() {
// 		let products = this.selectAccessories.querySelectorAll('.sb-product');

// 		for (var i = 0; i < products.length; i++) {
// 			products[i].classList.add('d-none');
// 		}

// 		for (var i = 0; i < products.length; i++) {
// 			let systemsJson = products[i].getAttribute('data-systems');
// 			let systems = JSON.parse(systemsJson);

// 			for (var j = 0; j < systems.length; j++) {
// 				if(systems[j]['variants_to_show'] == this.data['select-system']['system']['id']) {
// 					products[i].classList.remove('d-none');
// 				}
// 			}
// 		}

// 		// Update accessories
// 		for (var i = 0; i < this.selectAccessories.querySelectorAll('.sb__product').length; i++) {
// 			let product = this.selectAccessories.querySelectorAll('.sb__product')[i];				
// 			let productId = product.id;

// 			if(!product.classList.contains('d-none')) {

// 				if(!product.classList.contains('sb-product-included')) {
// 					if(this.data['select-accessories']['products'][productId]) {
// 						product.classList.add('sb__product--selected');
// 					} else {
// 						product.classList.remove('sb__product--selected');
// 					}
// 				} else {
// 					let includedVariant = product.querySelector('.sb-product-variant');
// 					let includedVariantObj = JSON.parse(includedVariant.getAttribute('data-variant'));
// 					includedVariantObj['included'] = true;
// 					includedVariantObj['featured_image'] = includedVariantObj['featured_image'] ? includedVariantObj['featured_image'] : product.getAttribute('data-product-img')

// 					this.setProduct = [productId, includedVariantObj];
// 				}
// 			} else {
// 				this.deleteProduct = productId;
// 			}
// 		}

// 		for (var i = 0; i < Object.entries(this.data['select-accessories']['products']).length; i++) {
// 			let productId = Object.entries(this.data['select-accessories']['products'])[i][0];
// 			let productInfo = Object.entries(this.data['select-accessories']['products'])[i][1];

// 			let productBlock = this.selectAccessories.querySelector(`#${productId}`);
// 			let productBlockImg = productBlock.querySelector('img');
// 			let productPriceMain = productBlock.querySelector('.price-main');
// 			let productPriceSecond = productBlock.querySelector('.price-second');

// 			if(productBlock) {
// 				let productBlockSelect = productBlock.querySelector('select');
// 				let productBlockQuantity = productBlock.querySelector('[type="number"]');

// 				if(productBlockSelect) {
// 					for (var j = 0; j < productBlockSelect.length; j++) {
// 						if(productBlockSelect[j].value == productInfo.id.toString()) {
// 							productBlockSelect.selectedIndex = j;
// 							this.updatePrice(productPriceMain, productPriceSecond, productInfo.price);
// 						}	
// 					}
// 				}

// 				if(productBlockQuantity) {
// 					productBlockQuantity.value = productInfo.quantity ? productInfo.quantity : 1;
// 				}
// 			}
// 		}

// 		// Main img
// 		if(this.data['select-van']['van-img']) {
// 			this.selectAccessoriesImg.setAttribute('src', this.data['select-van']['van-img']);
// 		}

// 		// this.selectAccessoriesContainer.innerHTML = '';
// 		// for (var i = 0; i < Object.entries(this.data['select-accessories']['products']).length; i++) {
// 		// 	let accessoryData = Object.entries(this.data['select-accessories']['products'])[i][1];
// 		// 	console.log('accessoryData', accessoryData)
// 		// 	let accessoryImg = `<img class="absolute" src="${accessoryData['featured_image']}">`
// 		// 	this.selectAccessoriesContainer.innerHTML = this.selectAccessoriesContainer.innerHTML + accessoryImg
// 		// }

// 		this.updateTotalPrice();
// 	}

// 	initSystem() {
// 		this.hideAllSections(this.selectSystem);
// 		this.updateSystem();

// 		if(!this.completedSections.includes('initSystem')) {

// 			// Init sizes
// 			for (var i = 0; i < this.systemSizes.length; i++) {
// 				let selectedSystem = this.systemSizes[i];
// 				this.systemSizes[i].addEventListener('click', function() {
// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'system-sizes', 
// 						'v': selectedSystem.getAttribute('data-update-value')
// 					};

// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'system-reels', 
// 						'v': selectedSystem.getAttribute('data-reel-type')
// 					};

// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'selected-reel', 
// 						'v': null
// 					};

// 					this.resetSystem();
// 					this.updateSystem()
// 				}.bind(this));
// 			}

// 			// Init reels
// 			for (var i = 0; i < this.systemReelOptions.length; i++) {
// 				let selectedReelOption = this.systemReelOptions[i];
// 				this.systemReelOptions[i].addEventListener('click', function() {
// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'selected-reel', 
// 						'v': selectedReelOption.getAttribute('data-system-reel')
// 					};
// 					this.resetSystem();
// 					this.updateSystem()
// 				}.bind(this))
// 			}


// 			for (var i = 0; i < this.systemProducts.length; i++) {
// 				let clickableProduct = this.systemProducts[i];
// 				this.systemProducts[i].addEventListener('click', function(e) {
// 					// Variant
// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'system', 
// 						'v': JSON.parse(clickableProduct.getAttribute('data-variant'))
// 					};

// 					// Variant img
// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'system-img', 
// 						'v': clickableProduct.getAttribute('data-variant-img')
// 					};

// 					// Variant name
// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'system-name', 
// 						'v': clickableProduct.getAttribute('data-variant-name')
// 					};

// 					// Prices
// 					let priceEl = clickableProduct.querySelector('.price-main');
// 					let secPriceEl = clickableProduct.querySelector('.price-second');
// 					let price = priceEl.getAttribute('data-amount');
// 					let discount = priceEl.getAttribute('data-discount');
// 					let priceSecond = secPriceEl ? secPriceEl.getAttribute('data-amount') != price ? secPriceEl.getAttribute('data-amount') : 0 : 0;

// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'amount', 
// 						'v': price
// 					};

// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'amount-prev', 
// 						'v': priceSecond
// 					};

// 					this.setData = {
// 						'step': 'select-system', 
// 						'k': 'discount', 
// 						'v': discount
// 					};

// 					this.updateSystem();
// 				}.bind(this));
// 			}

// 			this.completedSections.push('initSystem');
// 		}
// 	}

// 	resetSystem() {
// 		let options = ['system', 'system-img', 'system-name', 'amount', 'mount-prev', 'discount'];
// 		for (var i = 0; i < options.length; i++) {
// 			this.setData = {
// 				'step': 'select-system', 
// 				'k': options[i], 
// 				'v': options[i] == 'amount' || options[i] == 'amount-prev' ? 0 : null
// 			};
// 		}
// 	}

// 	updateSystem() {
// 		const selectedBtns = this.selectFiltration.querySelectorAll('.sb__product--selected');
// 		for (var i = 0; i < selectedBtns.length; i++) {
// 			selectedBtns[i].classList.remove('sb__product--selected');
// 		}

// 		// Init sizes
// 		this.selectSystemSection.classList.add('d-none');
// 		for (var i = 0; i < this.systemSizes.length; i++) {
// 			let vanSizes = this.systemSizes[i].getAttribute('data-van-sizes');
// 			let operators = this.systemSizes[i].getAttribute('data-operators');
// 			let show = false

// 			if(!vanSizes && !operators) {
// 				show = true
// 			} else if(vanSizes && !operators) {
// 				if(this.data['select-van']['van-selected-size']) {
// 					if(vanSizes.includes(this.data['select-van']['van-selected-size']) || this.data['select-van']['van-selected-type'] == 'no-van') {
// 						show = true
// 					}
// 				}
// 			} else if(operators && !vanSizes) {
// 				if(operators) {
// 					if(operators.includes(this.data['select-filtration']['man'])) {
// 						show = true
// 					}
// 				}
// 			} else {
// 				if(operators.includes(this.data['select-filtration']['man'])) {
// 					if(this.data['select-van']['van-selected-size'] || this.data['select-van']['van-selected-type'] == 'no-van') {
// 						if(vanSizes.includes(this.data['select-van']['van-selected-size']) || this.data['select-van']['van-selected-type'] == 'no-van') {
// 							show = true
// 						}
// 					}
// 				}
// 			}

// 			if(show) {
// 				this.systemSizes[i].classList.add('d-none');
// 			} else {
// 				this.systemSizes[i].classList.remove('d-none');
// 			}

// 			if(this.data['select-system']['system-sizes'] == this.systemSizes[i].getAttribute('data-update-value')) {
// 				this.systemSizes[i].classList.add('sb__product--selected');
// 			} else {
// 				this.systemSizes[i].classList.remove('sb__product--selected');
// 			}
// 		}

// 		// Init reel options
// 		for (var i = 0; i < this.systemReelOptions.length; i++) {
// 			this.systemReelOptions[i].classList.remove('sb__btn--selected');
// 		}

// 		if(this.data['select-system']['system-reels']) {
// 			let reels = this.data['select-system']['system-reels'].split('|');
// 			if(reels.length == 0) {
// 				this.systemReels.classList.add('d-none');
// 				for (var i = 0; i < this.systemReelOptions.length; i++) {
// 					this.systemReelOptions[i].classList.remove('sb__btn--selected');
// 				}
// 			} else {
// 				this.systemReels.classList.remove('d-none');
// 				for (var i = 0; i < this.systemReelOptions.length; i++) {
// 					if(reels.includes(this.systemReelOptions[i].getAttribute('data-system-reel'))) {
// 						this.systemReelOptions[i].classList.remove('d-none');
// 					} else {
// 						this.systemReelOptions[i].classList.add('d-none');
// 					}

// 					if(this.data['select-system']['selected-reel']) {
// 						if(this.data['select-system']['selected-reel'] == this.systemReelOptions[i].getAttribute('data-system-reel')) {
// 							this.systemReelOptions[i].classList.add('sb__btn--selected');
// 						} else {
// 							this.systemReelOptions[i].classList.remove('sb__btn--selected');
// 						}
// 					}
// 				}
// 			}
// 		} else {
// 			this.systemReels.classList.add('d-none');
// 			for (var i = 0; i < this.systemReelOptions.length; i++) {
// 				this.systemReelOptions[i].classList.remove('sb__btn--selected');
// 			}
// 		}

// 		// Init products
// 		if(this.data['select-system']['system-sizes'] && this.data['select-system']['selected-reel'] || this.data['select-system']['system-sizes'] && !this.data['select-system']['system-reels']) {
// 			this.selectSystemSection.classList.remove('d-none');
// 			for (var i = 0; i < this.systemProducts.length; i++) {
// 				let systemProduct = this.systemProducts[i];
// 				if((this.systemProducts[i].getAttribute('data-van').includes(this.data['select-van']['van-selected-size']) ||  
// 					this.data['select-van']['van-selected-type'] == 'no-van') && 
// 					(!this.systemProducts[i].getAttribute('data-reels') || this.systemProducts[i].getAttribute('data-reels').includes(this.data['select-system']['selected-reel'])) &&
// 					this.systemProducts[i].getAttribute('data-sizes').includes(this.data['select-system']['system-sizes']) &&
// 					this.systemProducts[i].getAttribute('data-filtration').includes(this.data['select-filtration']['filtration']) && 
// 					this.systemProducts[i].getAttribute('data-man').includes(this.data['select-filtration']['man'])) {
// 						this.systemProducts[i].classList.remove('d-none');
// 				} else {
// 					this.systemProducts[i].classList.add('d-none');
// 				}
// 			}
// 		} else {
// 			this.selectSystemSection.classList.add('d-none');
// 			for (var i = 0; i < this.systemProducts.length; i++) {
// 				this.systemProducts[i].classList.add('d-none');
// 			}
// 		}

// 		this.systemPretitle.innerHTML = this.data['select-system']['system-name'] ? 'Selected System' : '';
// 		this.systemTitle.innerHTML = this.data['select-system']['system-name'] ? this.data['select-system']['system-name'] : '';
// 		this.systemImg.setAttribute('src', this.data['select-system']['system-img'] ? this.data['select-system']['system-img'] : this.systemDefaultImg);

// 		// Update price
// 		let amount = parseInt(this.data['select-system']['amount']);
// 		this.systemPrice.querySelector('.price-main').setAttribute('data-amount', amount);
// 		this.systemPrice.querySelector('.price-main').setAttribute('data-discount', this.data['select-system']['discount']);
// 		this.systemPrice.querySelector('.price-main').setAttribute('data-alt-price', Currency.formatMoney(amount * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£'));
// 		this.systemPrice.querySelector('.price-second').setAttribute('data-amount', amount * 1.2);
// 		this.systemPrice.querySelector('.price-second').setAttribute('data-alt-price', Currency.formatMoney(amount, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£'));
// 		this.systemPrice.querySelector('.price-second').textContent = (Currency.formatMoney(amount * 1.2, Currency.money_format[Money.getCurrency()]).replace('&pound;', '£'));

// 		this.systemPrice.querySelector('.price-second').setAttribute('data-discount', this.data['select-system']['discount']);
// 		Global.updateCurrency();

// 		if(amount == 0) {
// 			this.systemPrice.classList.add('d-none');
// 		} else {
// 			this.systemPrice.classList.remove('d-none');
// 		}

// 		// Points
// 		if(this.data['select-system']['system']) {
// 			if(this.data['select-system']['system']['id']) {
// 				for (var i = 0; i < this.systemProducts.length; i++) {
// 					if(this.systemProducts[i].id == this.data['select-system']['system']['id']) {
// 						const pointsEl = this.systemProducts[i].querySelector('.sb-product-points');
// 						this.systemPoints.innerHTML = pointsEl.innerHTML;
// 					}
// 				}
// 			} else {
// 				this.systemPoints.innerHTML = '';
// 			}
// 		} else {
// 			this.systemPoints.innerHTML = '';
// 		}

// 		// sb-product-points

// 		this.updateButtons(this.systemProducts, this.data['select-system']['system'] ? this.data['select-system']['system']['id'] : '', 'sb__product--selected');
// 		this.checkShowCompleted(this.selectSystem, this.data['select-system']['system']);
// 		this.updateTotalPrice();
// 	}

// 	initHot() {
// 		this.hideAllSections(this.selectHot);
// 		this.updateHot();

// 		if(!this.completedSections.includes('initHot')) {

// 			for (var i = 0; i < this.selectHotOptions.querySelectorAll('.sb-btn').length; i++) {
// 				let selectHotOption = this.selectHotOptions.querySelectorAll('.sb-btn')[i];
// 				selectHotOption.addEventListener('click', function() {
// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-option', 
// 						'v': selectHotOption.getAttribute('data-hot-option')
// 					};

// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-operators', 
// 						'v': null
// 					};

// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-product', 
// 						'v': null
// 					};

// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-image', 
// 						'v': 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/all_systems_3.png'
// 					};
// 					this.updateHot();
// 					console.log(this.data)
// 				}.bind(this));

// 				let selectHotOperator = this.selectHotOperators.querySelectorAll('.sb-btn')[i];
// 				selectHotOperator.addEventListener('click', function() {
// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-operators', 
// 						'v': selectHotOperator.getAttribute('data-hot-option')
// 					};

// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-product', 
// 						'v': null
// 					};

// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-image', 
// 						'v': 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/all_systems_3.png'
// 					};
// 					this.updateHot();
// 				}.bind(this));
// 			}

// 			for (var i = 0; i < this.selectHotProductOptions.length; i++) {
// 				let selectHotProduct = this.selectHotProductOptions[i];
// 				selectHotProduct.addEventListener('click', function() {
// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-product', 
// 						'v': JSON.parse(selectHotProduct.getAttribute('data-variant-data'))
// 					};

// 					this.setData = {
// 						'step': 'select-hot', 
// 						'k': 'hot-image', 
// 						'v': selectHotProduct.getAttribute('data-variant-img')
// 					};
// 					this.updateHot();
// 				}.bind(this));
// 			}

// 			this.completedSections.push('initHot');
// 		}
// 	}

// 	updateHot() {
// 		for (var i = 0; i < this.selectHotOptions.querySelectorAll('.sb-btn').length; i++) {
// 			if(this.selectHotOptions.querySelectorAll('.sb-btn')[i].getAttribute('data-hot-option') == this.data['select-hot']['hot-option']) {
// 				this.selectHotOptions.querySelectorAll('.sb-btn')[i].classList.add('sb__btn--selected');
// 			} else {
// 				this.selectHotOptions.querySelectorAll('.sb-btn')[i].classList.remove('sb__btn--selected');
// 			}

// 			if(this.selectHotOperators.querySelectorAll('.sb-btn')[i].getAttribute('data-hot-option') == this.data['select-hot']['hot-operators'] && this.data['select-hot']['hot-option'] == 'yes') {
// 				this.selectHotOperators.querySelectorAll('.sb-btn')[i].classList.add('sb__btn--selected');
// 			} else {
// 				this.selectHotOperators.querySelectorAll('.sb-btn')[i].classList.remove('sb__btn--selected');
// 			}
// 		}

// 		if(this.data['select-hot']['hot-option'] == 'yes' && this.data['select-filtration']['man'] == 'two') {
// 			this.selectHotOperators.classList.remove('d-none');
// 		} else {
// 			this.selectHotOperators.classList.add('d-none');
// 		}

// 		if((this.data['select-hot']['hot-option'] == 'yes' && this.data['select-hot']['hot-operators']) || (this.data['select-hot']['hot-option'] == 'yes' && this.data['select-filtration']['man'] == 'one') ) {
// 			this.selectHotProducts.classList.remove('d-none');
// 		} else {
// 			this.selectHotProducts.classList.add('d-none');
// 		}

// 		if(this.data['select-hot']['hot-image']) {
// 			this.selectHotProductImg.setAttribute('src', this.data['select-hot']['hot-image']);
// 		} else {
// 			this.selectHotProductImg.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0039/8780/0133/files/all_systems_3.png');
// 		}

// 		if(this.data['select-hot']['hot-option'] == 'yes') {
// 			for (var i = 0; i < this.selectHotProductOptions.length; i++) {
// 				let operators = this.data['select-filtration']['man'] == 'one' ? 'one' : this.data['select-hot']['hot-operators'];
// 				if(this.selectHotProductOptions[i].getAttribute('data-operators').includes(operators)) {
// 					this.selectHotProductOptions[i].classList.remove('d-none');
// 				} else {
// 					this.selectHotProductOptions[i].classList.add('d-none');
// 				}
// 			}
// 		}

// 		if(this.data['select-hot']['hot-product']) {
// 			for (var i = 0; i < this.selectHotProducts.querySelectorAll('.sb__product').length; i++) {
// 				let selectHotProduct = this.selectHotProducts.querySelectorAll('.sb__product')[i];
// 				if(selectHotProduct.id == `select-hot-${this.data['select-hot']['hot-product']['id']}`) {
// 					selectHotProduct.classList.add('sb__product--selected');
// 				} else {
// 					selectHotProduct.classList.remove('sb__product--selected');
// 				}
// 			}
// 		} else {
// 			for (var i = 0; i < this.selectHotProducts.querySelectorAll('.sb__product').length; i++) {
// 				let selectHotProduct = this.selectHotProducts.querySelectorAll('.sb__product')[i];
// 				selectHotProduct.classList.remove('sb__product--selected');
// 			}
// 		}


// 		this.checkShowCompleted(this.selectHot, this.data['select-hot']['hot-option'] == 'no' || this.data['select-hot']['hot-product']);
// 		this.updateTotalPrice();
// 	}

// 	initFiltration() {
// 		this.hideAllSections(this.selectFiltration);

// 		// Init water
// 		if(!this.completedSections.includes('initFiltration')) {
// 			// Init postcode checker
// 			this.initPostcodeCheck();

// 			// Init filtration
// 			for (var i = 0; i < this.selectFiltrationSelectsBtns.length; i++) {
// 				this.selectFiltrationSelectsBtns[i].addEventListener('click', function(e) {
// 					this.setData = {
// 						'step': 'select-filtration', 
// 						'k': 'filtration', 
// 						'v': e.target.getAttribute('data-update-value')
// 					};
// 					this.updateFiltration();
// 				}.bind(this));
// 			}

// 			// Init man
// 			for (var i = 0; i < this.selectManBtns.length; i++) {
// 				this.selectManBtns[i].addEventListener('click', function(e) {
// 					this.setData = {
// 						'step': 'select-filtration', 
// 						'k': 'man', 
// 						'v': e.target.getAttribute('data-update-value')
// 					};
// 					this.updateFiltration();
// 				}.bind(this));
// 			}

// 			this.completedSections.push('initFiltration');
// 		}

// 		this.updateFiltration();
// 	}

// 	updateFiltration() {
// 		const selectedBtns = this.selectFiltration.querySelectorAll('.sb__btn--selected');
// 		for (var i = 0; i < selectedBtns.length; i++) {
// 			selectedBtns[i].classList.remove('sb__btn--selected');
// 		}
// 		const selectFiltrationData = this.data['select-filtration'];

// 		// Update water
// 		// if(selectFiltrationData['water']) {
// 		// 	this.updateButtons(this.selectFiltrationWaterBtns, 'filtration-water-' + selectFiltrationData['water']);
// 		// 	this.selectFiltrationSelects.classList.remove('d-none');
// 		// 	this.selectFiltrationDi.classList.remove('d-none');
// 		// 	this.selectFiltrationRo.classList.remove('d-none');
// 		// } else {
// 		// 	this.selectFiltrationSelects.classList.add('d-none');
// 		// }

// 		selectFiltrationData['filtration'] ? this.selectMan.classList.remove('d-none') : this.selectMan.classList.add('d-none');

// 		this.updateButtons(this.selectFiltrationSelectsBtns, selectFiltrationData['filtration'] ? 'filtration-' + selectFiltrationData['filtration'] : '');
// 		this.updateButtons(this.selectManBtns, selectFiltrationData['man'] ? selectFiltrationData['man'] + '-man' : '');

// 		this.selectFiltrationPretitle.innerHTML = 'Filtration & Operators';

// 		// Filtration text
// 		if(this.data['select-filtration']['man']) {
// 			this.selectFiltrationTitle.innerHTML = `${this.data['select-filtration']['filtration'].toUpperCase()} Filtration & ${capitalizeWords(this.data['select-filtration']['man'])} Operator${this.data['select-filtration']['man'] == 'one' ? '' : 's'}`;
// 		} else if(this.data['select-filtration']['filtration']) {
// 			this.selectFiltrationTitle.innerHTML = `${this.data['select-filtration']['filtration'].toUpperCase()} Filtration`;
// 		} else {
// 			this.selectFiltrationTitle.innerHTML = 'No Options Selected'
// 		}

// 		// Filtration image
// 		if(this.data['select-filtration']['man']) {
// 			let filtrationImgId = `w-${this.data['select-filtration']['water'] == 'soft' ? '1' : '2'}_o-${this.data['select-filtration']['man'] == 'one' ? '1' : '2'}`;
// 			this.selectFiltrationImg.setAttribute('src', this.filtrationImg.replace('{{id}}', filtrationImgId));
// 		} else if(this.data['select-filtration']['water']) {
// 			let filtrationImgId = `w-${this.data['select-filtration']['water'] == 'soft' ? '1' : '2'}_o-0`;
// 			this.selectFiltrationImg.setAttribute('src', this.filtrationImg.replace('{{id}}', filtrationImgId));
// 		} else {
// 			this.selectFiltrationImg.setAttribute('src', this.filtrationImg.replace('{{id}}', 'w-0_o-0'));
// 		}

// 		this.checkShowCompleted(this.selectFiltration, selectFiltrationData['man']);
// 		this.updateTotalPrice();
// 	}

// 	async initLicenseCheck() {
// 		// TODO: Ensure vehicle models match with API

// 		// Init license plate check
// 		let inputs = ['input', 'focus'];
// 		for (var i = 0; i < inputs.length; i++) {
// 			this.vanLicense.addEventListener(inputs[i], async function() {
// 				this.vanLicenseLoading.classList.remove('d-none');
// 				this.vanLicenseResults.classList.add('sb__license-results--active');
// 				this.vanLicenseResultsList.innerHTML = '';

// 				let licenceText = this.vanLicense.value;
// 				if(licenceText) {
// 					let vehicleData = this.getLicenseCookie(licenceText, false);
// 					if(!vehicleData) {
// 						vehicleData = await fetch(`https://uk1.ukvehicledata.co.uk/api/datapackage/VehicleData?v=2&api_nullitems=1&auth_apikey=eb26d38e-439a-4b77-80ac-fda2ec9b6581&key_VRM=${licenceText}`)
// 						  .then(function(response) {
// 						    return response.json();
// 						  })
// 						  .then(function(json) {
// 						    if(json.Response.StatusCode == 'Success') {
// 						    	let make = json.Response.DataItems.ClassificationDetails.Smmt.Make;
// 						    	let model = json.Response.DataItems.ClassificationDetails.Smmt.Range;
// 						    	return [make, model];
// 						    } else {
// 						    	return [null, null];
// 						    }
// 						  })
// 						  .catch(function(error) {
// 						    console.log('Request failed', error);
// 						    return [null, null];
// 						}); 
// 						this.updateLicenseCookie(licenceText, vehicleData, false);
// 					}

// 					if(vehicleData[0] && vehicleData[1]) {
// 						let vehicleImage = this.getLicenseCookie(licenceText, true);
// 						if(!vehicleImage) {
// 							vehicleImage = await fetch(`https://uk1.ukvehicledata.co.uk/api/datapackage/VehicleImageData?v=2&api_nullitems=1&auth_apikey=eb26d38e-439a-4b77-80ac-fda2ec9b6581&key_VRM=${licenceText}`)
// 							  .then(function(response) {
// 							    return response.json();
// 							  })
// 							  .then(function(json) {
// 							    if(json.Response.StatusCode == 'Success') {
// 							    	if(json.Response.DataItems.VehicleImages.ImageDetailsCount > 0) {
// 							    		return json.Response.DataItems.VehicleImages.ImageDetailsList[0].ImageUrl;
// 							    	}
// 							    	return null;
// 							    } else {
// 							    	return null;
// 							    }
// 							    return null;
// 							  })
// 							  .catch(function(error) {
// 							    console.log('Request failed', error);
// 							    return null;
// 							}); 
// 						}

// 						this.vanLicenseResultsList.innerHTML = `
// 							<div data-make="${vehicleData[0]}" data-model="${vehicleData[1]}" data-img="${vehicleImage}" class="pt-5 pb-5 pr-5 pl-5 sb-license-result sb__license-result">
// 								<p class="text-bold">${vehicleData[0]}</p>
// 								<p class="">${vehicleData[1]}</p>
// 							</div>
// 						`
// 						this.vanLicenseLoading.classList.add('d-none');
// 					} else {
// 						this.vanLicenseLoading.classList.add('d-none');
// 						this.vanLicenseResultsList.innerHTML = this.vanOptions['no-licence-found'];
// 					}
// 				} else {
// 					this.vanLicenseResults.classList.remove('sb__license-results--active');
// 					this.vanLicenseResultsList.innerHTML = '';
// 					this.vanLicenseLoading.classList.add('d-none');
// 				}
// 			}.bind(this));
// 		}

// 		document.addEventListener('click', function(e) {
// 			if(e.target.closest('.sb-license-result')) {
// 				this.vanLicenseResults.classList.remove('sb__license-results--active');
// 				this.vanLicenseResultsList.innerHTML = '';
// 				this.vanLicenseLoading.classList.add('d-none');

// 				let vanMake = e.target.closest('.sb-license-result').getAttribute('data-make');
// 				let vanModel = e.target.closest('.sb-license-result').getAttribute('data-model');
// 				let vanImg = e.target.closest('.sb-license-result').getAttribute('data-img') ? e.target.closest('.sb-license-result').getAttribute('data-img') : this.vanOptions['van-img-default'];

// 				this.setData = {
// 					'step': 'select-van', 
// 					'k': 'van-selected-size', 
// 					'v': null
// 				};
// 				if(VanData[vanMake.toLowerCase()]) {
// 					if(VanData[vanMake.toLowerCase()][vanModel.toLowerCase()]) {
// 						this.setData = {
// 							'step': 'select-van', 
// 							'k': 'van-selected-size', 
// 							'v': VanData[vanMake.toLowerCase()][vanModel.toLowerCase()]
// 						};
// 					}
// 				}

// 				this.setData = {
// 					'step': 'select-van', 
// 					'k': 'van-pretitle', 
// 					'v': vanMake
// 				};

// 				this.setData = {
// 					'step': 'select-van', 
// 					'k': 'van-img', 
// 					'v': vanImg
// 				};

// 				this.setData = {
// 					'step': 'select-van', 
// 					'k': 'van-title', 
// 					'v': vanModel
// 				};

// 				this.setData = {
// 					'step': 'select-van', 
// 					'k': 'van-selected-type', 
// 					'v': 'auto'
// 				};
// 				this.updateVan();
// 			} else if(!e.target.closest('#select-van-license') && this.vanLicenseResults.classList.contains('sb__license-results--active')) {
// 				this.vanLicenseResults.classList.remove('sb__license-results--active');
// 				this.vanLicenseResultsList.innerHTML = '';
// 				this.vanLicenseLoading.classList.add('d-none');
// 			}
// 		}.bind(this))
// 	}

// 	async initPostcodeCheck() {
// 		let inputs = ['input', 'focus'];
// 		for (var i = 0; i < inputs.length; i++) {
// 			this.filtPostcode.addEventListener(inputs[i], async function() {

// 				this.filtPostcodeLoading.classList.remove('d-none');
// 				this.filtPostcodeResults.classList.add('sb__license-results--active');
// 				this.filtPostcodeResultsList.innerHTML = '';

// 				let postcodeText = this.filtPostcode.value;
// 				if(postcodeText) {
// 					postcodeText = postcodeText.toUpperCase();
// 					let foundPostcodes = await fetch(`https://wcw-water.nw.r.appspot.com/?postcode=${postcodeText}`)
// 					  .then(function(response) {
// 					    return response.text();
// 					  })
// 					  .then(function(json) {
// 					  	console.log(json)
// 					    return JSON.parse(json)
// 					  })
// 					  .catch(function(error) {
// 					    console.log('Request failed', error);
// 					    return null;
// 					}); 

// 					if(foundPostcodes) {
// 						if(foundPostcodes['result']) {
// 							if(Object.keys(foundPostcodes['result']).length > 0) {
// 								this.filtPostcodeLoading.classList.add('d-none');
// 								for (var j = 0; j < Object.entries(foundPostcodes['result']).length; j++) {
// 									let postcodeResult = Object.entries(foundPostcodes['result'])[j]
// 									this.filtPostcodeResultsList.innerHTML = this.filtPostcodeResultsList.innerHTML +  `
// 										<div data-postcode="${postcodeResult[0]}" data-water="${postcodeResult[1]}" class="pt-5 pb-5 pr-5 pl-5 sb-water-result sb__license-result">
// 											<p class="text-bold">${postcodeResult[0]}</p>
// 										</div>
// 									`
// 								}
// 							} else {
// 								this.filtPostcodeLoading.classList.add('d-none');
// 								this.filtPostcodeResultsList.innerHTML = '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">Postcode Area Not Found</p>'
// 							}
// 						} else {
// 							this.filtPostcodeLoading.classList.add('d-none');
// 							this.filtPostcodeResultsList.innerHTML = '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">Postcode Area Not Found</p>'
// 						}
// 					} else {
// 						this.filtPostcodeLoading.classList.add('d-none');
// 						this.filtPostcodeResultsList.innerHTML = '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">Postcode Area Not Found</p>'
// 					}
// 				} else {
// 					this.filtPostcodeLoading.classList.add('d-none');
// 					this.filtPostcodeResults.classList.remove('sb__license-results--active');
// 					this.filtPostcodeResultsList.innerHTML = '';
// 				}
// 			}.bind(this));
// 		}

// 		document.addEventListener('click', function(e) {
// 			if(e.target.closest('.sb-water-result')) {
// 				this.filtPostcodeResults.classList.remove('sb__license-results--active');
// 				this.filtPostcodeResultsList.innerHTML = '';
// 				this.filtPostcodeLoading.classList.add('d-none');

// 				let dataWater = e.target.closest('.sb-water-result').getAttribute('data-water');
// 				let dataPost = e.target.closest('.sb-water-result').getAttribute('data-postcode');

// 				this.filtAnswer.innerHTML = `<p class="pb-5 pt-5">For the area ${dataPost}, we recommend you choose <span class="text-bold">${dataWater == 'soft' ? 'DI' : 'RO/DI'} filtration</span></p>`

// 			} else if(!e.target.closest('#select-filtration-postcode') && this.filtPostcodeResults.classList.contains('sb__license-results--active')) {
// 				this.filtPostcodeLoading.classList.add('d-none');
// 				this.filtPostcodeResults.classList.remove('sb__license-results--active');
// 				this.filtPostcodeResultsList.innerHTML = '';
// 			}
// 		}.bind(this))
// 	}

// 	async initVan() {
// 		this.hideAllSections(this.selectVan);
// 		// Init no van
// 		if(!this.completedSections.includes('initVan')) {
// 			this.initLicenseCheck();
// 			const noVanData = [
// 				{'van-pretitle': this.vanOptions['van-pretitle']},
// 				{'van-title': this.vanOptions['no-van-title']},
// 				{'van-img': this.vanOptions['no-van-img-default']},
// 				{'van-selected-type': 'no-van'},
// 				{'van-selected-size': null},
// 				{'show-completed': true}
// 			]

// 			this.updateVanBtn(this.vanNone, noVanData);

// 			// Init Not Listed
// 			const notListedData = [
// 				{'van-selected-type': 'not-listed'},
// 				{'show-completed': false},
// 				{'van-title': 'Van Not Listed'},
// 				{'van-pretitle': 'Selected Van'},
// 				{'van-img': this.vanOptions['van-img-default']},
// 			]

// 			this.updateVanBtn(this.vanNotListed, notListedData);

// 			// Init Sizes
// 			const sizeBtns = this.vanSizes.querySelectorAll('.sb-btn');
// 			for (var i = 0; i < sizeBtns.length; i++) {
// 				sizeBtns[i].addEventListener('click', function(e) {
// 					const selectedBtn = e.target;
// 					this.setData = {
// 						'step': 'select-van', 
// 						'k': selectedBtn.getAttribute('data-update-key'), 
// 						'v': selectedBtn.getAttribute('data-update-value')
// 					};
// 					this.updateVan();
// 				}.bind(this))
// 			}

// 			this.completedSections.push('initVan');
// 		}

// 		// Init van selected
// 		this.updateVan();
// 	}

// 	updateVanBtn(btn, dataToUpdate) {
// 		// Watch btn and update according data
// 		btn.addEventListener('click', function() {
// 			for (var i = 0; i < dataToUpdate.length; i++) {
// 				this.setData = {
// 					'step': 'select-van', 
// 					'k': Object.keys(dataToUpdate[i])[0], 
// 					'v': Object.values(dataToUpdate[i])[0]
// 				};
// 			}
// 			this.updateVan();
// 		}.bind(this));
// 	}

// 	updateVan() {
// 		const selectedBtns = this.selectVan.querySelectorAll('.sb__btn--selected');
// 		for (var i = 0; i < selectedBtns.length; i++) {
// 			selectedBtns[i].classList.remove('sb__btn--selected');
// 		}

// 		const selectVanData = this.data['select-van'];
// 		this.vanPretitle.innerHTML = selectVanData['van-pretitle'];
// 		this.vanTitle.innerHTML = selectVanData['van-title'];
// 		this.vanImg.setAttribute('src', selectVanData['van-img']);

// 		// Update btn colours
// 		if(selectVanData['van-selected-type'] == 'no-van') {
// 			this.vanNone.classList.add('sb__btn--selected');
// 			this.vanNotListed.classList.remove('sb__btn--selected');
// 		} else if(selectVanData['van-selected-type'] == 'not-listed') {
// 			this.vanNone.classList.remove('sb__btn--selected');
// 			this.vanNotListed.classList.add('sb__btn--selected');
// 		} else {
// 			this.vanNone.classList.remove('sb__btn--selected');
// 			this.vanNotListed.classList.remove('sb__btn--selected');
// 		}

// 		// Show sizes
// 		if(selectVanData['van-selected-type'] && selectVanData['van-selected-type'] != 'no-van') {
// 			this.vanSizes.classList.remove('d-none');
// 			if(selectVanData['van-selected-size']) {
// 				this.updateButtons(this.vanSizes.querySelectorAll('.std-btn'), 'select-van-size-' + this.data['select-van']['van-selected-size']);
// 			}
// 		} else {
// 			this.vanSizes.classList.add('d-none');
// 		}

// 		// Init auto selected
// 		// if(selectVanData['van-selected-type'] == 'auto' && selectVanData['van-selected-size']) {
// 		// 	this.vanExplanation.classList.remove('d-none');
// 		// 	this.vanSizeText.classList.innerHTML = selectVanData['van-selected-size'];
// 		// } else {
// 		// 	this.vanExplanation.classList.add('d-none');
// 		// }

// 		// If show completed
// 		if(selectVanData['van-selected-type'] == 'no-van' || selectVanData['van-selected-size']) {
// 			this.setData = {
// 				'step': 'select-van', 
// 				'k': 'show-completed', 
// 				'v': true
// 			}
// 		} else {
// 			this.setData = {
// 				'step': 'select-van', 
// 				'k': 'show-completed', 
// 				'v': false
// 			}
// 		}

// 		this.checkShowCompleted(this.selectVan, selectVanData['show-completed']);
// 		this.updateTotalPrice();
// 	}

// 	updateAll() {
// 		this.updateSystem();
// 		this.updateFiltration();
// 		this.updateVan();
// 	}


// 	updateTotalPrice() {
// 		const amount = this.getTotalPrice();

// 		for (var i = 0; i < this.selectTotalPrice.length; i++) {
// 			this.updatePrice(this.selectTotalPrice[i].querySelector('.price-main'), this.selectTotalPrice[i].querySelector('.price-second'), amount);
// 		}
// 		this.financeBlock.setAttribute('data-finance-price', amount);

// 		if(amount > 999.99) {
// 			this.selectFinance.classList.remove('d-none');
// 			FinanceUtils.workoutFinance(window.financeCheck !== true, amount / 100)
// 		} else {
// 			this.selectFinance.classList.add('d-none');
// 		}
// 	}

// 	getTotalPrice() {
// 		// Work out total
// 		let amount = 0;

// 		// Systems & location
// 		amount = amount + parseInt(this.data['select-system']['amount']);
// 		amount = amount + parseInt(this.data['select-fitting']['amount']);
// 		if(this.data['select-hot']['hot-product'] != null) {
// 			amount = amount + parseInt(this.data['select-hot']['hot-product']['price']);
// 		}

// 		// Accessories
// 		for (var i = 0; i < Object.entries(this.data['select-accessories']['products']).length; i++) {
// 			let productInfo = Object.entries(this.data['select-accessories']['products'])[i][1];
// 			if(!productInfo['included']) {
// 				amount = amount + parseInt(productInfo['price']) * parseInt(productInfo['quantity']);
// 			}
// 		}
// 		return amount
// 	}

// 	// resetFutureSteps(step) {
// 	// 	const steps = ['select-van', 'select-filtration', 'select-system'];
// 	// 	const sbStepsReverse = steps.slice().reverse();

// 	// 	for (var i = 0; i < sbStepsReverse.length; i++) {
// 	// 		console.log(sbStepsReverse[i], step)
// 	// 		if(sbStepsReverse[i] != step) {
// 	// 			this.setDefaultData = sbStepsReverse[i]
// 	// 		} else {
// 	// 			break
// 	// 		}
// 	// 	}
// 	// }

// 	// Helpers
// 	updateButtons(buttons, id, classToChange='sb__btn--selected') {
// 		for (var i = 0; i < buttons.length; i++) {
// 			if(buttons[i].id == id) {
// 				buttons[i].classList.add(classToChange);
// 			} else {
// 				buttons[i].classList.remove(classToChange);
// 			}
// 		}
// 	}

// 	spitOutText(text) {
// 		if(text) {
// 			return text
// 		} else {
// 			return ''
// 		}
// 	}

// 	getLicenseCookie(license, img=false) {
// 		let licenseDataJson;
// 		if(img) {
// 			licenseDataJson = Cookies.getCookie('license-img') ? Cookies.getCookie('license-img') : '{}';
// 		} else {
// 			licenseDataJson = Cookies.getCookie('license-check-1') ? Cookies.getCookie('license-check-1') : '{}';
// 		}
// 		let licenseData = JSON.parse(licenseDataJson);
// 		return licenseData[license];
// 	}

// 	updateLicenseCookie(license, results, img) {
// 		let licenseDataJson;
// 		if(img) {
// 			licenseDataJson = Cookies.getCookie('license-img') ? Cookies.getCookie('license-img') : '{}';
// 		} else {
// 			licenseDataJson = Cookies.getCookie('license-check-1') ? Cookies.getCookie('license-check-1') : '{}';
// 		}		
// 		let licenseData = JSON.parse(licenseDataJson);
// 		licenseData[license] = results;
// 		if(img) {
// 			Cookies.setCookie('license-img', JSON.stringify(licenseData), 30);
// 		} else {
// 			Cookies.setCookie('license-check-1', JSON.stringify(licenseData), 30);
// 		}
// 	}	

// 	checkShowCompleted(section, showCompleted) {
// 		const showCompletedBtn = section.querySelector('.sb-next');
// 		if(showCompleted) {
// 			showCompletedBtn.removeAttribute('disabled');
// 		} else {
// 			showCompletedBtn.setAttribute('disabled', true);
// 		}
// 	}

// 	updatePrice(main, second, amount) {
// 		let amountWithCurrency = Currency.formatMoney(amount, Currency.money_format[Money.getCurrency()]);
// 		let amountWithCurrencyVat = Currency.formatMoney((amount * 1.2), Currency.money_format[Money.getCurrency()]);
// 		amountWithCurrency = amountWithCurrency.replace('&pound;', '£');
// 		amountWithCurrencyVat = amountWithCurrencyVat.replace('&pound;', '£');

// 		main.setAttribute('data-amount', amount);
// 		main.setAttribute('data-vat-status', 'exc');
// 		main.setAttribute('data-gbp-price', amountWithCurrency);
// 		main.setAttribute('data-alt-price', amountWithCurrencyVat);
// 		main.innerHTML = amountWithCurrency;
// 		second.setAttribute('data-vat-status', 'inc');
// 		second.setAttribute('data-alt-price', amountWithCurrency);
// 		second.innerHTML = amountWithCurrencyVat;
// 		Global.updateVat(false);
// 	}
// }

// const SystemBuilder = {
// 	init: function(section) {
// 		const sb = new SystemBuilderFunc(section);
// 		const steps = ['select-van', 'select-filtration', 'select-system', 'select-hot', 'select-accessories', 'select-fitting', 'select-total'];
// 		const sbStepsReverse = steps.slice().reverse();
// 		// Get last step and init
// 		const data = sb.getData;
// 		this.initSections(steps, data, sb);

// 		// Init completed
// 		const sbNext = document.querySelectorAll('.sb-next');
// 		for (var i = 0; i < sbNext.length; i++) {
// 			sbNext[i].addEventListener('click', function(e) {
// 				const sbStep = e.target.getAttribute('data-step');
// 				sb.setData = {
// 					'step': sbStep,
// 					'k': 'completed',
// 					'v': true
// 				}
// 				this.initSections(steps, data, sb);
// 				window.scrollTo(0, 0);
// 			}.bind(this))
// 		}

// 		// Init previous
// 		const sbPrev = document.querySelectorAll('.sb-prev');
// 		for (var i = 0; i < sbPrev.length; i++) {
// 			sbPrev[i].addEventListener('click', function(e) {
// 				const sbStep = e.target.getAttribute('data-step');
// 				for (var j = 0; j < steps.length; j++) {
// 					if(sbStepsReverse[j] == sbStep) {
// 						sb.setData = {
// 							'step': sbStep,
// 							'k': 'completed',
// 							'v': false
// 						}
// 						break
// 					} else {
// 						sb.setDefaultData = sbStepsReverse[j];
// 					}
// 				}
// 				Cookies.setCookie('system-builder', JSON.stringify(sb.getData), 90);
// 				this.initSections(steps, sb.getData, sb);
// 				window.scrollTo(0, 0);
// 			}.bind(this))
// 		}

// 		document.addEventListener('click', function(e) {
// 			if(e.target.closest('.sb-arrow')) {
// 				let sbArrow = e.target.closest('.sb-arrow');
// 				let sbArrowStep = sbArrow.getAttribute('data-step');

// 				if(!sbArrow.classList.contains('sb__arrow--new')) {
// 					for (var j = 0; j < steps.length; j++) {
// 						if(sbStepsReverse[j] == sbArrowStep) {
// 							sb.setData = {
// 								'step': sbArrowStep,
// 								'k': 'completed',
// 								'v': false
// 							}
// 							break
// 						} else {
// 							sb.setDefaultData = sbStepsReverse[j];
// 						}
// 					}
// 				}
// 				Cookies.setCookie('system-builder', JSON.stringify(sb.getData), 90);
// 				this.initSections(steps, sb.getData, sb);
// 			}
// 		}.bind(this))

// 		// for (var i = 0; i < sbArrows.length; i++) {
// 		// 	let sbArrow = sbArrows[i];
// 		// 	let sbArrowStep = sbArrow.getAttribute('data-step');
// 		// 	sbArrow.addEventListener('click', function(e) {
// 		// 		if(!sbArrow.classList.contains('sb__arrow--new')) {
// 		// 			for (var j = 0; j < steps.length; j++) {
// 		// 				if(sbStepsReverse[j] == sbArrowStep) {
// 		// 					sb.setData = {
// 		// 						'step': sbArrowStep,
// 		// 						'k': 'completed',
// 		// 						'v': false
// 		// 					}
// 		// 					break
// 		// 				} else {
// 		// 					sb.setDefaultData = sbStepsReverse[j];
// 		// 				}
// 		// 			}
// 		// 		}
// 		// 		Cookies.setCookie('system-builder', JSON.stringify(sb.getData), 90);
// 		// 		this.initSections(steps, sb.getData, sb);
// 		// 	}.bind(this));
// 		// }
// 	},

// 	initSections: function(steps, data, sb, first) {
// 		for (var i = 0; i < steps.length; i++) {
// 			if(!data[steps[i]]['completed']) {
// 				sb[sb.allFunctions[steps[i]]]()
// 				break
// 			}
// 		}

// 		let foundActive = false;
// 		for (var i = 0; i < steps.length; i++) {
// 			if(!data[steps[i]]['completed']) {
// 				if(!foundActive) {
// 					sb.visitedSection(steps[i], 'active');
// 					foundActive = true
// 				} else {
// 					sb.visitedSection(steps[i], false);
// 				}
// 			} else {
// 				sb.visitedSection(steps[i], 'visited');
// 			}
// 		}
// 		sb.updateTotalPrice();
// 		sb.updateAll();
// 	}
// }

class SystemBuilderLogic {
	constructor(section) {
		this.elements = {
			systemBlocks: section.querySelectorAll('.system-block'),
			systemButtons: section.querySelectorAll('.system-option'),
			mapsUpdateEls: section.querySelectorAll('.install-maps-update'),
			mapsEls: section.querySelectorAll('.installation-maps'),
			systemContainerShow: section.querySelectorAll('.system-container-show'),
			systemContainerTarget: section.querySelectorAll('.system-show-target'),
			allSelectors: section.querySelectorAll('.std-checkbox input'),
			radioContainer: section.querySelectorAll('.system-radio-container'),
			allEmbeds: section.querySelectorAll('.installation-maps'),
			productTotal: section.querySelector('#product-total'),
			systemTableTotal: section.querySelector('#system-total-price'),
			productData: JSON.parse(section.querySelector('#product-data').textContent),
			totalPrice: section.querySelector('#total-price'),
			finalTotalPrice: section.querySelector('#system-builder-final-total'),
			totalSystem: section.querySelector('#total-system'),
			systemForm: section.querySelector('#system-form'),
			financeBlock: section.querySelector('.finance-block'),
			selectFinance: section.querySelector('#select-finance'),
			inputProduct: section.querySelector('#system-product-input'),
			inputTotal: section.querySelector('#system-total-input'),
			systemProgress: document.querySelector('#system-progress'),
			systemLoading: document.querySelector('#system-builder-loading'),
			systemFormSubmit: document.querySelector('#system-builder-form-submit'),
			systemSelections: document.querySelector('#system-selection-options'),
			systemTotalAndProducts: document.querySelector('#system-builder-total-and-products'),
			financeSlider: document.querySelector('.finance-slider'),
			financeText: document.querySelector('#totalpricetext'),
			dynamicProducts: document.querySelectorAll('.system-builder-dynamic-product')
		}

		this.pdf = {
			systemPdf: document.querySelector('#system-pdf'),
			customerDetails: document.querySelector('#system-pdf-details'),
			productDetails: document.querySelector('#system-pdf-product')
		}

		this.defaultSelections = {
			'filtration': null,
			'operators': null,
			'system': null,
			'size': null,
			'reels': null,
			'hot-water': null,
			'poles': null,
			'accessories': null,
			'installation': null,
			'floor-protection': null,
			'total': null
		}

		this.defaultProducts = {
			'system-products': null,
			'reel-products': null,
			'hot-water': null,
			'floor-protection': null
		}

		this.selections = Cookies.getCookie('selections-1') ? JSON.parse(Cookies.getCookie('selections-1')) : this.defaultSelections

		this.products = Cookies.getCookie('products') ? JSON.parse(Cookies.getCookie('products')) : this.defaultProducts

		this.form = {
			'email': section.querySelector('#system-contact-form [name="email"]'),
			'name': section.querySelector('#system-contact-form [name="name"]'),
			'phone': section.querySelector('#system-contact-form [name="phone"]'),
			'finance': section.querySelector('#system-contact-form [name="finance"]')
		}

		this.filtration = {
			filtPostcode: section.querySelector('#select-filtration-postcode'),
			filtPostcodeResults: section.querySelector('#select-filtration-results'),
			filtPostcodeLoading: section.querySelector('.sb-loading'),
			filtPostcodeResultsList: section.querySelector('#select-filtration-results-list'),
			filtAnswer: section.querySelector('#select-filtration-answer')
		}

		this.currentPosition = Cookies.getCookie('currentPosition') ? parseInt(Cookies.getCookie('currentPosition')) : 0;
	}

	init() {
		this.displayBlocks();
		this.initButtons();
		this.mapsUpdate();
		this.initContainerShow();
		this.updateFinance();
		this.initPostcodeCheck();
		this.initDynamicProducts();
		document.addEventListener('click', () => this.workoutPrices());
	}

	async initDynamicProducts() {
		const dynamicProducts = this.elements.dynamicProducts;
		for (var i = 0; i < dynamicProducts.length; i++) {
			let handle = dynamicProducts[i].getAttribute('data-product-url');
			let variants = dynamicProducts[i].getAttribute('data-variant-limits').split(',');
			let subtitle = dynamicProducts[i].getAttribute('data-subtitle');

			let productData = await fetch('https://windowcleaningwarehouse.co.uk/products/' + handle + '.js')
			  .then(response => {
			  	return response.json()
			  })
			  .then(data => { return data })
			  .catch((err) => {
			  	console.log(err)
			  	return false
			  });

			if(productData) {
				let variantHTML = '';
				for (var j = 0; j < productData.variants.length; j++) {
					if(productData.variants[j].available) {
						let variant = productData.variants[j];
						variantHTML = variants.includes(variant.id.toString()) ? variantHTML : variantHTML + `
							<div class="flex system-builder__product">
								<label class="std-checkbox text-extra-bold ml-auto mr-auto" for="${variant.id}">
									${variant.title == 'Default Title' ? 'Select' : variant.title}
							    	<input data-product-data='
							    		{
							    			"productTitle": "${productData.title.replace(/"/g, '')}",
							    			"variantTitle": "${variant.title.replace(/"/g, '')}",
							    			"id": "${variant.id}",
							    			"price": ${variant.price},
							    			"image": "${variant.featured_image ? variant.featured_image : productData.images[0]}"
							    		}
							    	' type="checkbox" id="${variant.id}" name="accessories[]">
							    	<span class="std-checkmark"></span>

					    	    	<div class="quantity ml-5">
					    		    	<input type="button" value="-" class="minus quantity__btn quantity__minus">
					    		    	<input type="number" step="1" min="1" max="" name="quantity" value="1" title="ProductQuantity" class="quantity__field quantity-selector">
					    		    	<input type="button" value="+" class="plus quantity__btn quantity__plus">
					    	    	</div>
							    </label>
							</div>
						`
					}
				}

				dynamicProducts[i].innerHTML = `
					<div class="col-one-whole mb-50-medium mb-25 pl-5 pr-5">
						<p class="text-bold">${productData.title}</p>
						${variantHTML}
						${subtitle ? `<p class="font-small">${subtitle}</p>` : ''}
					</div>
				`;
			}
		}
	}

	displayBlocks() {
		for (var i = 0; i < this.elements['systemBlocks'].length; i++) {
			if(this.currentPosition == i) {
				this.elements['systemBlocks'][i].style.display = 'block';
				this.hideableOptions(this.elements['systemBlocks'][i]);
				if(i > 5 && !this.products['system-products']) {
					alert('Error: No System Found With Those Options')
				}
			} else {
				this.elements['systemBlocks'][i].style.display = 'none';
			}
		}
		this.resetInputs();
		this.updateProductTotal();
		this.checkProduct();
		this.workoutPrices();
		this.updateFinance();
		this.updateTotalInputs();
		this.elements.systemProgress.style.width = `${(this.currentPosition / (Object.keys(this.selections).length - 1)) * 100}%`
		window.scrollTo(0, 0);
	}

	updatePriceEl(el, gbpPrice, amount, altPrice, price) {
		if(el) {
			el.setAttribute('data-gbp-price', gbpPrice.includes('&pound;') ? gbpPrice.replace('&pound;', '£') : gbpPrice);
			el.setAttribute('data-amount', amount);
			el.setAttribute('data-alt-price', altPrice.includes('&pound;') ? altPrice.replace('&pound;', '£') : altPrice);
			price = price.includes('&pound;') ? price.replace('&pound;', '£') : price;

			el.innerHTML = price;
			this.elements.totalSystem.innerHTML = this.products['system-products'] ? `${this.products['system-products'].product.productTitle} - ${this.products['system-products'].product.variantTitle}` : ''
		} 
	}

	resetInputs() {
		this.elements.allSelectors = document.querySelectorAll('.std-checkbox input')
		for (var i = 0; i < this.elements.allSelectors.length; i++) {
			this.elements.allSelectors[i].checked = false;
		}

		for (var i = 0; i < this.elements.radioContainer.length; i++) {
			this.elements.radioContainer[i].querySelector('[type="radio"]').checked = true;
		}

		for (var i = 0; i < this.elements.allEmbeds.length; i++) {
			this.elements.allEmbeds[i].style.display = 'none';
		}
	}

	updateVisuals() {
		for (var i = 0; i < Object.entries(this.selections).length; i++) {
			let key = Object.entries(this.selections)[i][0];
			let val = Object.entries(this.selections)[i][1];
			for (var j = 0; j < document.querySelectorAll(`[data-system-key="${key}"]`).length; j++) {
				if(!document.querySelectorAll(`[data-system-key="${key}"]`)[j].getAttribute('data-multi-question')) {
					document.querySelectorAll(`[data-system-key="${key}"]`)[j].classList.remove('std-btn__swipe--selected');
				}
			}
			document.querySelector(`[data-system-value='${val}']`) && val ? document.querySelector(`[data-system-value="${val}"]`).classList.add('std-btn__swipe--selected') : null;				
		}
	}

	set setProduct(data) {
		this.products[data[0]] = data[1];
		if(this.products) {
			let tempProducts = JSON.stringify(this.products).replace(/®/g, "").replace(/™/g, '');
			Cookies.setCookie('products', tempProducts, 30);
			this.updateVisuals();
		}
	}

	set setData(data) {
		this.selections[data[0]] = data[1];
		if(this.selections) {
			let tempSelection = JSON.stringify(this.selections).replace(/®/g, "").replace(/™/g, '');
			Cookies.setCookie('selections-1', tempSelection, 30);
			this.updateVisuals();
		}
	}

	set updatePosition(change) {
		this.currentPosition = this.currentPosition + change;
		Cookies.setCookie('currentPosition', this.currentPosition, 30);
	}

	set setPosition(change) {
		this.currentPosition = change;
		Cookies.setCookie('currentPosition', this.currentPosition, 30);
	}

	set resetData(def) {
		Cookies.setCookie('currentPosition', '', 30);
		Cookies.setCookie('selections-1', '', 30);
		Cookies.setCookie('products', '', 30);
		location.reload();
	}

	initButtons() {
		for (var i = 0; i < this.elements.systemButtons.length; i++) {
			let option = this.elements.systemButtons[i];
			option.addEventListener('click', function() {
				let key = option.getAttribute('data-system-key');
				let val = option.getAttribute('data-system-value');
				this.setData = [key, val];
				if(option.getAttribute('data-single-product-data')) {
					this.setProduct = [key, JSON.parse(option.getAttribute('data-single-product-data'))];
				}
				if(!option.getAttribute('data-multi-question')) {
					this.updatePosition = 1;
					this.displayBlocks();
				}

				console.log(this.selections)
			}.bind(this))
		}
	}

	hideableOptions(section) {
		let allOptions = section.querySelectorAll('.hideable-option');
		for (var i = 0; i < allOptions.length; i++) {
			let optionCheckJson = allOptions[i].getAttribute('data-hideable-check');
			let optionCheck = JSON.parse(optionCheckJson);
			let check = true;
			for (var j = 0; j < optionCheck.check.length; j++) {
				let optionCheckVal = (Object.values(optionCheck.check[j])[0]).split('|');
				let optionCheckKey = Object.keys(optionCheck.check[j])[0];
				if(!optionCheckVal.includes(this.selections[optionCheckKey])) {
					check = false;
					break
				}
			}
			allOptions[i].style.display = check ? 'block' : 'none';
		}
	}

	startAgain() {
		// this.setData = ['filtration', null];
		// this.setPosition = 0;
		// this.setProduct = ['filtration', null];
		// this.displayBlocks();
		this.resetData = true;
	}

	previousStep(step) {
		this.setData = [step, null];
		if(this.products[step]) {
			this.setProduct = [step, null];
		}
		this.updatePosition = -1;
		this.displayBlocks();
	}

	nextStep() {
		this.updatePosition = 1;
		this.displayBlocks();
	}

	nextProduct(btn, section) {
		let productDataArr = [];
		let totalQuantity = 0;
		const selectedProducts = btn.closest('.system-block').querySelectorAll(`[name="${section}[]"]:checked`);
		for (var i = 0; i < selectedProducts.length; i++) {
			let productData = JSON.parse(selectedProducts[i].getAttribute('data-product-data'));
			let productQuantity = selectedProducts[i].closest('.std-checkbox').querySelector('.quantity-selector').value;
			productData['quantity'] = productQuantity;
			productDataArr.push(productData);
			totalQuantity = totalQuantity + parseInt(productQuantity);
		}
		// Workaround for brushes
		if(section == 'poles') {
			const poleEl = btn.closest('.system-block').querySelector('.sb-brush');
			const pole = poleEl.checked;
			if(pole) {
				let productData = JSON.parse(poleEl.getAttribute('data-product-data'));
				productData['quantity'] = totalQuantity;
				productDataArr.push(productData);
			}
		}
		this.setData = [section, productDataArr];
		this.updatePosition = 1;
		this.displayBlocks();
	}

	findNumberOfPoles() {
		let total = 0
		let selectedPoles = document.querySelector('[data-system-step="poles"]').querySelectorAll(`[name="poles[]"]:not(.sb-brush):checked`);
		for (var j = 0; j < selectedPoles.length; j++) {
			let quantity = selectedPoles[j].closest('.std-checkbox').querySelector('.quantity-selector').value;
			total = total + parseInt(quantity)
		}
		return total
	}

	selectedProductsPriceCheck() {
		let total = 0;

		for (var i = 0; i < Object.keys(this.selections).length; i++) {
			let section = Object.keys(this.selections)[i];

			if(!this.selections[section]) {
				let selectedProducts = document.querySelectorAll(`[name="${section}[]"]:checked`);
				for (var j = 0; j < selectedProducts.length; j++) {
					let productData = JSON.parse(selectedProducts[j].getAttribute('data-product-data'));
					let productQuantity = selectedProducts[j].classList.contains('sb-brush') ? this.findNumberOfPoles() : selectedProducts[j].closest('.std-checkbox').querySelector('.quantity-selector').value;
					total = total + (productData.price * productQuantity)
				}
			}
		}

		return total;
	}

	mapsUpdate() {
		for (var i = 0; i < this.elements.mapsUpdateEls.length; i++) {
			this.elements.mapsUpdateEls[i].addEventListener('click', function(e) {
				let mapsId = e.target.classList.contains('std-checkbox') ? e.target.getAttribute('data-maps-id') : e.target.closest('.std-checkbox').getAttribute('data-maps-id');
				for (var j = 0; j < this.elements.mapsEls.length; j++) {
					this.elements.mapsEls[j].style.display = mapsId == this.elements.mapsEls[j].id ? 'block' : 'none';
				}
			}.bind(this));
		}
	}

	initContainerShow() {
		for (var i = 0; i < this.elements.systemContainerShow.length; i++) {
			let containerTriggers = this.elements.systemContainerShow[i].querySelectorAll('.system-container-trigger');
			for (var i = 0; i < containerTriggers.length; i++) {
				containerTriggers[i].addEventListener('click', function(e) {
					let trigger = e.target.classList.contains('system-container-trigger') ? e.target : e.target.closest('.system-container-trigger');
					// this.resetContainerShow();
					if(trigger.getAttribute('data-container-key')) {
						this.updateContainerShow(trigger, 'add');
					} else {
						this.updateContainerShow(trigger, 'remove');
					}
				}.bind(this))
			}
			for (var i = 0; i < containerTriggers.length; i++) {
				if(containerTriggers[i].classList.contains('std-btn__swipe--selected')) {
					if(containerTriggers[i].getAttribute('data-container-key')) {
						this.updateContainerShow(containerTriggers[i], 'add');
					}
				}
			}
		}
	}

	resetContainerShow() {
		for (var i = 0; i < this.elements.systemContainerShow.length; i++) {
			let step = this.elements.systemContainerShow[i].getAttribute('data-system-step');
			let containerTriggers = this.elements.systemContainerShow[i].querySelectorAll('.system-container-trigger');

			if(!this.selections[step]) {
				for (var i = 0; i < containerTriggers.length; i++) {
					this.updateContainerShow(containerTriggers[i], 'remove');
				}
			}
		}
	}

	updateContainerShow(trigger, change) {
		if(change == 'remove') {
			for (var i = 0; i < document.querySelectorAll('.std-btn__swipe--selected').length; i++) {
				document.querySelectorAll('.std-btn__swipe--selected')[i].classList.remove('std-btn__swipe--selected');
			}
			for (var i = 0; i < this.elements.systemContainerTarget.length; i++) {
				this.elements.systemContainerTarget[i].classList.add('d-none');
			}
		} else {
			trigger.classList.add('std-btn__swipe--selected');
			let containerKey = trigger.getAttribute('data-container-key');
			document.querySelector(containerKey).classList.remove('d-none')
		}
		this.updateVisuals();
	}

	updateTotalKey(key) {
		return key.replace('-', ' ').split(' ').map((word) => { 
		    return word[0].toUpperCase() + word.substring(1); 
		}).join(" ");
	}

	checkProduct() {
		const { systems, systemProducts } = this.elements.productData;
		this.setProduct = ['system-products', null];
		this.setProduct = ['reel-products', null];
		console.log(systemProducts, 'systems')

			for (var i = 0; i < systems.length; i++) {
				if(systems[i]['filtration'].includes(this.selections['filtration']) && 
					systems[i]['reels'] == this.selections['reels'] && 
					systems[i]['operators'] == this.selections['operators'] && 
					systems[i]['system'] == this.selections['system'] && 
					systems[i]['size'].includes(this.selections['size'])) {
					let reelsArr = [];
					let systemHandle = systems[i].product_handles;
					let systemSku = systems[i].variant_sku;
					// console.log(systemProducts, systemHandle, systemSku)

					if(systemProducts[systemHandle][systemSku]) {
						let foundSystem = systemProducts[systemHandle][systemSku];
						systems[i]['product'] = foundSystem;

						this.setProduct = ['system-products', systems[i]];
						for (var j = 0; j < systems[i].additional_reel.length; j++) {
							let reelProduct = this.elements.productData.reels[systems[i]['additional_reel'][j]];
							if(reelProduct) {
								reelsArr.push(reelProduct);
							}
						}
					} else {
						alert('Error: No system found with these options')
					}	
					this.setProduct = ['reel-products', reelsArr];
					break
				}
			}
	}	

	workoutPrices() {
		let total = this.getTotal();
		this.updatePriceTotal(total);
	}

	updateTotalInputs() {
		this.elements.inputProduct.value = JSON.stringify({
			'products': this.products,
			'selections': this.selections
		})
		this.elements.inputTotal.value = this.getTotal();
	}

	getTotal() {
		let total = 0;
		let productResults = ['installation', 'poles',  'accessories'];
		let currency = Money.getCurrency();

		// Check Multi-select products
		for (var i = 0; i < productResults.length; i++) {
			if(this.selections[productResults[i]]) {
				for (var j = 0; j < this.selections[productResults[i]].length; j++) {
					let productResult = this.selections[productResults[i]][j];
					total = total + (productResult.price * parseInt(productResult.quantity));
				}
			}
		}
		// Check auto-added products
		let productsToCheck = ['system-products', 'hot-water', 'floor-protection'];
		for (var i = 0; i < productsToCheck.length; i++) {
			if(this.products[productsToCheck[i]]) {
				total = total + (productsToCheck[i] == 'system-products' ? this.products[productsToCheck[i]]['product']['price'] : this.products[productsToCheck[i]]['price']);
			}
		}
		// Check auto-added products where multiples can be added
		if(this.products['reel-products']) {
			for (var i = 0; i < this.products['reel-products'].length; i++) {
				total = total + this.products['reel-products'][i].price;
			}
		}
		total = total + this.selectedProductsPriceCheck();
		return total
	}

	updatePriceTotal(total) {
		let currency = Money.getCurrency();
		let altPrice = Currency.formatMoney(total * 1.2, Currency.money_format[currency]);
		let priceFormatted = Currency.formatMoney(total, Currency.money_format[currency]);

		this.updatePriceEl(this.elements.finalTotalPrice, priceFormatted, total, altPrice, priceFormatted)
		this.updatePriceEl(this.elements.totalPrice, priceFormatted, total, altPrice, priceFormatted);
	}

	updateProductTotal() {
		let productsInSelections = ['poles', 'accessories', 'installation'];
		let productData = this.products;
		this.elements.productTotal.innerHTML = '';

		// System
		if(this.products['system-products']) {
			let currency = Money.getCurrency();
			let total = this.getTotal();
			let priceFormatted = Currency.formatMoney(this.products['system-products'].product.price, Currency.money_format[currency]);

			this.elements.productTotal.innerHTML = this.elements.productTotal.innerHTML + `
				<tr>
				    <td>${this.products['system-products'].product.image ? `<img src="https:${this.products['system-products'].product.image}">` : ''}</td>
				    <td>
				    	<strong>${this.products['system-products'] ? `${this.products['system-products'].product.productTitle}` : ''}</strong>
				    	<p>${this.products['system-products'] ? this.products['system-products'].product.variantTitle : ''} - x1</p>
				    </td>
				    <td class="font-green system-builder__table-price">${priceFormatted}</td>
				</tr>`;
		}

		// Hot Water
		if(productData['hot-water']) {
			this.elements.productTotal.innerHTML = this.elements.productTotal.innerHTML + `
				<tr>
				    <td>${productData['hot-water'] ? productData['hot-water'].image ? `<img src="https:${productData['hot-water'].image}">` : '' : ''}</td>
				    <td>
				    	<strong>${productData['hot-water'].productTitle}</strong>
				    	<p>${productData['hot-water'].variantTitle} - x1</p>
				    </td>
				    <td class="font-green system-builder__table-price">${this.formatPrice((1 * productData['hot-water'].price))}</td>
				</tr>
				`
		}

		// Reels
		if(this.products['reel-products']) {
			for (var j = 0; j < productData['reel-products'].length; j++) {
				if(productData['reel-products'][j]) {
					this.elements.productTotal.innerHTML = this.elements.productTotal.innerHTML + `
						<tr>
						    <td>${productData['reel-products'][j] ? productData['reel-products'][j].image ? `<img src="https:${productData['reel-products'][j].image}">` : '' : ''}</td>
						    <td>
						    	<strong>${productData['reel-products'][j].productTitle}</strong>
						    	<p>${productData['reel-products'][j].variantTitle} - x1</p>
						    </td>
						    <td class="font-green system-builder__table-price">${this.formatPrice((1 * productData['reel-products'][j].price))}</td>
						</tr>
						`
				}
			}
		}

		// Poles, accessories, installation
		for (var i = 0; i < productsInSelections.length; i++) {
			let products = sb.selections[productsInSelections[i]];
			if(products) {
				for (var j = 0; j < products.length; j++) {
					if(products[j].productTitle != 'No Installation') {
						this.elements.productTotal.innerHTML = this.elements.productTotal.innerHTML + `
							<tr>
							    <td>${products[j].image ? `<img src="https:${products[j].image}">` : ''}</td>
							    <td>
							    	<strong>${products[j].productTitle}</strong>
							    	<p>${products[j].variantTitle} - x${products[j].quantity}</p>
							    </td>
							    <td class="font-green system-builder__table-price">${this.formatPrice((parseInt(products[j].quantity) * products[j].price))}</td>
							</tr>`;
					}
				}
			}	
		}

		// Floor Protection
		if(productData['floor-protection']) {
			this.elements.productTotal.innerHTML = this.elements.productTotal.innerHTML + `
				<tr>
				    <td>${productData['floor-protection'] ? productData['floor-protection'].image ? `<img src="https:${productData['floor-protection'].image}">` : '' : ''}</td>
				    <td>
				    	<strong>${productData['floor-protection'].productTitle}</strong>
				    	<p>${productData['floor-protection'].variantTitle} - x1</p>
				    </td>
				    <td class="font-green system-builder__table-price">${this.formatPrice((1 * productData['floor-protection'].price))}</td>
				</tr>
				`
		}

		let selectionOptions = ['system', 'filtration', 'size', 'reels', 'operators', 'hot-water', 'floor-protection'];
		this.elements.systemSelections.innerHTML = '';
		for (var i = 0; i < selectionOptions.length; i++) {
			if(this.selections[selectionOptions[i]]) {
				this.elements.systemSelections.innerHTML = this.elements.systemSelections.innerHTML + `
				<div class="col-one-half pr-5 pl-5 pt-10 text-center">
					<strong>${this.updateTotalKey(selectionOptions[i])}:</strong>
					<p>${this.selections[selectionOptions[i]]}</p>
				</div>
				`
			}
		}
	}

	formatPrice(amount) {
		let currency = Money.getCurrency();
		let total = this.getTotal();
		let formattedTotal = Currency.formatMoney(amount, Currency.money_format[currency]);
		return formattedTotal
	}

	openCallback() {
		systemCallback.style.display = 'block';
	}

	async submitProducts() {
		let toAddVariants = {'items': [] };

		// Add standard products
		let productResults = ['installation', 'poles', 'accessories'];
		for (var i = 0; i < productResults.length; i++) {
			if(this.selections[productResults[i]]) {
				for (var j = 0; j < this.selections[productResults[i]].length; j++) {
					let productResult = this.selections[productResults[i]][j];
					if(productResult['id']) {
						toAddVariants['items'].push({
							'quantity': parseInt(productResult['quantity']),
							'id': productResult['id']
						});
					}
				}
			}
		}

		// Auto-added products
		let productsToCheck = ['system-products', 'hot-water', 'floor-protection'];
		for (var i = 0; i < productsToCheck.length; i++) {
			let variantId = this.products[productsToCheck[i]] ? productsToCheck[i] == 'system-products' ? this.products[productsToCheck[i]]['product']['id'] : this.products[productsToCheck[i]]['id'] : null;
			if(variantId) {
				toAddVariants['items'].push({
					'quantity': 1,
					'id': variantId
				});
			}
		}
		// Check auto-added products where multiples can be added
		if(this.products['reel-products']) {
			for (var i = 0; i < this.products['reel-products'].length; i++) {
				toAddVariants['items'].push({
					'quantity': this.products['reel-products'][i]['quantity'],
					'id': this.products['reel-products'][i]['id']
				});
			}
		}
		
		let toAddVariantsRes = await makePostRequest('/cart/add.js', toAddVariants);
		if(toAddVariantsRes) {
			Global.updateCartHtmlGlobal();
			showModal(false, 'Added to cart successfully');
		} else {
			showModal(true, 'An Error Occurred');
		}
	}

	updateFinance() {
		let amount = this.getTotal();
		this.elements.financeBlock.setAttribute('data-finance-price', amount);

		if(amount > 99999) {
			this.elements.selectFinance.classList.remove('d-none');
			FinanceUtils.workoutFinance(window.financeCheck !== true, amount / 100)
		} else {
			this.elements.selectFinance.classList.add('d-none');
		}
	}

	async submitEmail() {
		this.updateBtn(true);
		let emailData = {
			'email': this.form.email.value,
			'phone': this.form.phone.value,
			'name': this.form.name.value,
			'finance': this.form.finance.checked
		}
		let custDetails = `
		<table>
			<tr>
			  <td><strong>Name</strong></td>
			  <td>${emailData.name}</td>
			</tr>
			<tr>
			  <td><strong>Email</strong></td>
			  <td>${emailData.email}</td>
			</tr>
			<tr>
			  <td><strong>Phone</strong></td>
			  <td>${emailData.phone}</td>
			</tr>
			<tr>
			  <td><strong>Interested in Finance?</strong></td>
			  <td>${emailData.finance ? 'Yes' : 'No'}</td>
			</tr>
		</table>
		`;

		this.buildPdf(emailData);

		let trackingDetails = await makePostRequest(`http://europe-west2-wcw-water.cloudfunctions.net/system-builder`, {'selections': this.pdf.systemPdf.outerHTML, 'emailData': emailData, 'custDetails': custDetails});
		trackingDetails ? showModal(false, 'Form Submitted Successfully') : showModal(true, 'An Error Occurred. Please Contact Support.')
		this.updateBtn(false);
	}

	buildPdf(emailData) {
		let currency = Money.getCurrency();
		let priceFormatted = Currency.formatMoney(this.products['system-products'].product.price, Currency.money_format[currency]);
		let productData = this.products;

		this.pdf.customerDetails.innerHTML = `
			<p style="font-size: 1em; font-weight: bold; margin: 0;">${emailData.name}</p>
			<p style="margin: 0; font-size: 0.8em;">${emailData.email}</p>
			<p style="margin: 0; font-size: 0.8em;">0${emailData.phone}</p>
		`;

		this.pdf.productDetails.innerHTML = `
		<tr>
			<th colspan="2" style="width: 40%; text-align: left; padding: 5px; color: white; background-color: #484848;">
				Product
			</th>
			<th style="width: 10%; text-align: left; padding: 5px; color: white; background-color: #484848;">
				Quantity
			</th>
			<th style="width: 20%; text-align: left; padding: 5px; color: white; background-color: #484848;">
				Total Price (exc VAT)
			</th>
		</tr>
		<tr>
		    <td style="padding: 5px; background-color: #8080801f;" colspan="2"> 
		    	<div style="display: flex;">
			    	${this.products['system-products'] ? `<img style="width: 20%;" src="https:${this.products['system-products'].product.image}">` : '' }
			    	<div style="width: 89%; vertical-align: top; padding-left: 10px;">
			    		<strong style="margin-top: 10px; margin-bottom: 0;">${this.products['system-products'] ? `${this.products['system-products'].product.productTitle}` : ''}</strong>
			    		<p>${this.products['system-products'] ? this.products['system-products'].product.variantTitle : ''}</p>
			    	</div>	
		    	</div>
		    </td>
		    <td style="width: 10%; background-color: #8080801f;" padding: 5px;>
		    	<p>1</p>
		    </td>
		    <td style="color: #239a41; width: 20%; padding: 5px; background-color: #8080801f;">${priceFormatted}</td>
		</tr>`

		let even = true;

		// Hot water
		if(productData['hot-water']) {
			this.pdf.productDetails.innerHTML = this.pdf.productDetails.innerHTML + `
				<tr>
				    <td style="padding: 5px; ${even ? '' : ' background-color: #8080801f;'}" colspan="2"> 
				    	<div style="display: flex;">
					    	${productData['hot-water'] ? productData['hot-water'].image ? `<img style="width: 20%;" src="https:${productData['hot-water'].image}">` : '' : '' }
					    	<div style="width: 89%; vertical-align: top; padding-left: 10px;">
					    		<strong style="margin-top: 10px; margin-bottom: 0;">${productData['hot-water'].productTitle}</strong>
					    		<p>${productData['hot-water'].variantTitle} - x1</p>
					    	</div>	
				    	</div>
				    </td>
				    <td style="width: 10%; ${even ? '' : ' background-color: #8080801f; '}" padding: 5px;>
				    	<p>1</p>
				    </td>
				    <td style="color: #239a41; width: 20%; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">${this.formatPrice((1 * productData['hot-water'].price))}</td>
				</tr>
				`
			even = !even;
		}

		// Reels
		if(this.products['reel-products']) {
			for (var j = 0; j < productData['reel-products'].length; j++) {
				if(productData['reel-products'][j]) {
					this.pdf.productDetails.innerHTML = this.pdf.productDetails.innerHTML + `
						<tr>
						    <td style="padding: 5px; ${even ? '' : ' background-color: #8080801f;'}" colspan="2"> 
						    	<div style="display: flex;">
							    	${productData['reel-products'][j] ? productData['reel-products'][j].image ? `<img style="width: 20%;" src="https:${productData['reel-products'][j].image}">` : '' : '' }
							    	<div style="width: 89%; vertical-align: top; padding-left: 10px;">
							    		<strong style="margin-top: 10px; margin-bottom: 0;">${productData['reel-products'][j].productTitle}</strong>
							    		<p>${productData['reel-products'][j].variantTitle} - x1</p>
							    	</div>	
						    	</div>
						    </td>
						    <td style="width: 10%; ${even ? '' : ' background-color: #8080801f; '}" padding: 5px;>
						    	<p>1</p>
						    </td>
						    <td style="color: #239a41; width: 20%; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">${this.formatPrice((1 * productData['reel-products'][j].price))}</td>
						</tr>
						`
					even = !even
				}
			}
		}

		let productsInSelections = ['poles', 'accessories', 'installation'];

		for (var i = 0; i < productsInSelections.length; i++) {
			let products = this.selections[productsInSelections[i]];
			if(products) {
				for (var j = 0; j < products.length; j++) {
					this.pdf.productDetails.innerHTML = this.pdf.productDetails.innerHTML + `
	  				<tr>
					    <td style="padding: 5px; ${even ? '' : ' background-color: #8080801f;'}" colspan="2"> 
					    	<div style="display: flex;">
						    	${products[j].image ? `<img style="width: 20%;" src="https:${products[j].image}">` : '' }
						    	<div style="width: 89%; vertical-align: top; padding-left: 10px;">
						    		<strong style="margin-top: 10px; margin-bottom: 0;">${products[j].productTitle}</strong>
						    		<p>${products[j].variantTitle}</p>
						    	</div>	
					    	</div>
					    </td>
					    <td style="width: 10%; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">
					    	<p>${products[j].quantity}</p>
					    </td>
					    <td style="color: #239a41; width: 20%; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">${this.formatPrice((parseInt(products[j].quantity) * products[j].price))}</td>
					</tr>`;
					even = !even;
				}
			}	
		}

		// Floor Protection
		if(productData['floor-protection']) {
			this.pdf.productDetails.innerHTML = this.pdf.productDetails.innerHTML + `
			<tr>
			    <td style="padding: 5px; ${even ? '' : ' background-color: #8080801f;'}" colspan="2"> 
			    	<div style="display: flex;">
				    	${productData['floor-protection'].image ? `<img style="width: 20%;" src="https:${productData['floor-protection'].image}">` : '' }
				    	<div style="width: 89%; vertical-align: top; padding-left: 10px;">
				    		<strong style="margin-top: 10px; margin-bottom: 0;">${productData['floor-protection'].productTitle}</strong>
				    		<p>${productData['floor-protection'].variantTitle}</p>
				    	</div>	
			    	</div>	
			    </td>
			    <td style="width: 10%; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">
			    	<p>1</p>
			    </td>
			    <td style="color: #239a41; width: 20%; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">${this.formatPrice(productData['floor-protection'].price)}</td>
			</tr>`;
			even = !even;
		}

		this.pdf.productDetails.innerHTML = this.pdf.productDetails.innerHTML + `
		<tr>
			<td style="text-align: right; font-weight: bold; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}" colspan="3">
				Interested in Finance
			</td>
			<td style="color: #239a41; font-size: 1.1em; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}">
				${emailData.finance ? 'Yes' : 'No'}
			</td>
		</tr>
		${emailData.finance ?
		`<tr>
			<td style="text-align: right; font-weight: bold; padding: 5px; ${!even ? '' : ' background-color: #8080801f;'}" colspan="3">
				No. of Years
			</td>
			<td style="color: #239a41; font-size: 1.1em; padding: 5px; ${!even ? '' : ' background-color: #8080801f;'}">
				${this.elements.financeSlider.value}
			</td>
		</tr>
		<tr>
			<td style="text-align: right; font-weight: bold; padding: 5px; ${even ? '' : ' background-color: #8080801f;'}" colspan="3">
				Finance (per Month Exc. VAT)
			</td>
			<td style="color: #239a41; font-size: 1.1em; padding: 5px; ${even ? '' : ' background-color: #8080801f;'} font-weight: bold;">
				${this.elements.financeText.textContent}
			</td>
		</tr>`
		: '' }
		<tr>
			<td style="text-align: right; font-weight: bold; padding: 5px; ${!even ? '' : ' background-color: #8080801f;'}" colspan="3">
				Quote Total (Exc VAT)
			</td>
			<td style="color: #239a41; font-size: 1.1em; padding: 5px; ${!even ? '' : ' background-color: #8080801f;'} font-weight: bold;">
				${this.formatPrice(this.getTotal())}
			</td>
		</tr>
		`;
	}

	updateBtn(loading) {
		this.elements.systemLoading.style.display = loading ? 'block' : 'none';
		this.elements.systemFormSubmit.style.display = loading ? 'none' : 'block';
	}

	async initPostcodeCheck() {
		let inputs = ['input', 'focus'];
		for (var i = 0; i < inputs.length; i++) {
			this.filtration.filtPostcode.addEventListener(inputs[i], async function() {

				this.filtration.filtPostcodeLoading.classList.remove('d-none');
				this.filtration.filtPostcodeResults.classList.add('sb__license-results--active');
				this.filtration.filtPostcodeResultsList.innerHTML = '';

				let postcodeText = this.filtration.filtPostcode.value;
				if(postcodeText) {
					postcodeText = postcodeText.toUpperCase();
					let foundPostcodes = await fetch(`https://wcw-water.nw.r.appspot.com/?postcode=${postcodeText}`)
					  .then(function(response) {
					    return response.text();
					  })
					  .then(function(json) {
					    return JSON.parse(json)
					  })
					  .catch(function(error) {
					    console.log('Request failed', error);
					    return null;
					}); 

					if(foundPostcodes) {
						if(foundPostcodes['result']) {
							if(Object.keys(foundPostcodes['result']).length > 0) {
								this.filtration.filtPostcodeLoading.classList.add('d-none');
								for (var j = 0; j < Object.entries(foundPostcodes['result']).length; j++) {
									let postcodeResult = Object.entries(foundPostcodes['result'])[j]
									this.filtration.filtPostcodeResultsList.innerHTML = this.filtration.filtPostcodeResultsList.innerHTML +  `
										<div data-postcode="${postcodeResult[0]}" data-water="${postcodeResult[1]}" class="pt-5 pb-5 pr-5 pl-5 sb-water-result sb__license-result">
											<p class="text-bold">${postcodeResult[0]}</p>
										</div>
									`
								}
							} else {
								this.filtration.filtPostcodeLoading.classList.add('d-none');
								this.filtration.filtPostcodeResultsList.innerHTML = '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">Postcode Area Not Found</p>'
							}
						} else {
							this.filtration.filtPostcodeLoading.classList.add('d-none');
							this.filtration.filtPostcodeResultsList.innerHTML = '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">Postcode Area Not Found</p>'
						}
					} else {
						this.filtration.filtPostcodeLoading.classList.add('d-none');
						this.filtration.filtPostcodeResultsList.innerHTML = '<p class="pb-5 pr-5 pl-5 pt-5 text-center text-bold">Postcode Area Not Found</p>'
					}
				} else {
					this.filtration.filtPostcodeLoading.classList.add('d-none');
					this.filtration.filtPostcodeResults.classList.remove('sb__license-results--active');
					this.filtration.filtPostcodeResultsList.innerHTML = '';
				}
			}.bind(this));
		}

		document.addEventListener('click', function(e) {
			if(e.target.closest('.sb-water-result')) {
				this.filtration.filtPostcodeResults.classList.remove('sb__license-results--active');
				this.filtration.filtPostcodeResultsList.innerHTML = '';
				this.filtration.filtPostcodeLoading.classList.add('d-none');

				let dataWater = e.target.closest('.sb-water-result').getAttribute('data-water');
				let dataPost = e.target.closest('.sb-water-result').getAttribute('data-postcode');

				this.filtration.filtAnswer.innerHTML = `<p class="pb-5 pt-5">For the area ${dataPost}, we recommend you choose <span class="text-bold">${dataWater == 'soft' ? 'DI' : 'RO/DI'} filtration</span></p>`

			} else if(!e.target.closest('#select-filtration-postcode') && this.filtration.filtPostcodeResults.classList.contains('sb__license-results--active')) {
				this.filtration.filtPostcodeLoading.classList.add('d-none');
				this.filtration.filtPostcodeResults.classList.remove('sb__license-results--active');
				this.filtration.filtPostcodeResultsList.innerHTML = '';
			}
		}.bind(this))
	}
}

const systemBuilder = {
	init: function() {
		const builderSection = document.getElementById('system-builder');
		const sb = new SystemBuilderLogic(builderSection);
		window['sb'] = sb;
		sb.init();
	}
};
const CheckoutBuilder = {
	init: function(section) {
		const checkoutInput = section.querySelector('#checkout-builder');
		const checkoutProducts = section.querySelector('#checkout-products');
		
		window['order'] = {
			products: {}
		}

		if(checkoutInput) {
			checkoutInput.addEventListener('input', async (e) => {
				let request = `https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=window-cleaning-warehouse-ltd.myshopify.com&q=${e.target.value}&product_limit=4&page_limit=2&collection_limit=2&suggestion_limit=3`;
				let result = await makeRequest('GET', request);
				result = JSON.parse(result);
				console.log(result, result.query == checkoutInput.value)

				if(result.query == checkoutInput.value) {
					CheckoutBuilder.buildProducts(result.products, checkoutProducts);
				}
			})
		}
	},

	buildProducts: function(products, checkoutProducts) {
		let productsStr = '';
		let vatStatus = Money.getVat();

		for (let i = 0; i < products.length; i++) {
			productsStr+=`
				<div class="mt-15">
				<div class="row">
					<div class="col-one-third">
						${Object.values(products[i].images)[0] ? `<img src="${Object.values(products[i].images)[0]}">` : ''}
					</div>
					<div class="col-two-thirds">
						<p class="font-grey">${products[i].vendor}</p>
						<p class="font-small-plus">${products[i].title}</p>
					</div>
				</div>
					<p class="font-bold">Options</p>
					${products[i].variants.map((v)=> `
						<div class="mt-5">
							<p onClick="CheckoutBuilder.addProduct({
								img: '${Object.values(products[i].images)[0] ? Object.values(products[i].images)[0] : ''}',
								id: '${v.id}',
								name: '${products[i].title.replace('"', '')}',
								variant: '${v.title == 'Default Title' ? 'Default' : v.title.replace('"', '')} (${v.sku})',
								amount: ${v.price},
								quantity: 1
							})" class="cb__option ${v.available ? '' : 'cb__option--disabled'}">
								${v.title == 'Default Title' ? 'Default' : v.title} (${v.sku}) - 
								<span data-amount="${v.price * 100}" data-vat-default="main" data-discount="0" data-vat-status="${vatStatus}" class="font-green price price-gbp">
									${Currency.formatMoney(parseInt(vatStatus == 'exc' ? v.price * 100 : (v.price * 100) * 1.2), Currency.money_format[Money.getCurrency()])}
								</span>
							</p>
						</div>
					`).join("\n")}
				</div>
			`;
		}

		checkoutProducts.innerHTML = productsStr
	},

	addProduct: function(product) {
		if(product.id in window['order'].products) {
			window['order'].products[product.id].quantity = window['order'].products[product.id].quantity + 1
		} else {
			window['order'].products[product.id] = product 
		}
		this.buildOrder();
	},

	buildOrder: function() {
		let vatStatus = Money.getVat();
		const checkoutOrder = document.querySelector('#checkout-order');
		const products = Object.values(window['order'].products);
		const checkoutProducts = document.querySelector('#checkout-submit');

		let productsStr = `
			${products.map((v)=> `
				<div>
					<div class="row">
						<div class="col-one-third">
							${v.img ? `<img src="${v.img}">` : ''}
						</div>
						<div class="col-two-thirds">
							<p>${v.name}</p>
							<p class="font-small-plus">${v.variant}</p>
							<p>
								<span data-amount="${v.amount * 100}" data-vat-default="main" data-discount="0" data-vat-status="${vatStatus}" class="font-green price price-gbp">
									${Currency.formatMoney(parseInt(vatStatus == 'exc' ? v.amount * 100 : (v.amount * 100) * 1.2), Currency.money_format[Money.getCurrency()])}
								</span>
							</p>
							<p>x ${v.quantity}<p>
						</div>
					</div>
				</div>
			`).join("\n")}
		`;

		checkoutOrder.innerHTML = productsStr;
		checkoutProducts.style.display = products.length > 0 ? 'block' : 'none';
	},

	sendOrder: function() {
		let ids = [];
		const countryCode = document.querySelector('#cs-country').value;
		const phoneNum = document.querySelector('#cs-phone').value;
		const name = document.querySelector('#checkout-name').value;
		
		for (let i = 0; i < Object.entries(window['order']['products']).length; i++) {
			const x = Object.values(window['order']['products'])[i];
			ids.push(`${x.id}:${x.quantity}`);
		}
		if(ids.length > 0 && phoneNum) {
			const url = `https://window-cleaning-warehouse-ltd.myshopify.com/cart/${ids.toString()}`;
			var xhr = new XMLHttpRequest();
			xhr.open("POST", "https://customer-api-9450.twil.io/send/order", true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.send(JSON.stringify({
				'Url': url,
				'Name': name,
				'To': '+' + countryCode.toString() + phoneNum.toString()
			}));
			xhr.onload = function() {
			  alert('Message sent')
			//   var data = JSON.parse(this.responseText);
			}
	
			xhr.onerror = function() {
			  alert('Error: Message Not Sent')
			//   var data = JSON.parse(this.responseText);
			}
		}
	}
};
const BlogHub = {
    init: function(section) {
        this.section = section;
        this.blogSelectors = this.section.querySelectorAll('[data-blog-selected]');
        this.searchSelectors = this.section.querySelectorAll('[data-search-selected]');
        this.articleContainer = this.section.querySelector('#blog-landing-articles');
        this.mainArticleContainer = this.section.querySelector('#blog-landing-top');
        this.searchInput = this.section.querySelector('#blog-search-input');

        this.searchEnabled = false;
        this.loading = false;
        this.queryString = window.location.search;
        this.urlParams = new URLSearchParams(this.queryString);
        this.page = this.urlParams.get('page') ? this.urlParams.get('page') : 1;
        this.blog = this.urlParams.get('blog') ? this.urlParams.get('blog') : this.section.querySelector('[data-blog-selected]').getAttribute('data-blog-selected');
        this.searchValue = this.urlParams.get('q') ? this.urlParams.get('q') : null;
        this.selectedBlog = this.section.querySelector('.blog-hub-selected').getAttribute('data-blog-selected');

        console.log(this.searchValue, 'this.searchInputValue')
        if(this.selectedBlog != this.blog && this.searchValue == null) {
            this.getSelectedBlog();
            return
        } else if(this.searchValue != null) {
            this.search(this.searchValue);
            this.searchInput.value = this.searchValue;
            return
        }
        this.initEventListeners();

    },

    debounce: (func, wait) => {
        // https://skilled.dev/course/debounce
        let timeout;
      
        return function executedFunction(...args) {
          const later = () => {
            clearTimeout(timeout);
            func(...args);
          };
      
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
    },
      

    search: async function(value, searchUrl=false) {
        // searchUrl: boolean to determine if the search string is a URL or search term
        if(!value) {
            console.log('none')
            this.searchValue = null;
            this.getSelectedBlog();
            return
        }

        this.loading = true;
        console.log(searchUrl ? value + "&sections=blog-landing-articles" : window.Shopify.routes.root + "search?" + "q=" + value + "&type=article&sections=blog-landing-articles")
        const res = await fetch(searchUrl ? value + "&sections=blog-landing-articles" : window.Shopify.routes.root + "search?" + "q=" + value + "&type=article&sections=blog-landing-articles")
        .then(res => res.json()).then(res => { return res })

        console.log(res)
        if(!searchUrl) {
            this.searchValue = value ? value : null;
        }
        this.renderBlogs(res['blog-landing-articles']);


        // let request = `/search/suggest.json?&q=${value}&resources[type]=article&[limit_scope]=each`;
        // let result = await makeRequest('GET', request);
        // let articles = JSON.parse(result)
        // this.createArticleCards(articles.resources.results.articles);
    },

    createArticleCards: function(articles) {
        if(!articles) {
            return
        }

        let topCard = '';
        if(articles.length > 0) {
            topCard = topCard + `
            <div class="blog-hub__top-card">
                <a href="${articles[0].url}">
                    <h2>${articles[0].title}</h2>
                    <div class="blog-hub__top-card-desc">
                        <p>${articles[0].summary_html.replace(/(<([^>]+)>)/gi, "").split(" ").splice(0, 20).join(" ")}...</p>
                    </div>
                    <div class="flex blog-hub__top-card-btn">
                    <p class="blog-hub__top-card-read">Read More</p>
                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.007 2c-5.518 0-9.998 4.48-9.998 9.998 0 5.517 4.48 9.997 9.998 9.997s9.998-4.48 9.998-9.997c0-5.518-4.48-9.998-9.998-9.998zm1.523 6.21s1.502 1.505 3.255 3.259c.147.147.22.339.22.531s-.073.383-.22.53c-1.753 1.754-3.254 3.258-3.254 3.258-.145.145-.335.217-.526.217-.192-.001-.384-.074-.531-.221-.292-.293-.294-.766-.003-1.057l1.977-1.977h-6.693c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.693l-1.978-1.979c-.29-.289-.287-.762.006-1.054.147-.147.339-.221.53-.222.19 0 .38.071.524.215z" fill-rule="nonzero"></path></svg>
                    </div>
                </a>
            </div>
            `
        }

        let cards = '<div class="blog-hub__articles">';
        if(articles.length > 1) {
            cards = cards + `
            ${articles.slice(1).map(article => {
                return `
                <div class="blog-hub__card">
                    <a href="${article.url}">
                        <h3>${article.title}</h3>
                        <div class="flex blog-hub__card-btn">
                        <p class="blog-hub__card-read">Read More</p>
                        <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.007 2c-5.518 0-9.998 4.48-9.998 9.998 0 5.517 4.48 9.997 9.998 9.997s9.998-4.48 9.998-9.997c0-5.518-4.48-9.998-9.998-9.998zm1.523 6.21s1.502 1.505 3.255 3.259c.147.147.22.339.22.531s-.073.383-.22.53c-1.753 1.754-3.254 3.258-3.254 3.258-.145.145-.335.217-.526.217-.192-.001-.384-.074-.531-.221-.292-.293-.294-.766-.003-1.057l1.977-1.977h-6.693c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.693l-1.978-1.979c-.29-.289-.287-.762.006-1.054.147-.147.339-.221.53-.222.19 0 .38.071.524.215z" fill-rule="nonzero"></path></svg>
                        </div>
                    </a>
                </div>
                `
            }).join('')}`
        }

        this.articleContainer.innerHTML = cards + '</div>';
        this.mainArticleContainer.innerHTML = topCard;

        this.loading = false;
    },

    setUrlParams: function() {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('blog', this.blog);
        urlParams.set('page', this.page);
        if(this.searchValue) {
            urlParams.set('q', this.searchValue);
        } else {
            urlParams.delete('q');
        }

        console.log(urlParams)

        window.history.pushState({}, null, window.location.href.split('?')[0] + '?' + urlParams.toString());
    },

    initEventListeners: async function(search=true) {
        this.blogSelectors = this.section.querySelectorAll('[data-blog-selected]');
        this.searchSelectors = this.section.querySelectorAll('[data-search-selected]');

        for (let i = 0; i < this.blogSelectors.length; i++) {
            const blogSelector = this.blogSelectors[i];
            this.blogSelectors[i].addEventListener('click', () => {
                const page = blogSelector.getAttribute('data-blog-page');
                const blog = blogSelector.getAttribute('data-blog-selected');
                if(page != this.page || blog != this.blog || this.searchInput.value != '') {
                    this.searchInput.value = '';
                    this.page = page;
                    this.blog = blog;
                    this.searchValue = null;
                    this.getSelectedBlog();
                }
            })
        }

        for (let i = 0; i < this.searchSelectors.length; i++) {
            const searchSelector = this.searchSelectors[i];
            this.searchSelectors[i].addEventListener('click', () => {
                const search = searchSelector.getAttribute('data-search-selected');
                console.log(search)
                this.search(search, true);
            })
        }

        if(search && !this.searchEnabled) {
            this.searchEnabled = true;
            const returnedFunction = this.debounce((e) => {
                this.search(e.target.value);
            }, 250);
    
            this.searchInput.addEventListener('keyup', returnedFunction);
        }
    },

    getSelectedBlog: async function() {
        if(!this.loading) {
            this.loading = true
            const res = await fetch(window.Shopify.routes.root + "blogs/" + this.blog + "?page=" + this.page + "&sections=blog-landing-articles")
            .then(res => res.json()).then(res => { return res })
    
            console.log(res, window.Shopify.routes.root + "blogs/" + this.blog + "?page=" + this.page + "&sections=blog-landing-articles")
            this.renderBlogs(res['blog-landing-articles']);
        }
    },

    renderBlogs: function(html, search=true) {
        const div = document.createElement('div');
        div.innerHTML = html;

        const articleContainer = div.querySelector('#blog-landing-articles');
        const mainArticleContainer = div.querySelector('#blog-landing-top');

        this.articleContainer.innerHTML = articleContainer.innerHTML;
        this.mainArticleContainer.innerHTML = mainArticleContainer.innerHTML;

        this.updateMenu();
        this.initEventListeners(search);
        this.setUrlParams();

        const y = this.section.getBoundingClientRect().top + window.pageYOffset + -250;
        window.scrollTo({top: y, behavior: 'smooth'});

        this.loading = false;
    },

    updateMenu: function() {
        for (let i = 0; i < this.blogSelectors.length; i++) {
            const blogSelector = this.blogSelectors[i];
            if(blogSelector.getAttribute('data-blog-selected') == this.blog && !this.searchValue) {
                blogSelector.classList.add('blog-hub__menu-item--selected');
            } else {
                blogSelector.classList.remove('blog-hub__menu-item--selected');
            }
        }

        console.log(this.searchValue, 'this.searchValue)')
        
        if(this.searchValue) {
            this.searchInput.classList.add('blog-hub__search--selected');
            return
        }

        this.searchInput.classList.remove('blog-hub__search--selected');
    }
};
const Finance = {
	init: function(section) {
		this.section = section;
		this.financeSelectedProducts = section.querySelector('#finance-selected-products');
		this.financeTotalProducts = section.querySelectorAll('[data-finance-type="products"]');
		this.financeTotalCart = section.querySelectorAll('[data-finance-type="cart"]');
		this.financeSelects = section.querySelectorAll('[data-finance-select]');
		this.financeLimit = section.querySelectorAll('.finance-limit, .finance-limit-show');
		this.cartValue = parseFloat(section.getAttribute('data-cart-total'));
		this.productFinanceForm = section.querySelector('#product-finance');
		this.financeCartDetails = section.querySelector('#finance-cart-details');

		this.year = {
			24: 0.0522,
			36: 0.0355,
			48: 0.0289,
			60: 0.0235
		}

		this.selectedMonths = 60
		this.workoutValues()
		this.initSearch(section);
		this.addProductClick(section);
		this.updateVariants(section);
		this.updateSelected();
		this.initForm();

	},

	initSearch: function(section) {
		let resElsParent = section.querySelectorAll('.custom-search');
		// let searchForms = document.querySelectorAll('.search');
		// let searchBtn = document.querySelector('.mobile-search-btn');
		const cartOverlay = document.querySelector('#cart-overlay')
		let closeTarget = section.querySelector('.click-hide-select');
		let clickTarget = section.querySelector('.search-show-custom');


		let _this = this;

		const searchInputs = section.querySelectorAll('.custom-search-input');
		for(var i=0; i < searchInputs.length; i++) {
		  ['input','focus','click'].forEach(function(evt) {
		      searchInputs[i].addEventListener(evt, function(e) {
				// Show search on mobile
				
				if(!clickTarget.classList.contains('click-show-custom--show') && this.value) {
					// _this.hideCart();
					window['drawer'].close();
					// _this.lockScreen(clickTarget.classList.contains('click-show--show'));
					clickTarget.classList.add('click-show-custom--show');
					closeTarget.classList.remove('d-none');

					fadeOut(cartOverlay);
				} else if(!this.value) { 
					clickTarget.classList.remove('click-show-custom--show');
					closeTarget.classList.add('d-none');
				}

		      	let resultsId = e.target.getAttribute('data-results-id');
		      	let resultsEl = section.querySelector(resultsId);

		      	if(this.value) {
		      		let request = `/search/suggest.json?&q=${this.value}&resources[options][fields]=title,product_type,variants.title,variants.barcode,variants.sku,variants.title,vendor&resources[limit_scope]=each`;
					_this.initSearchResults(request, resultsEl, this.value, false);

		      		for (var i = 0; i < resElsParent.length; i++) {
		      			if(resElsParent[i].id != resultsId) {
		      				resElsParent[i].classList.remove('row')
		      			}
		      		}
		      	} else {
		      		_this.initSearchResults(null, resultsEl, null, false);
		      	}
		      })
		  });
		}

		// searchBtn.addEventListener('click', function() {
		// 	const searchMobile = document.querySelector('.custom-boost-search-mobile');
		// 	if(searchMobile) {
		// 		const term = searchMobile.value;
		// 		if(term) {
		// 			window.location.href = Shopify.routes.root + `search?q=${term}`;
		// 		}
		// 	}
		// });

		closeTarget.addEventListener('click', function(e) {
			clickTarget.classList.remove('click-show-custom--show');
			closeTarget.classList.add('d-none');
		})

		// for (var i = 0; i < searchForms.length; i++) {
		// 	let searchForm = searchForms[i];
		// 	let searchIcon = searchForms[i].querySelector('svg');

		// 	searchForms[i].addEventListener('submit', function(e) {
		// 		e.preventDefault()
		// 		_this.submitSearchForm(e.target);
		// 	});

		// 	if(searchIcon) {
		// 		searchIcon.addEventListener('click', function() {
		// 			_this.submitSearchForm(searchForm);
		// 		});
		// 	}
		// }

	},

	initForm: function() {
		document.addEventListener('click', function(e) {
			if(e.target.classList.contains('finance-form-selector') || e.target.closest('.finance-form-selector')) {
				Finance.updateForm();
			}
		})
	},

	closeSearch: function() {
		let closeTarget = this.section.querySelector('.click-hide-select');
		let clickTarget = this.section.querySelector('.search-show-custom');
		clickTarget.classList.remove('click-show-custom--show');
		closeTarget.classList.add('d-none');
	},

	initSearchResults: async function(request, resEls, term, tradeStatus) {
		if(term) {
			let result = await makeRequest('GET', request);
			if(result) {
			  result = JSON.parse(result)['resources']['results'];
			  resEls.innerHTML = '';
			  try {
				if(result.products.length < 1 && result.pages.length < 1 && result.collections.length < 1 && result.suggestions.length < 1) {
					resEls.innerHTML = '<li class="boost-pfs-search-suggestion-group boost-custom__title text-extra-bold" aria-label="No Results">No results found</li>';
				  } else {
					let productRes = this.initProducts(result, term, tradeStatus);
					// let pagesRes = this.initLinks(result['pages'], 'Information');
					// let colRes = this.initLinks(result['collections'], 'Categories');
					// let colSuggestions = this.initSuggestions(result['queries'], false);
					// let colSuggestionsMobile = this.initSuggestions(result['queries'], true);
	
					// resEls.insertAdjacentHTML('beforeend', colSuggestionsMobile);
					resEls.insertAdjacentHTML('beforeend', productRes);
					// resEls.insertAdjacentHTML('beforeend', colSuggestions);
					// resEls.insertAdjacentHTML('beforeend', colRes);
					// resEls.insertAdjacentHTML('beforeend', pagesRes);
				  }
			  } catch(e) {
				resEls.innerHTML = '<li class="boost-pfs-search-suggestion-group boost-custom__title text-extra-bold" aria-label="No Results">No results found</li>';
			  }
			  resEls.classList.add('row');
			  Global.updateVat();
			}
		} else {
			resEls.classList.remove('row');
			Global.updateVat();
		}
	},


	initProducts: function(result, term, tradeStatus) {
		let products = `<li class="boost-custom__title col-one-whole" data-group="products-custom" aria-label="Products">
			  <ul aria-hidden="true" aria-expanded="false" class="p-0 m-0 flex flex-wrap__wrap row">
				<li class="boost-custom__title text-extra-bold width-whole mb-10" aria-label="Products">Products</li>`;
		if(result.products.length > 0) {
		  for(const [i, product] of result.products.entries()) {
		  //   let tradeDiscount = tradeStatus ? product.tags.filter(function(i) { if(i.includes(`Wholesale-Pricing-${tradeStatus}`)) { return i } }) : null
			let tradeDiscountAmount = 0
  
			let currency = Money.getCurrency();
			let vatStatus = Money.getVat();
  
			let discountAmount = 0;
			let price =  Currency.convert(discountAmount, 'GBP', currency);
			let vatPrice =  Currency.convert(discountAmount * 1.2, 'GBP', currency);
  
			// let price = Currency.formatMoney((product.price_min  tradeDiscountAmount * 100), Currency.money_format[currency]);
			// let vatPrice = currency != 'GBP' ? (product.price_min * tradeDiscountAmount * 100) : Currency.formatMoney((product.price_min * tradeDiscountAmount * 100) * 1.2, Currency.money_format[currency]);
			let bundleTag = product.tags.filter(function(i) { if(i.includes('infinite-adv')) { return i } });
  
			let bundle = product.tags.filter(function(i) { if(i.includes('infinite-adv-')) { return i } })
			let bundleAmount = bundle.length > 0 ? parseInt(bundle[0].replace('infinite-adv-', '')) : null
			
			products = products + `
				<li data-product-handle="${product.handle}" class="boost-custom__product add-finance-product col-one-whole pl-10-medium pl-0 ${i > 10 ? 'd-md-none' : ''}" aria-label="products: ${product.title}" data-id="${product.id}">
				  <div class="width-whole row">
					<div class="relative col-one-third">
							<div class="width-whole">
								<div class="image-wrapper-100">
									${product.featured_image ? `<img src="${product.featured_image.url}" alt="${product.title}">` : ``}
								</div>
							</div>
					  </div>
					  <div class="col-two-third pl-5">
					  <p class="text-standard font-semibold mb-5 font-small font-small-plus-large line-height">${product.title}</p>
					  ${tradeStatus && !(bundle.length > 0) ? '<p class="font-small font-green discount-text">Trade Price</p>' : ''}
  
					  <p 
						  data-amount="${product.price_min * 100}"
						  data-discount="${tradeDiscountAmount}"
						  data-vat-default="main"
						  class="line-height font-small-plus font-small-plus-large font-green price">${vatStatus == 'inc' ? vatPrice : price}</p> 
  
					  ${bundle.length > 0 && !tradeStatus ? `<p class="font-small font-green discount-text">+${bundleAmount}% Bundle Discount at Checkout </p>` : ''}
						  
						  <p 
							  data-amount="${product.price_min * 100}"
							  data-discount="${tradeDiscountAmount}"
							  data-vat-default="second"
							  class="font-small line-height font-light-grey money price">${vatStatus == 'inc' ? price : vatPrice}</p> 
					</div>
				  </div>
				</li>`
		  }
		}
		products = products + '</ul></li>';
		return products
	  },

	  addProductClick: function(section) {
		section.addEventListener('click', function(e) {
			if(e.target.classList.contains('add-finance-product') || e.target.closest('.add-finance-product')) {
				const product = e.target.closest('.add-finance-product') ? e.target.closest('.add-finance-product') : e.target;
				if(!product) { return }
				const productHandle = product.getAttribute('data-product-handle');

				if(productHandle) {
				makeRequest('GET', `/products/${productHandle}.js`).then(function(result) {
					result = JSON.parse(result);
					Finance.addProduct({
						id: result.id,
						name: result.title,
						img:  result.images.length ? result.images[0] : '',
						vendor: result.vendor,
						handle: result.handle,
						variants: result.variants.map(function(variant) {
							return {
								title: variant.public_title,
								price: variant.price,
								id: variant.id,
								available: variant.available,
								sku: variant.sku
							}
						}),
						selectedVariant: result.variants.find(function(variant) { return variant.available }).id || result.variants[0].id
					});
				}).catch(function(e) {
					console.log(e)
					alert('There was an error adding the product, please try again');
				});
				}
			}
		});

		section.addEventListener('click', function(e) {
			if(e.target.classList.contains('remove-finance-product') || e.target.closest('.remove-finance-product')) {
				const element = e.target.closest('.remove-finance-product') ? e.target.closest('.remove-finance-product') : e.target;
				// Get index of element
				const allRemoves = section.querySelectorAll('.remove-finance-product');
				const index = Array.from(allRemoves).indexOf(element);
				// Get current products
				const currentProducts = sessionStorage.getItem('finance-products-3');
				let products = [];
				if(currentProducts) {
					products = JSON.parse(currentProducts);
				}
				// Remove product
				products.splice(index, 1);
				// Set new products
				sessionStorage.setItem('finance-products-3', JSON.stringify(products));
				// Update selected
				Finance.updateSelected();
			}
		});

		this.financeSelects.forEach((select) => {
			select.addEventListener('change', (e) => {
				this.selectedMonths = parseInt(e.target.value);
				this.updateValues();
				this.updateSelected();
			})
		})
	},

	  addProduct: function(product) {
		const currentProducts = sessionStorage.getItem('finance-products-3');
		let products = [];
		if(currentProducts) {
		  products = JSON.parse(currentProducts);
		}

		products.unshift(product);
		sessionStorage.setItem('finance-products-3', JSON.stringify(products));
		this.closeSearch();
		this.updateSelected();
	  },

	  updateVariants: function(section) {
		section.addEventListener('change', function(e) {
			if(e.target.classList.contains('finance-variant-select')) {
				const productIndex = e.target.getAttribute('data-product-index');
				const currentProducts = sessionStorage.getItem('finance-products-3');
				let products = [];
				if(currentProducts) {
					products = JSON.parse(currentProducts);
				}
				products[productIndex].selectedVariant = e.target.value;
				sessionStorage.setItem('finance-products-3', JSON.stringify(products));
				Finance.updateSelected(products);
			}
		}
		)
	  },

	  workoutValues: function() {
		this.cartValues = {
			total: this.cartValue,
			months: this.selectedMonths,
			first: this.cartValue * this.year[this.selectedMonths],
			weekly: (this.cartValue * this.year[this.selectedMonths] * 12) / 52,
			monthly: this.cartValue * this.year[this.selectedMonths],
			totalFinance: (this.cartValue * this.year[this.selectedMonths]) * this.selectedMonths,
			tax: (((this.cartValue * this.year[this.selectedMonths]) * this.selectedMonths) / 100) * 20,
			net: (((this.cartValue * this.year[this.selectedMonths]) * this.selectedMonths) - ((((this.cartValue * this.year[this.selectedMonths]) * this.selectedMonths) / 100) * 20))
		}

		const currentProducts = sessionStorage.getItem('finance-products-3');
		let products = [];
		if(currentProducts) {
		  products = JSON.parse(currentProducts);
		}

		total = 0;
		products.map(function(product) {
			if(!product.selectedVariant) { return }
			const selected = product.variants.find(function(variant) { return variant.id == product.selectedVariant });
			if(selected) {
				total += selected.price;
			}
		})


		this.productValues = {
			total: total,
			months: this.selectedMonths,
			first: total * this.year[this.selectedMonths],
			weekly: (total * this.year[this.selectedMonths] * 12) / 52,
			monthly: total * this.year[this.selectedMonths],
			totalFinance: (total * this.year[this.selectedMonths]) * this.selectedMonths,
			tax: (((total * this.year[this.selectedMonths]) * this.selectedMonths) / 100) * 20,
			net: (((total * this.year[this.selectedMonths]) * this.selectedMonths) - ((((total * this.year[this.selectedMonths]) * this.selectedMonths) / 100) * 20))
		}
	  },
	

	  updateValues: function() {
		this.workoutValues();
		this.financeTotalProducts.forEach(function(el) {
			const totalElements = el.querySelectorAll('[data-finance-results]');
			totalElements.forEach(function(totalEl) {
				if(typeof this.productValues[totalEl.getAttribute('data-finance-results')] != 'undefined') {
					totalEl.innerHTML = this.productValues['total'] >= 100000 || totalEl.getAttribute('data-finance-results') == 'total' ? totalEl.getAttribute('data-finance-results') == 'months' ? this.productValues[totalEl.getAttribute('data-finance-results')] :  Currency.formatMoney(this.productValues[totalEl.getAttribute('data-finance-results')], Currency.money_format[Money.getCurrency()]) : '';
				}
			}.bind(this))
		}.bind(this))

		this.financeTotalCart.forEach(function(el) {
			const totalElements = el.querySelectorAll('[data-finance-results]')
			totalElements.forEach(function(totalEl) {
				if(this.cartValues[totalEl.getAttribute('data-finance-results')]) {
					totalEl.innerHTML = this.cartValues['total'] >= 100000 || totalEl.getAttribute('data-finance-results') == 'total' ? totalEl.getAttribute('data-finance-results') == 'months' ? this.cartValues[totalEl.getAttribute('data-finance-results')] :  Currency.formatMoney(this.cartValues[totalEl.getAttribute('data-finance-results')], Currency.money_format[Money.getCurrency()]) : '';
				}
			}.bind(this))
		}.bind(this))

		this.financeLimit.forEach((el, i) => {
			const compare = el.getAttribute('data-finance-show') == 'products' ? this.productValues['total'] : this.cartValues['total'];
			if(compare >= 100000) {
				if(el.classList.contains('finance-limit-show')) { el.classList.remove('d-none') } else { el.classList.add('d-none') }
			} else {
				if(el.classList.contains('finance-limit-show')) { el.classList.add('d-none') } else { el.classList.remove('d-none') }
			}
		});
	  },

	  updateForm: function(formType) {
		console.log()
		if(window['tab-system'] == '2' || !window['tab-system']) {
			const currentProducts = sessionStorage.getItem('finance-products-3') || '[]';
			const products = JSON.parse(currentProducts);

			this.productFinanceForm.querySelector('#product').value = products.map(function(product) { 
				const selected = product.variants.find(function(variant) { return variant.id == product.selectedVariant });
				return `${product.name} | ${selected ? selected.sku : ''}` 
			}).join(', ');

			this.productFinanceForm.querySelector('#price').value = (this.productValues['total'] / 100).toFixed(2)
			this.productFinanceForm.querySelector('#months').value = this.selectedMonths;
		} else {
			this.productFinanceForm.querySelector('#product').value = this.financeCartDetails.getAttribute('data-cart-products');
			this.productFinanceForm.querySelector('#price').value = this.financeCartDetails.getAttribute('data-finance-total');
			this.productFinanceForm.querySelector('#months').value = this.selectedMonths;
		}
	  },

	  updateSelected: function(updatedProducts=null) {
		const currentProducts = sessionStorage.getItem('finance-products-3');
		let products = updatedProducts ? updatedProducts : [];
		if(currentProducts && !updatedProducts) {
		  products = JSON.parse(currentProducts);
		}

		if(products.length < 1) {
		  this.financeSelectedProducts.innerHTML = `
			<div class="mt-15">
			  <p class="font-grey text-center">No products selected</p>
			</div>
		  `;

		  this.updateValues();

		  return;
		}

		let productsStr = '';
		for (let i = 0; i < products.length; i++) {
			const selected = products[i].variants.find(function(variant) { return variant.id == products[i].selectedVariant });
			const price = selected ? selected.price : 0;
			const priceFormatted = Currency.formatMoney(price, Currency.money_format[Money.getCurrency()]);
		  	productsStr+=`
			<div class="mt-15 mb-15 relative">
				<div class="row">
					<a target="_blank" href="${Shopify.routes.root + 'products/' + products[i].handle}" class="col-one-third">
						<img src="${products[i].img}">
					</a>
				<div class="col-two-third pl-5 pr-20">
					<p class="font-grey">${products[i].vendor}</p>
					<p class="font-small-plus">${products[i].name}</p>
					<p class="font-small-plus font-small font-green text-light mt-5 mb-5">${price > 0 ? priceFormatted : ''}</p>
					<label for="finance-variant-select-${i}" ${products[i].variants.length == 1 ? 'style="display: none;"' : ''} class="label-std ${products[i].variants.length == 1 ? 'd-none"' : ''}">Options</label> 
					<select id="finance-variant-select-${i}" ${products[i].variants.length == 1 ? 'style="display: none;"' : ''} class="finance-variant-select select-std" data-product-index="${i}">
							${products[i].variants.map(function(variant) {
								return `<option ${!variant.available ? 'disabled' : ''} value="${variant.id}" ${variant.id == products[i].selectedVariant ? 'selected' : ''}>${variant.title}</option>`
							}).join('')}
					</select>	
				</div>
				</div>
				<div class="remove-finance-product finance__remove text-center pt-5 pb-5">
					<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/></svg>
				</div>
			</div>
			`
		}

			this.financeSelectedProducts.innerHTML = productsStr

		// Update selected option
		const months = [24, 36, 48, 60];
		const selectedMonths = this.selectedMonths;
		this.financeSelects.forEach(function(select) {
			if(select.selectedIndex != months.indexOf(selectedMonths)) {
				select.selectedIndex = months.indexOf(selectedMonths);
			}
		})
		

		this.updateValues();
	  },
}
;
const Review = {
    init: function(section) {
        this.reviewEls = section.querySelectorAll('.simple-review-content');
        this.reviews = []
        this.reviewEls.forEach(review => {
            this.reviews.push(JSON.parse(review.innerHTML));
        });
        this.reviewOutput = section.querySelector('.sr-review-output');

        this.star = '<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.322 2.923c.126-.259.39-.423.678-.423.289 0 .552.164.678.423.974 1.998 2.65 5.44 2.65 5.44s3.811.524 6.022.829c.403.055.65.396.65.747 0 .19-.072.383-.231.536-1.61 1.538-4.382 4.191-4.382 4.191s.677 3.767 1.069 5.952c.083.462-.275.882-.742.882-.122 0-.244-.029-.355-.089-1.968-1.048-5.359-2.851-5.359-2.851s-3.391 1.803-5.359 2.851c-.111.06-.234.089-.356.089-.465 0-.825-.421-.741-.882.393-2.185 1.07-5.952 1.07-5.952s-2.773-2.653-4.382-4.191c-.16-.153-.232-.346-.232-.535 0-.352.249-.694.651-.748 2.211-.305 6.021-.829 6.021-.829s1.677-3.442 2.65-5.44z" fill-rule="nonzero"/></svg>';
        this.halfStar = '<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.322 2.923c.126-.259.39-.423.678-.423.289 0 .552.164.678.423.974 1.998 2.65 5.44 2.65 5.44s3.811.524 6.022.829c.403.055.65.396.65.747 0 .19-.072.383-.231.536-1.61 1.538-4.382 4.191-4.382 4.191s.677 3.767 1.069 5.952c.083.462-.275.882-.742.882-.122 0-.244-.029-.355-.089-1.968-1.048-5.359-2.851-5.359-2.851s-3.391 1.803-5.359 2.851c-.111.06-.234.089-.356.089-.465 0-.825-.421-.741-.882.393-2.185 1.07-5.952 1.07-5.952s-2.773-2.653-4.382-4.191c-.16-.153-.232-.346-.232-.535 0-.352.249-.694.651-.748 2.211-.305 6.021-.829 6.021-.829s1.677-3.442 2.65-5.44zm.678 2.033v11.904l4.707 2.505-.951-5.236 3.851-3.662-5.314-.756z" fill-rule="nonzero"/></svg>';
        this.emptyStar = '<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.322 2.923c.126-.259.39-.423.678-.423.289 0 .552.164.678.423.974 1.998 2.65 5.44 2.65 5.44s3.811.524 6.022.829c.403.055.65.396.65.747 0 .19-.072.383-.231.536-1.61 1.538-4.382 4.191-4.382 4.191s.677 3.767 1.069 5.952c.083.462-.275.882-.742.882-.122 0-.244-.029-.355-.089-1.968-1.048-5.359-2.851-5.359-2.851s-3.391 1.803-5.359 2.851c-.111.06-.234.089-.356.089-.465 0-.825-.421-.741-.882.393-2.185 1.07-5.952 1.07-5.952s-2.773-2.653-4.382-4.191c-.16-.153-.232-.346-.232-.535 0-.352.249-.694.651-.748 2.211-.305 6.021-.829 6.021-.829s1.677-3.442 2.65-5.44zm.678 2.033-2.361 4.792-5.246.719 3.848 3.643-.948 5.255 4.707-2.505 4.707 2.505-.951-5.236 3.851-3.662-5.314-.756z" fill-rule="nonzero"/></svg>';
        this.outputReviews();
        this.readMoreFunc(section);
    },

    outputReviews() {
        if(!this.reviewOutput.classList.contains('sr-review-output-disable')) {
            let output = '';
            for (let i = 0; i < this.reviews.length; i++) {
                output = output + this.outputReviewsHtml(this.reviews[i]);
            }

            this.reviewOutput.innerHTML = output;

        }
    },

    readMoreFunc(section) {
        this.readMore = section.querySelectorAll('.sr-block-read-more-btn');

        this.readMore.forEach(readMore => {
            readMore.addEventListener('click', (e) => {
                console.log('click')
                const container = e.target.closest('.sr-block-read-more');

                if(e.target.closest('.sr-block-read-more-limited')) {
                    e.target.closest('.sr-block-read-more-limited').classList.add('d-none');
                    container.querySelector('.sr-block-read-more-full').classList.remove('d-none');
                } else {
                    e.target.closest('.sr-block-read-more-full').classList.add('d-none');
                    container.querySelector('.sr-block-read-more-limited').classList.remove('d-none');
                }
            })
        })
    },

    outputReviewsHtml(review) {
        const reviewHtml = `
        	<div class="sr-block__review">
                <div class="pr-20 sr-block__star-container">
                    <div class="sr-block__stars">
                        ${Array(Math.floor(review.rating)).fill(this.star).join('')}
                        ${review.rating - Math.floor(review.rating) >= 0.5 ? this.halfStar : ''}
                        ${Array(5 - Math.ceil(review.rating)).fill(this.emptyStar).join('')}
                    </div>
                    <p class="sr-block__date">${new Date(review.date_added).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"})}</p>
                    <p class="sr-block__author">${review.author}</p>
                </div>
                <div>
                    <p class="sr-block__title">${review.title}</p>
                    <div class="sr-block-read-more">
                    <div class="sr-block__content sr-block-read-more-limited">
                        ${review.content.length > 200 ? review.content.substring(0, 200) + '...' : review.content}
                        ${review.content.length > 200 ? `<p class="sr-block-read-more-btn sr-block__read-more">Read More</p>` : ''}
                    </div>
                    ${review.content.length > 200 ? `
                    <div class="sr-block__content sr-block-read-more-full d-none">
                        ${review.content}
                        <p class="sr-block__read-more sr-block-read-more-btn sr-block-read-more-btn ">Read Less</p>
                    </div>    
                    ` : ''}
                    </div>
                </div>
            </div>
        `;
        return reviewHtml;
    }
}
;

document.addEventListener('DOMContentLoaded', function() {
	const sections = {
		'header': Header,
		'collection': Collection,
		'product': Product,
		'cart': Cart,
		'article': Article,
		'system-builder': systemBuilder,
		'checkout-builder': CheckoutBuilder,
		'blog-hub': BlogHub,
		'finance': Finance,
		'review': Review
	}

	Global.init();
	const jsSections = document.querySelectorAll('.js-section');

	for (var i = 0; i < jsSections.length; i++) {
		let sectionId = jsSections[i].getAttribute('data-section');
		sections[sectionId].init(jsSections[i])
	}
	document.addEventListener('click', function (e) {
		const title = e.target.closest('.footer-columns__title');
		if (!title) return;
	  
		const wrapper = title.nextElementSibling;
	  
		if (wrapper && wrapper.classList.contains('footer-menu-wrapper')) {
			title.classList.toggle('show');
		  	wrapper.classList.toggle('show');
		}
	});
});
function showTooltip(targetElement, message) {
    // Avoid duplicate tooltips if clicked rapidly
    let existingTooltip = targetElement.parentNode.querySelector('.qty-tooltip');
    if (existingTooltip) existingTooltip.remove();

    // Create tooltip container
    let tooltip = document.createElement('div');
    tooltip.className = 'qty-tooltip';
    tooltip.textContent = message;

    // Position container relative to parent
    targetElement.parentNode.style.position = 'relative';
    targetElement.parentNode.appendChild(tooltip);

    // Auto-remove after 2 seconds
    setTimeout(function() {
        tooltip.remove();
    }, 2000);
}
